<template>
  <div v-if="!isLoad">
    <!--加载中，后期可增加进度条等-->
  </div>
  <div id="main_page" class="main_page" v-else>
    <Layout class="layout home_style" >
      <Header>
        <HeaderBar :currentRoute="currRoutePath" :videoCount="videoCount" :message-count="noReadCount" :showAuto="register" :supportVideo="supportVideo" :userId="userId" :userAccount="userAccount" :serverTime="serverTime"></HeaderBar>
      </Header>
      <Content>
        <Layout>
          <!--不缓存页面-->
          <keep-alive :include="['station','monitor','alarm','broadcast','Conference','liveplayer','surveillance','surveillancePlayer','chat']">
            <router-view/>
          </keep-alive>
          <!--<router-view/>-->
        </Layout>
      </Content>
      <!--<Footer>
        <FooterBar :showAuto="register" :supportVideo="supportVideo" @callType="answerType" @autoAnswer="answer"></FooterBar>
      </Footer>-->
    </Layout>
    <!--报警弹屏-->
    <!--<Modal :title="$t('video')" v-model="showAlarm" :width="80%" scrollable footer-hide draggable :transfer="false" :styles="style" @on-visible-change="visibleChange">
      <alarm-video :cameras="cameras" :play="play"></alarm-video>
    </Modal>-->

    <!--自定义最大化最小化-->
    <!-- <Modal v-model="showAlarm"  :width="avwidth" :fullscreen="vfull"  :draggable="true" scrollable footer-hide id="video" transfer class-name="vertical-center-modal_video"  @on-visible-change="visibleChange">
      <div slot="header" @mousedown="moveStart">
        <label class="wordClass">{{$t('video')}}</label>
        <Icon type="md-remove" size="20" style="margin-right: 20px;float: right;cursor: pointer" class="wordClass" @click="minModal($event)" v-show="mid"></Icon>
        <Icon :type="fullModal" size="20" style="margin-right: 10px;float: right;cursor: pointer" class="wordClass" @click="maxModal($event)" v-show="mid"></Icon>
        <Icon type="md-albums" size="20" style="margin-right: 20px;float: right;cursor: pointer" id="mid" class="wordClass" @click="midModal($event)" v-show="!mid"></Icon>
      </div>
      <AlarmVideo :cameras="cameras" :play="play" :date="playFlash" :pheight="ph"></AlarmVideo>
    </Modal> -->
    <!--来电弹屏-->
    <Modal v-model="showCall" id="showCall" :mask="false" :title="$t('call_tip')" :z-index="9000" footer-hide class-name="vertical-center-modal" :closable="false">
      <img class="table-logo" style="width: 1rem;height: 1rem;position: absolute;" :src="sosGif" v-show="info.indexOf('_split_') > -1"/>
      <p style="text-align: center;font-size: 20px;" :style="info.indexOf('_split_') > -1 ? 'color: red':''" class="wordClass">{{info.split('_split_')[0]}}</p>
      <p style="text-align: center;font-size: 20px;" :style="info.indexOf('_split_') > -1 ? 'color: red':''" class="wordClass">{{infoTwo}}</p>
    </Modal>
    <!--来电软件化弹屏-->
    <Modal v-model="showSoft" :mask="true" :title="$t('call_tip')" transfer :z-index="10000" :mask-closable="fullClose" class-name="vertical-center-modal" :closable="false">
      <img class="table-logo" style="width: 1rem;height: 1rem;position: absolute;" :src="sosGif" v-show="softInfo.indexOf('_split_') > -1"/>
      <p style="text-align: center;font-size: 20px;" class="wordClass" :style="softInfo.indexOf('_split_') > -1 ? 'color: red':''">{{softInfo.split('_split_')[0]}}</p>
      <p style="text-align: center;font-size: 20px;" class="wordClass" :style="softInfo.indexOf('_split_') > -1 ? 'color: red':''">{{softInfoTwo}}</p>
      <div slot="footer">
        <Button type="primary" @click="callAnswer('auto')" v-show="callType!=='auto'">{{$t('answer_call')}}</Button>
        <Button type="primary" @click="callAnswer('audio')" v-show="callType==='auto'">{{$t('audio_accept')}}</Button>
        <Button type="primary" @click="callAnswer('video')" v-show="callType==='auto'">{{$t('video_accept')}}</Button>
        <Button type="warning" @click="callReject">{{$t('reject_call')}}</Button>
      </div>
    </Modal>
    <!--webRTC视频通话-->
    <Modal v-model="showWebVideo" id="videoModal" :styles="{bottom:'0px!important;',right:'0px!important;'}" :width="vModalWidth" :mask="false" :sticky="true"  :fullscreen="false" :closable="false" :draggable="true" scrollable footer-hide transfer>
      <div slot="header" @mousedown="moveStart">
        <label class="wordClass">{{$t('video_call')}}</label>
        <Icon type="md-remove" size="20" style="margin-right: 20px;float: right;cursor: pointer" class="wordClass" @click.capture.stop="v_minModal($event)" v-show="vmid"></Icon>
        <!--<Icon :type="fullModal" size="20" style="margin-right: 10px;float: right;cursor: pointer" color="white" @click="maxModal($event)" v-show="mid"></Icon>-->
        <Icon type="md-albums" size="20" style="margin-right: 20px;float: right;cursor: pointer" id="vmid" class="wordClass" @click.capture.stop="v_midModal($event)" v-show="!vmid"></Icon>
      </div>
      <div :id="webRtcVideoId" :style="remoteStyle">
        <div :style="remoteStyle">
          <video :id="remoteVideo" playsinline autoplay style="width:100%;height:100%;background: #a9a9ab"></video>
          <img :src="hangupImg" class="hangup" @click="hangup"/>
          <video :id="myVideoId" playsinline autoplay :style="myStyle" style="position: absolute;object-fit: fill;right: 16px;bottom: 16px;background: black"></video>
        </div>
      </div>
    </Modal>

    <!--回呼弹屏-->
    <Modal v-model="callNo" :title="$t('unanswer')" :z-index="9999" class-name="vertical-center-modal" @on-visible-change="changeCallNo">
      <p style="text-align: center;font-size: 20px;" class="wordClass">{{callInfo}}</p>
      <div slot="footer">
        <Button type="primary" @click="callNoAnswer">{{$t('call_btn')}}</Button>
        <Button type="warning" @click="callIgnoral">{{$t('ignore')}}</Button>
      </div>
    </Modal>

    <!--详细数据-->
    <SelfCheckResult :extens="extens" id="" :show="showSelfResult" @closeModal="closeResult"></SelfCheckResult>

    <!--系统备份等消息提示框-->
    <Modal v-model="showSystem" :mask-closable="false" :closable="false" footer-hide width="20%">
      <dv-loading>{{backMsg}}</dv-loading>
    </Modal>

    <!--确认密码框-->
    <Modal v-model="showPwd" :mask="false" :title="$t('system_tip')" transfer :z-index="10000" :mask-closable="fullClose" class-name="vertical-center-modal">
      <p style="text-align: center;font-size: 16px;" class="wordClass">{{$t('password_old_tip')}}</p>
      <div slot="footer">
        <Button type="primary" @click="changePwd()" >{{$t('modify_now')}}</Button>
        <Button type="primary" @click="showPwd = false" >{{$t('next_modification')}}</Button>
      </div>
    </Modal>
    <!--修改密码-->
    <Modal :title="$t('update_password')" :mask="false" v-model="showChangePwd" width="30%" scrollable :closable="false" transfer >
      <div>
        <Form :model="pwdForm" :label-width="100" ref="form1" >
<!--          <FormItem label="原始密码">-->
<!--            <Input v-model="pwdForm.oldPwd" type="password" auto-complete="new-password"></Input>-->
<!--          </FormItem>-->
          <FormItem :label="$t('new_pass')">
            <Input v-model="pwdForm.newPwd" type="password" auto-complete="new-password"></Input>
          </FormItem>
          <FormItem :label="$t('again_pass')">
            <Input v-model="pwdForm.newPwdTwice" type="password" auto-complete="new-password"></Input>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button type="primary" @click="submitPwd">{{$t('sure')}}</Button>
        <Button type="primary" @click="showChangePwd = false">{{$t('cancel')}}</Button>
      </div>
    </Modal>

    <!--视频会议邀请框-->
    <Modal v-model="showVcsInvite" :title="$t('meeting.invite.title')" :closable="false">
      <p class="wordClass">{{inviteInfo.content}}</p>
      <div slot="footer">
        <Button type="primary" @click="acceptVcs" >{{$t('meeting.invite.join')}}</Button>
        <Button type="primary" @click="rejectVcs" >{{$t('meeting.invite.reject')}}</Button>
      </div>
    </Modal>
    <!--来电软件化弹屏-->
    <Modal v-model="showSoftWebrtc" :mask="false" :title="$t('call_type')" transfer :z-index="10000" :mask-closable="fullClose"
           class-name="vertical-center-modal" :closable="false">
      <p style="text-align: center;font-size: 20px;" class="wordClass">{{softInfoTwo}}</p>
      <div slot="footer">
        <Button type="primary" @click="callAnswerWeb('auto')" v-show="callType!=='auto'">{{this.callType == "audio" ? $t('audio_call_out') : $t('video_call_out')}}</Button>
        <Button type="primary" @click="callAnswerWeb('audio')" v-show="callType==='auto'">{{$t('audio_call_out')}}</Button>
        <Button type="primary" @click="callAnswerWeb('video')" v-show="callType==='auto'">{{$t('video_call_out')}}</Button>
        <Button type="warning" @click="callRejectWeb">{{$t('cancel')}}</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
  import HeaderBar from './components/header-bar'
  import FooterBar from './components/footer-bar'
  import sosGif from '@/assets/sos_for_queue.gif'
  import {mapActions, mapMutations} from 'vuex'
  import {
    addQueueArr,
    changeExtenAlarm,
    changeExtenStatusForMap,
    changeExtenStatus,
    ConferencesDel,
    deviceQueueArr,
    deviceQueueArrNoExtens,
    updateQueue,
    generArea,
    generInfo,
    getStatusByExten,
    getStatusExten,
    localRead,
    localSave,
    produceExten,
    produceLoginExten,
    queryShowExtenInfo,
    setToken,
    getToken,
    setBase64Token
  } from '@/libs/util'
  import {findUserConfig} from '@/api/userSetting.js'

  import {deleteNoticeByUserAndType, detailAlarm,alarmAck} from '@/api/alarmjs.js'
  import {getSysDept, phoneInfo, updateNoAnswerIsRead} from '@/api/data.js'
  import {getGeneral, getQueueExtens,checkPwd,checkPwdValid} from '@/api/data'

  import MyWebrtc from '@/libs/webrtc'
  import {queryCameraAddress, queryRTMPByExten, queryRTMPByPhone,stopRTMP} from '@/api/camera'
  import {queryPrePlan, queryPrePlanByParams, queryVideo} from '@/api/actionPlan'
  import {getMapDefaultSet} from '@/api/map.js'

  import hangupImg from '@/assets/images/center/v_hangup.png'
  import {forEach, getDiff2, sortOrder, debounce} from '@/libs/tools'
  import SelfCheckResult from '../../view/self_check/selfCheck-result'
  import Room from '../../view/conference/room.js'
  import {baseImg} from '@/libs/base'
  import {getGradeSystemInfo} from '@/api/cascade.js'
  import {connectVCS} from '../../view/conference/conference-websocket.js'
  import log_ from '@/libs/operationLog.js'
  import {getDetailById,getChannelGroup} from '@/api/chatChannel.js'
  import {updatePassword} from "../../api/user";

  export default {
    name: 'Main',
    components: { //AlarmVideo,
      FooterBar, HeaderBar, SelfCheckResult
    },
    mixins: [baseImg],
    data() {
      return {
        isLoad: false,
        turnPage: false,
        noticeBottom: 0,
        myWebRtc: undefined,
        register: false,
        SIPControl: '',
        showModal: true,
        showAlarm: false,
        showCall: false,
        showSoft: false,
        showSoftWebrtc: false,
        fullClose: false,
        softInfo: '',
        info: '',
        infoExten: '',
        infoTwo: '',
        softInfoTwo: '',
        rejectExten: '',
        style: {top: '10px'},
        cameras: [],
        date: '',
        play: false,
        playFlash: new Date().getTime(),
        resend: null,
        reCount: 0,

        avwidth: 900,
        ph: 500,
        vfull: false,
        firstOpen: true,
        mid: true,
        openStation: {top: 0, left: 0},
        fullModal: 'md-expand',
        move: false,

        beforeUnload_time: null,
        gap_time: null,
        alarmId: '',

        hangupImg: hangupImg,
        showWebVideo: false,
        supportVideo: false,
        callType: 'auto',//呼出方式 1. auto 2. audio 3. video
        webRtcVideoId: 'videoLayer',
        myVideoId: 'myVideo',
        remoteVideo: 'remoteVideo',
        remoteStyle: {height: '500px', width: '700px'},
        myStyle: {height: '140px', width: '220px'},
        mediaTracks: null,
        vModalWidth: 732,
        vmid: true,

        /*未接来电*/
        callNo: false,
        callInfo: '',
        callNoExten: '',
        callNoId: '',
        /*分区列表*/
        deptList: null,
        queueExtens: null,
        queueCaller: null,
        queueCallee: null,
        videoExten: null,
        /*外线号码*/
        leftOut: null,
        rightOut: null,
        interval: null,
        noReadCount: 0,
        autoCloseDialog: false,
        autoRecover: false,
        alarmOpen: false,
        updateInterval: null,
        updateVolume: [],
        yuneasyWS: '',
        yuneasyStore: '',
        showSelfResult: false,
        showSystem: false,
        backMsg: '',
        extens: '',
        alarmOpenW: '',
        queuePhones: [],
        refreshCount: 0,
        timeOutLife: null,
        showVideoList: [],
        videoCount: 0,
        showPwd: false,
        showChangePwd: false,
        pwdForm: {},
        isLoading: false,
        showVcsInvite: false,
        inviteInfo: {content: '', userId: '', roomName: '', roomNum: ''},
        callNumber: '',
        isFromMonitor: '',
        resize: false,
        currRouteName: '',
        currRoutePath: '',
        chatList: [],
        closeForExt: '',
        colorTimer: null,
        serverTime: '',
        sosGif: sosGif,
        alarmControl: {left: false, right: false},
        //并发收到online和offline消息得定时器及开关。
        needFreshTime:null,
        needFreshFlag:false,

        messageQueue:[],
        isProcessing: false,
        batchUpdateTimer: null,
        highFrequencyTypes: new Set(['online', 'offline','ring','answer','handup','get_ext_status','broading']),
        immediateProcessTypes: new Set(['alarm','chatMessage']),
        debounceTimers: new Map(),
        deviceStatusBuffer: new Map(),
        BATCH_UPDATE_INTERVAL: 50,
        MAX_BATCH_SIZE: 100,

        debouncedShowCall: null,
        debouncedShowSoft: null,
        debouncedStatusUpdate: null,
        debouncedUIUpdate: null,
        uiDebounceTimer: null,
      }
    },
    methods: {
      ...mapMutations([
        'setWS',
        'setWS_MSG',
        'setDevices',
        'setGroups',
        'setNoStatusDevices',
        'setControl',
        'addQueueList',
        'addCallList',
        'setSysHeight',
        'setSysWidth',
        'setConfList',
        'setConferences',
        'updateConferences',
        'addCallConfList',
        'setMonitorUUID',
      ]),
      ...mapActions([
        'ws',
        'sendMsg',
        'cacheExtens',
        'closeWS',
        'LogoPath',
        'handleLogOut',
        'sendSelfMsg',
        'chatMessage',
        'reloadOneSession',
        'getParamByOpenId',
        'userConfig',
      ]),

      //优化方法
      /**
       * 初始化防抖函数
       */
      initDebouncedMethods() {
        this.debouncedShowCall = this.debounce((info, infoTwo, infoExten) => {
          this.info = info
          this.infoTwo = infoTwo
          this.infoExten = infoExten
          this.showCall = true
        }, 100)

        this.debouncedShowSoft = this.debounce((softInfo, softInfoTwo, rejectExten) => {
          this.softInfo = softInfo
          this.softInfoTwo = softInfoTwo
          this.rejectExten = rejectExten
          this.showSoft = true
        },100)

        this.debouncedStatusUpdate = this.debounce((updates)=>{
          this.executeDeviceStatusUpdate(updates)
        },this.BATCH_UPDATE_INTERVAL)

        this.debouncedUIUpdate = this.debounce((operations)=>{
          this.processUIOperations(operations)
        },16)
      },
      /**
       * 防抖函数
       * @param func
       * @param wait
       * @param immediate
       * @returns {(function(...[*]): void)|*}
       */
      debounce(func, wait,immediate = false) {
        return (...args)=>{
          const key = func.name || 'default'
          if (this.debounceTimers.has(key)) {
            clearTimeout(this.debounceTimers.get(key))
          }
          if (immediate && !this.debounceTimers.has(key)) {
            func.apply(this, args)
          }
          this.debounceTimers.set(key, setTimeout(() => {
            if (!immediate) {
              func.apply(this, args)
            }
            this.debounceTimers.delete(key)
          }, wait))
        }
      },
      async onHandle(data){
        this.messageQueue.push(data)
        if (!this.isProcessing) {
          setTimeout(() => this.processMessageQueue(), 0)
        }
      },
      /**
       * 处理消息队列
       * @returns {Promise<void>}
       */
      async processMessageQueue() {
        if(this.isProcessing || this.messageQueue.length === 0) {
          return
        }
        this.isProcessing = true
        try {
          await this.processBatch();
        } catch (error){
          console.error('Message processing error:', error)
        }finally {
          this.isProcessing = false;
          if (this.messageQueue.length > 0) {
            setTimeout(() => this.processMessageQueue(), 0)
          }
        }
      },
      /**
       * 批量处理消息
       * @returns {Promise<void>}
       */
      async processBatch() {
        const startTime = performance.now()
        const batchSize = Math.min(this.messageQueue.length, this.MAX_BATCH_SIZE)
        const batch = this.messageQueue.splice(0, batchSize)
        const stateUpdates = {
          deviceStatus:[],
          leftStatus:null,
          rightStatus:null,
        }
        const eventsToEmit = []
        const immediateOperations = []
        const uiOperations = []
        for (const data of batch) {
          try {
            const result = await this.processSingleMessage(data)
            if (result) {
              if (result.stateUpdates) {
                if (result.stateUpdates.deviceStatus) {
                  stateUpdates.deviceStatus.push(result.stateUpdates.deviceStatus)
                }
                if (result.stateUpdates.leftStatus) {
                  state.leftStatus = result.stateUpdates.leftStatus
                }
                if (result.stateUpdates.rightStatus) {
                  state.rightStatus = result.stateUpdates.rightStatus
                }
              }
              if (result.events) {
                eventsToEmit.push(...result.events)
              }
              if (result.immediateOperations) {
                immediateOperations.push(...result.immediateOperations)
              }
              if (result.uiOperations) {
                uiOperations.push(...result.uiOperations)
              }
            }
          }catch (error) {
            console.error('Proccess message error:', error)
          }
        }

        this.executeImmediateOperations(immediateOperations)

        this.applyBatchUpdates(stateUpdates,eventsToEmit,uiOperations)

        const endTime = performance.now()
        if (endTime - startTime > 16) {
          console.warn(`Batch processing took ${endTime - startTime}ms for ${batchSize} messages`)
        }
      },
      /**
       * 处理单条消息
       */
      async processSingleMessage(data) {
        const jsonData = JSON.parse(data)
        const { type, method: remethod } = jsonData

        // 高频消息快速处理
        if (this.highFrequencyTypes.has(remethod)) {
          return this.processHighFrequencyMessage(jsonData)
        }

        // 特殊消息立即处理
        if (remethod === 'alarm' || remethod === 'chatMessage') {
          return this.processImmediateMessage(jsonData)
        }

        // 其他消息使用原有逻辑
        return this.processNormalMessage(jsonData)
      },
      /**
       * 处理高频消息(优化版本)
       * @param jsonData
       */
      processHighFrequencyMessage(jsonData){
        const {method:remethod,ExtenInfo,displayNum} = jsonData
        const ext = ExtenInfo?ExtenInfo.split('@')[0]:''
        switch (remethod) {
          case 'online':
          case 'offline':
            return this.optimizedOnlineOfflineHandler(jsonData)
          case 'ring':
          case 'answer':
          case 'handup':
          case 'broading':
            return this.optimizedCallHandler(jsonData)
          case 'get_ext_status':
            return this.optimizedStatusHandler(jsonData)
          default:
            return this.processNormalMessage(jsonData)
        }
      },
      /**
       * 优化online/offline 处理
       * @param jsonData
       */
      optimizedOnlineOfflineHandler(jsonData){
        const {method: remethod, ExtenInfo} = jsonData
        const ext = ExtenInfo.split('@')[0]
        const isOnline = remethod === 'online'
        const status = isOnline ? 'Idle' : 'OffLine'
        const stateUpdates = {
          deviceStatus:{ext,status,registerIp:jsonData.NetWork},
        }
        const immediateOperations = []
        const isLeft = this.$store.state.user.SIPControl
        if ((isLeft == 1 && ext == this.$store.state.user.left) || (isLeft == 2 && ext == this.$store.state.user.right)) {
          immediateOperations.push({
            type: 'setIsOtherCall',
            data:'0'
          })
        }
        if (ext === this.$store.state.user.left) {
          stateUpdates.leftStatus = status
        }
        if (ext === this.$store.state.user.right) {
          stateUpdates.rightStatus = status
        }
        const events = [
          {
            type: 'extenStatusChange',
            data: {ext, status}
          },
          {
            type: 'OnlineOrOffLine',
            data: {ext, status: isOnline ? 'Online' : 'OffLine'}
          }
        ]
        if (!isOnline) {
          events.push({type:'offline',data:{ext}})
        }
        events.push({
          type:'conferenceStatusUpdate',
          data:{ext,status:isOnline?'online':'offline'}
        })
        const uiOperations = [{
          type: 'handleNeedFresh'
        }]

        uiOperations.push({
          type:'updateDeviceStatus',
          data:{
            ext,
            status,
            registerIp:jsonData.NetWork,
            isOnline
          }
        })

        if (1 == this.$store.state.user.enableRemind) {
          events.push({
            type:'showNotification',
            data:{
              title:this.$t('status'),
              desc: this.$t('ext') + ext + (isOnline ? this.$t('online') : this.$t('extOffline')),
              duration: parseInt(this.$store.state.user.remindCloseTime),
            }
          });
        }
        return {stateUpdates, events, uiOperations, immediateOperations};
      },
      /**
       * 优化通话相关消息处理
       * @param jsonData
       */
      optimizedCallHandler(jsonData){
        // 1. 提取参数和初始化变量
        const {method: remethod, ExtenInfo, displayNum, displayOut, confName, appKey, isSOS, extens, id, alert_type, NetWork} = jsonData
        const ext = ExtenInfo ? ExtenInfo.split('@')[0] : ''

        // 2. 根据方法确定状态
        let status = 'Idle'
        switch (remethod) {
          case 'ring': status = 'Ringing'; break
          case 'answer': status = 'Talking'; break
          case 'handup': status = 'Idle'; break
          case 'broading': status = 'Broading'; break
        }

        // 3. 初始化操作数组和状态更新对象
        const immediateOperations = []
        const stateUpdates = { deviceStatus: {ext, status} }
        const events = []
        const uiOperations = []

        // 4. 通用extractDevices状态更新 - 所有消息类型共享
        immediateOperations.push({
          type: 'updateExtractDevices',
          data: {ext, status}
        })

        // 5. 通用分机状态更新和排序 - 所有消息类型共享
        immediateOperations.push({
          type: 'updateDeviceStatus',
          data: {ext, status}
        })

        // 5. 通用SIP控制逻辑 - 非ring消息共享
        const isLeft = this.$store.state.user.SIPControl
        if (remethod != 'ring' && ((isLeft == 1 && (ext === this.$store.state.user.left || ext.split('@')[0] === this.$store.state.user.left)) ||
          (isLeft == 2 && (ext === this.$store.state.user.right || ext.split('@')[0] === this.$store.state.user.right)))) {
          stateUpdates.isOtherCall = '0' // 直接更新stateUpdates而不是通过immediateOperations
        }

        // 6. 通用分机状态变更事件 - 所有消息类型共享
        if (!appKey) {
          events.push({ type: 'extenStatusChange', data: {ext, status} })
        }

        // 7. 通用左右设备状态更新 - 所有消息类型共享
        if (ext === this.$store.state.user.left) {
          stateUpdates.leftStatus = status
        }
        if (ext === this.$store.state.user.right) {
          stateUpdates.rightStatus = status
        }

        // 8. 通用会议室更新事件 - 所有消息类型共享
        if (confName) {
          events.push({
            type: 'conferenceUpdate',
            data: {
              confName,
              displayNum,
              method: remethod
            }
          })

          // 临时会议室处理
          if (confName.indexOf('meeting') > -1 || confName.indexOf('-a-') > -1) {
            events.push({
              type: 'tempConferenceUpdate',
              data: {
                confName,
                displayNum,
                method: remethod
              }
            })
          }
        }

        if (remethod === 'ring') {
          //处理外线号码逻辑
          const outLineOperations = this.handleOutLineLogic(jsonData,ext,displayNum,displayOut,confName)
          uiOperations.push(...outLineOperations.uiOperations)
          immediateOperations.push(...outLineOperations.immediateOperations)

          const sipOperations = this.handleSIPLogic(jsonData,ext,displayNum,displayOut,outLineOperations.showExten,outLineOperations.callInfo)
          uiOperations.push(...sipOperations.uiOperations)
          immediateOperations.push(...sipOperations.immediateOperations)

          const videoOperations = this.handleVideoLogic(jsonData, ext, displayNum)
          uiOperations.push(...videoOperations.uiOperations)
          immediateOperations.push(...videoOperations.uiOperations)

          const accessOperations = this.handleAccessLogic(jsonData, ext, displayNum)
          immediateOperations.push(...accessOperations.immediateOperations)

          // 队列处理逻辑
          const queueOperations = this.handleQueueLogic(jsonData, ext, displayNum)
          immediateOperations.push(...queueOperations.immediateOperations)
          stateUpdates.queueData = queueOperations.queueData

          if (jsonData.isSOS == 1) {
            uiOperations.push({
              type:'changeColor',
              data: true
            })
          }

          const videoOperation = this.generateVideoOperations(jsonData, ext, displayNum)
          uiOperations.push(...videoOperation)

          // 通话信息显示逻辑
          if (displayNum === this.$store.state.user.left || displayNum === this.$store.state.user.right) {
            uiOperations.push({
              type: 'setInfo',
              data: {
                info: this.$t('callComing'),
                infoTwo: this.$store.state.user.left === displayNum ? this.$t('left') : this.$t('right')
              }
            })
          } else if (ext === this.$store.state.user.left || ext === this.$store.state.user.right) {
            // 处理群组名、联系人姓名等多语言展示
            let displayName = displayNum
            // 从缓存中查找联系人或群组信息
            if (this.$store.state.cacheData.userList) {
              const userInfo = this.$store.state.cacheData.userList.find(item => item.exten === displayNum)
              if (userInfo && userInfo.name) {
                displayName = userInfo.name
              }
            }
            uiOperations.push({
              type: 'setInfo',
              data: {
                info: displayName,
                infoTwo: ext === this.$store.state.user.left ? this.$t('left') : this.$t('right')
              }
            })
          }

          // 视频弹窗延迟处理
          if (ext === this.$store.state.user.right || ext === this.$store.state.user.left) {
            uiOperations.push({
              type: 'triggerVideoAlert',
              data: {
                displayNum,
                ext,
                alarmControl: ext === this.$store.state.user.right ? 'right' : 'left'
              }
            })
          }

          // 设备状态更新 - 触发分机重新排序
          // immediateOperations.push({
          //   type: 'updateDeviceStatus',
          //   data: {ext, status}
          // })
        }

        if (remethod === 'answer') {
          // 外线处理逻辑
          if (jsonData.ExtenInfo && jsonData.ExtenInfo.indexOf('@') < 0) {
            immediateOperations.push({
              type: 'addOutLine',
              data: {ext, status: 'Talking'}
            })

            // 权限外呼入呼出记录处理
            const _right = this.$store.state.user.right
            const _left = this.$store.state.user.left
            if (_right === displayNum || _left === displayNum) {
              immediateOperations.push({
                type: 'addNoAccessTalking',
                data: {ext, displayNum}
              })
            }
          }

          // 会议室刷新逻辑 - answer需要额外的reloadRoom
          if (confName) {
            immediateOperations.push({
              type: 'reloadRoom',
              data: confName
            })
          }

          // 队列处理 - 更新queueCallee
          if (this.queueCaller === displayNum) {
            stateUpdates.queueCallee = ext
          }

          // SIP相关处理
          if (this.register && ext === this.SIPControl) {
            let autoSpeak = this.$store.state.clickData.autoCall
            if (this.showModal && !autoSpeak) {
              if (!this.rejectExten || this.rejectExten !== displayNum) {
                stateUpdates.rejectExten = displayNum
              }
            }
          }

          // UI状态处理
          if (displayNum === ext) {
            if (this.queueCaller && displayNum !== this.queueCaller) {
              if (displayNum === this.infoExten) {
                stateUpdates.showCall = false
              }
              if (ext === this.SIPControl) {
                stateUpdates.showSoft = false
              }
            }
          } else {
            if (displayNum === this.infoExten) {
              stateUpdates.showCall = false
            }
            if (ext === this.SIPControl) {
              stateUpdates.showSoft = false
            }
          }

          // 设备状态更新已在通用区域处理

          // 通用操作 - 通话记录添加
          immediateOperations.push({
            type: 'addCallRecord',
            data: {jsonData, ext, displayNum}
          })

          // 通用操作 - 队列处理逻辑
          immediateOperations.push({
            type: 'handleQueueLogic',
            data: {jsonData, ext, queueExtens: this.queueExtens}
          })

          // 权限外呼入呼出记录添加
          /*if (this.$store.state.user.privilege.indexOf('callRecord') > -1) {

          }*/
          immediateOperations.push({
            type: 'addAccessCallRecord',
            data: {
              ext,
              displayNum,
              startTime: new Date().getTime()
            }
          })
        }

        if (remethod === 'broading') {
          // 会议室刷新逻辑 - broading特有处理
          if (confName) {
            immediateOperations.push({
              type: 'inFixReloadRoom',
              data: confName
            })
          }

          // 更新Vuex状态 - broading特有
          stateUpdates.broadCastList = jsonData.broadCastList || []

          // 通话记录添加 - 使用jsonData.displayNum作为displayNum
          immediateOperations.push({
            type: 'addCallRecord',
            data: {jsonData, ext, displayNum: jsonData.displayNum}
          })

          // 队列处理逻辑
          immediateOperations.push({
            type: 'handleQueueLogic',
            data: {jsonData, ext, queueExtens: this.queueExtens}
          })

          // UI状态处理 - broading特有
          if (jsonData.displayNum === this.infoExten) {
            stateUpdates.showCall = false
          }
          if (ext === this.SIPControl) {
            stateUpdates.showSoft = false
          }

          // 队列列表更新 - broading特有
          const queueData = this.$store.state.cacheData.queueData
          if (queueData && queueData[ext]) {
            stateUpdates.queueData = {
              ...queueData,
              [ext]: {
                ...queueData[ext],
                status: 'Broading'
              }
            }
          }
        }

        if (remethod == 'handup') {
          // 特有事件 - 挂断清理
          events.push({
            type: 'hangClear',
            data: {ext, displayNum}
          })

          // 视频弹窗处理
          if ((ext == this.videoExten || displayNum == this.videoExten)
            && (ext == this.$store.state.user.right || displayNum == this.$store.state.user.right ||
              ext == this.$store.state.user.left || displayNum == this.$store.state.user.left)) {
            uiOperations.push({
              type: 'closeVideoAlert',
              data: {ext, displayNum}
            })

            // alarmControl处理
            immediateOperations.push({
              type: 'updateAlarmControl',
              data: {
                ext,
                displayNum,
                userLeft: this.$store.state.user.left,
                userRight: this.$store.state.user.right
              }
            })
          }

          // 会议室成员移除逻辑 - handup特有
          if (confName) {
            const roomMember = this.$store.state.cacheData.roomMember
            if (roomMember && roomMember[confName]) {
              const newMember = roomMember[confName].filter(item => item.exten !== ext)
              stateUpdates.roomMember = {
                ...roomMember,
                [confName]: newMember
              }

              // 刷新当前会议室
              immediateOperations.push({
                type: 'reloadRoom',
                data: confName
              })
            }
          }

          // 缓存清理 - handup特有
          if (this.$store.state.cacheData.talkingCache && this.$store.state.cacheData.talkingCache[ext]) {
            delete this.$store.state.cacheData.talkingCache[ext]
          }

          // 队列处理逻辑 - handup特有
          immediateOperations.push({
            type: 'handleQueueHangup',
            data: {
              ext,
              displayNum,
              jsonData
            }
          })

          // 外线号码移除处理 - handup特有
          immediateOperations.push({
            type: 'removeOutlineDevice',
            data: {
              ext,
              displayNum
            }
          })

          // 无权限通话记录清理 - handup特有
          immediateOperations.push({
            type: 'cleanNoAccessTalking',
            data: {
              ext,
              displayNum
            }
          })

          // 设备状态更新已在通用区域处理
        }

        return {stateUpdates, events, uiOperations, immediateOperations};
      },
      /**
       * 生成视频联动操作
       * @param jsonData
       * @param ext
       * @param displayNum
       */
      generateVideoOperations(jsonData, ext, displayNum) {
        const operations = []
        const _left = this.$store.state.user.left
        const _right = this.$store.state.user.right

        // 视频联动逻辑
        if (ext !== displayNum) {
          if ((_right !== ext && _left !== ext) && (displayNum === _right || displayNum === _left)) {
            if (!(this.videoExten && this.videoExten === ext)) {
              operations.push({
                type: 'triggerVideo',
                data: {
                  exten: ext,
                  displayNum: displayNum,
                  alarmControl: displayNum === _right ? 'right' : 'left'
                }
              })
            }
          }

          if ((_right !== displayNum && _left !== displayNum) && (ext === _right || ext === _left)) {
            if (!(this.videoExten && this.videoExten === displayNum)) {
              operations.push({
                type: 'triggerVideo',
                data: {
                  exten: displayNum,
                  displayNum: ext,
                  alarmControl: ext === _right ? 'right' : 'left'
                }
              })
            }
          }
        }

        return operations
      },
      /**
       * 处理外线号码逻辑
       * @param jsonData
       * @param ext
       * @param displayNum
       * @param displayOut
       * @param confName
       */
      handleOutLineLogic(jsonData, ext, displayNum, displayOut, confName) {
        const uiOperations = []
        const immediateOperations = []

        let outExten = displayNum
        let showExten = ''
        let callInfo = ''

        if (confName) {
          outExten = ext
          displayOut = false
        }
        showExten = this.$store.state.cacheData.devices ? this.$store.state.cacheData.devices[outExten] : null

        if (showExten) {
          let outExt = queryShowExtenInfo(this.$store.state.cacheData.extractDevices,outExten)
          if (outExt) {
            showExten = ''
          }
        }

        if (displayOut && outExten != this.$store.state.user.displayNum) {
          let outExt = queryShowExtenInfo(this.$store.state.cacheData.extractDevices,outExten)
          if (!outExt) {
            // 生成外线数据
            let name = this.$t('outLine')
            let groupName = jsonData.groupName
            let realName = jsonData.name
            callInfo = {
              exten: outExten,
              status: 'Ringing',
              out: '2',
              deptid: '-1',
              deptname: groupName ? groupName : name,
              cameraflag: '0',
              employeename: realName || outExten,
              employeeid: '',
              position: '',
              order: '-5'
            }

            immediateOperations.push({
              type:'addOutLineDevice',
              data: callInfo
            })
          }
        }
        if (ext == this.$store.state.user.right) {
          uiOperations.push({
            type:'setRightOut',
            data: displayNum
          })
        }else if (ext == this.$store.state.user.left) {
          uiOperations.push({
            type: 'setLeftOut',
            data: displayNum
          })
        }

        return {
          uiOperations,
          immediateOperations,
          showExten,
          callInfo
        }
      },
      /**
       * 处理SIP话机逻辑
       * @param jsonData
       * @param ext
       * @param displayNum
       */
      handleSIPLogic(jsonData, ext, displayNum, displayOut, showExten, callInfo) {
        const uiOperations = []
        const immediateOperations = []
        const _left = this.$store.state.user.left
        const _right = this.$store.state.user.right
        const call = this.$store.state.clickData.call
        if (this.register) {
          if ((this.SIPControl !== displayNum && ext === this.SIPControl)
            || (this.SIPControl === displayNum && ext === this.SIPControl)) {
            immediateOperations.push({
              type: 'customerRing',
              data: jsonData.isSOS == 1
            })

            if (showExten) {
              uiOperations.push({
                type: 'setRejectExten',
                data: showExten.exten,
              });
            } else {
              if (callInfo && callInfo.hasOwnProperty('exten')) {
                uiOperations.push({
                  type: 'setRejectExten',
                  data: callInfo.exten
                })
              }
            }

            let autoSpeak = this.$store.state.clickData.autoCall
            if (this.showModal && !autoSpeak) {
              if ((this.$store.state.user.SIPControl == 1 && ext == this.$store.state.user.left && 0 == this.$store.state.cacheData.isOtherCall)
              || (this.$store.state.user.SIPControl == 2 && ext == this.$store.state.user.right && 0 == this.$store.state.cacheData.isOtherCall)) {
                let softInfo = this.$t('left_mobile') + ' : ' + this.$t('ring') + ' , ' + (call ? this.$t('caller_pre') : this.$t('calling_per')) + ' : ' + displayNum
                let softInfoTwo = ''
                if (showExten) {
                  softInfoTwo = this.$t('device_station') + ' : ' + showExten.deptname + ' , ' + this.$t('device_name') + ' : ' + showExten.employeename
                } else {
                  if (callInfo) {
                    softInfoTwo = this.$t('linkman_groupname') + ' : ' + callInfo.deptname + ' , ' + this.$t('linkman_name') + ' : ' + callInfo.employeename
                  } else {
                    if (displayOut && jsonData.groupName) {
                      softInfoTwo = this.$t('linkman_groupname') + ' : ' + jsonData.groupName + ' , ' + this.$t('linkman_name') + ' : ' + jsonData.name
                    } else {
                      softInfoTwo = this.$t('linkman_groupname') + ' : ' + this.$t('UnKnow') + ' , ' + this.$t('linkman_name') + ' : ' + this.$t('UnKnow')
                    }
                  }
                }

                if (jsonData.isSOS == 1) {
                  softInfo = softInfo + '_split_'
                }
                uiOperations.push({
                  type: 'showSoft',
                  data: {
                    softInfo,
                    softInfoTwo,
                    rejectExten: showExten ? showExten.exten : (callInfo ? callInfo.exten : ''),
                  }
                })
              }
            } else {
              immediateOperations.push({
                type: 'setAutoCall',
                data: false
              })

              if (this.$store.state.user.SIPControl == 1) {
                immediateOperations.push({
                  type:'setAutoCall',
                  data: this.callType,
                })
              }
            }
          }else if ((ext === _left || ext === _right) && ext !== this.SIPControl && (displayNum !== _left && displayNum !== _right)) {
            // 非SIP控制的话机来电
            if (!call) {
              let info = ''
              if (ext === _left) {
                info = this.$t('left_mobile') + ' : ' + this.$t('ring') + ' , ' + (call ? this.$t('caller_pre') : this.$t('calling_pre')) + ' : ' + displayNum
              }
              if (ext === _right) {
                info = this.$t('right_mobile') + ' : ' + this.$t('ring') + ' , ' + (call ? this.$store.state.user.caller_pre : this.$t('calling_pre')) + ' : ' + displayNum
              }

              let infoTwo = ''
              if (showExten) {
                infoTwo = this.$t('device_station') + ' : ' + showExten.deptname + ' , ' + this.$t('device_name') + ' : ' + showExten.employeename
              } else {
                if (callInfo) {
                  infoTwo = this.$t('linkman_groupname') + ' : ' + callInfo.deptname + ' , ' + this.$t('linkman_name') + ' : ' + callInfo.employeename
                } else {
                  if (displayOut && jsonData.groupName) {
                    infoTwo = this.$t('linkman_groupname') + ' : ' + jsonData.groupName + ' , ' + this.$t('linkman_name') + ' : ' + jsonData.name
                  } else {
                    infoTwo = this.$t('linkman_groupname') + ' : ' + this.$t('UnKnow') + ' , ' + this.$t('linkman_name') + ' : ' + this.$t('UnKnow')
                  }
                }
              }

              if (jsonData.isSOS === '1') {
                info = info + '_split_'
              }

              uiOperations.push({
                type: 'showCall',
                data: {
                  info,
                  infoTwo,
                  infoExten: displayNum
                }
              })
            }
          }
        } else {
          // 无SIP话机
          if ((ext === _left || ext === _right) && (displayNum !== _left && displayNum !== _right)) {
            let info = ''
            if (ext === _left) {
              info = this.$t('left_mobile') + ' : ' + this.$t('ring') + ' , ' + (call ? this.$t('caller_pre') : this.$t('calling_pre')) + ' : ' + displayNum
            }
            if (ext === _right) {
              info = this.$t('right_mobile') + ' : ' + this.$t('ring') + ' , ' + (call ? this.$t('caller_pre') : this.$t('calling_pre')) + ' : ' + displayNum
            }

            let infoTwo = ''
            if (showExten) {
              infoTwo = this.$t('device_station') + ' : ' + showExten.deptname + ' , ' + this.$t('device_name') + ' : ' + showExten.employeename
            } else {
              if (callInfo) {
                infoTwo = this.$t('linkman_groupname') + ' : ' + callInfo.deptname + ' , ' + this.$t('linkman_name') + ' : ' + callInfo.employeename
              } else {
                if (displayOut && jsonData.groupName) {
                  infoTwo = this.$t('linkman_groupname') + ' : ' + jsonData.groupName + ' , ' + this.$t('linkman_name') + ' : ' + jsonData.name
                } else {
                  infoTwo = this.$t('linkman_groupname') + ' : ' + this.$t('UnKnow') + ' , ' + this.$t('linkman_name') + ' : ' + this.$t('UnKnow')
                }
              }
            }

            if (jsonData.isSOS === '1') {
              info = info + '_split_'
            }

            uiOperations.push({
              type: 'showCall',
              data: {
                info,
                infoTwo,
                infoExten: displayNum
              }
            })
          }
        }

        // 处理呼叫状态
        if (call) {
          if (_right !== ext && _left !== ext) {
            immediateOperations.push({
              type: 'setCall',
              data: false
            })
          }
        }

        return { uiOperations, immediateOperations }

      },
      /**
       * 处理视频联动逻辑
       */
      handleVideoLogic(jsonData, ext, displayNum) {
        const uiOperations = []
        const _left = this.$store.state.user.left
        const _right = this.$store.state.user.right

        if (ext !== displayNum) {
          // 被叫是左右话机
          if ((_right !== ext && _left !== ext) && (displayNum === _right || displayNum === _left)) {
            if (!(this.videoExten && this.videoExten === ext)) {
              uiOperations.push({
                type: 'triggerVideo',
                data: {
                  exten: ext,
                  displayNum: displayNum,
                  alarmControl: displayNum === _right ? 'right' : 'left'
                }
              })
            }
          }

          // 主叫是左右话机
          if ((_right !== displayNum && _left !== displayNum) && (ext === _right || ext === _left)) {
            if (!(this.videoExten && this.videoExten === displayNum)) {
              uiOperations.push({
                type: 'triggerVideo',
                data: {
                  exten: displayNum,
                  displayNum: ext,
                  alarmControl: ext === _right ? 'right' : 'left'
                }
              })
            }
          }
        }

        return { uiOperations }
      },
      /**
       * 处理权限外逻辑
       */
      handleAccessLogic(jsonData, ext, displayNum) {
        const immediateOperations = []
        const _left = this.$store.state.user.left
        const _right = this.$store.state.user.right

        let noAccessExten = ''

        // 处理权限外的呼入呼出
        if (_right === ext || _left === ext) {
          if (displayNum.length <= 7) {
            noAccessExten = displayNum
          }
        }
        if (_right === displayNum || _left === displayNum) {
          if (ext.length <= 7) {
            noAccessExten = ext
          }
        }

        if (noAccessExten) {
          let rE = this.$store.state.cacheData.roleExten[noAccessExten]
          if (!rE) {
            let aE = this.$store.state.cacheData.devices[noAccessExten]
            if (aE) {
              if (this.$store.state.cacheData.noAccessTalkingExten.indexOf(aE) < 0) {
                immediateOperations.push({
                  type: 'addNoAccessTalking',
                  data: aE
                })
              }
            }
          }
        }

        return { immediateOperations }
      },

      /**
       * 处理队列逻辑
       * @param jsonData
       * @param ext
       * @param displayNum
       */
      handleQueueLogic(jsonData, ext, displayNum) {
        const immediateOperations = []
        const queueData = this.$store.state.cacheData.queueData || {}
        let updatedQueueData = { ...queueData }

        if (jsonData.method === 'ring' && jsonData.queueInfo) {
          const { queueName, queueNum, callerId, queueCallId } = jsonData.queueInfo
          // 更新队列数据
          updatedQueueData[ext] = {
            ...queueData[ext],
            status: 'Ringing',
            queueName,
            queueNum,
            callerId,
            queueCallId,
            startTime: new Date().getTime()
          }

          // 触发队列状态更新事件
          immediateOperations.push({
            type: 'updateQueueStatus',
            data: {
              ext,
              status: 'Ringing',
              queueInfo: jsonData.queueInfo
            }
          })
        }

        return {
          immediateOperations,
          queueData: updatedQueueData
        }
      },
      /**
       * 优化状态处理
       * @param jsonData
       */
      optimizedStatusHandler(jsonData){
        const devices = this.$store.state.cacheData.devices
        if (!devices) return null
        const stateUpdates = {}
        if (jsonData.extens && jsonData.extens.exten) {
          produceExten(devices,jsonData.extens.exten)
          produceExten(this.$store.state.cacheData.roleExten,jsonData.extens.exten)
          const leftStatus = getStatusExten(devices,this.$store.state.user.left)
          const rightStatus = getStatusExten(devices,this.$store.state.user.right)

          if (leftStatus) {
            stateUpdates.leftStatus = leftStatus
          }
          if (rightStatus) {
            stateUpdates.rightStatus = rightStatus
          }
        }
        return {stateUpdates}
      },
      /**
       * 处理需要立即执行的消息
       */
      processImmediateMessage(jsonData) {
        const { method: remethod } = jsonData

        if (remethod === 'alarm') {
          return {
            immediateOperations: [
              { type: 'alarm', data: jsonData }
            ]
          }
        }

        if (remethod === 'chatMessage') {
          return {
            immediateOperations: [
              { type: 'chatMessage', data: jsonData }
            ]
          }
        }

        return {}
      },
      /**
       * 正常消息处理
       * @param jsonData
       * @returns {Promise<{stateUpdates: {}, events: *[], uiOperations: *[]}>}
       */
      async processNormalMessage(jsonData){
        // 对于非高频消息，使用原有的onHandle逻辑
        try {
          await this.originalOnHandle(JSON.stringify(jsonData))
        } catch (error) {
          console.error('Process normal message error:', error)
        }
        return {}
      },
      /**
       * 执行立即操作
       */
      executeImmediateOperations(operations) {
        if (!operations || operations.length === 0) return

        operations.forEach(operation => {
          switch(operation.type) {
            case 'alarm':
              this.handleAlarmMessage(operation.data)
              break
            case 'chatMessage':
              this.chatMessage(operation.data)
              break
            case 'setIsOtherCall':
              this.$store.commit('setIsOtherCall',operation.data)
              break
            case 'addOutLineDevice':
              this.addOutLineDevice(operation.data)
              break
            case 'customerRing':
              this.myWebRtc.customerRing(operation.data)
              break
            case 'setAutoCall':
              this.handleAutoAnswer(operation.data)
              break
            case 'setCall':
              this.$store.commit('setCall',operation.data)
              break
            case 'addNoAccessTalking':
              this.addNoAccessTalking(operation.data)
              break
            case 'updateAlarmControl':
              this.updateAlarmControl(operation.data)
              break
            case 'handleQueueHangup':
              this.handleQueueHangup(operation.data)
              break
            case 'removeOutlineDevice':
              this.removeOutlineDevice(operation.data)
              break
            case 'cleanNoAccessTalking':
              this.cleanNoAccessTalking(operation.data)
              break
            case 'reloadRoom':
              this.reloadRoom(operation.data)
              break
            case 'inFixReloadRoom':
              this.inFixReloadRoom(operation.data)
              break
            case 'updateDeviceStatus':
              this.updateDeviceStatus(operation.data)
              break
            case 'addAccessCallRecord':
              this.addAccessCallRecord(operation.data)
              break
            case 'updateQueueStatus':
              this.updateQueueStatus(operation.data)
              break
            case 'setInfo':
              this.setInfo(operation.data)
              break
            case 'triggerVideoAlert':
              this.triggerVideoAlert(operation.data)
              break
            case 'updateExtractDevices':
              this.updateExtractDevices(operation.data)
              break
            case 'addCallRecord':
              this.addCallRecord(operation.data)
              break
            case 'handleQueueLogic':
              this.handleQueueLogic(operation.data)
              break
          }
        })
      },
      /**
       * 批量应用更新
       * @param stateUpdates
       * @param events
       * @param uiOperations
       */
      applyBatchUpdates(stateUpdates, events, uiOperations){
        if (stateUpdates.deviceStatus && stateUpdates.deviceStatus.length > 0) {
          this.batchUpdateDeviceStatus(stateUpdates.deviceStatus)
        }
        if (stateUpdates.leftStatus) {
          this.$store.commit('setLeftStatus', stateUpdates.leftStatus)
        }
        if (stateUpdates.rightStatus) {
          this.$store.commit('setRightStatus', stateUpdates.rightStatus)
        }
        this.batchEmitEvents(events)

        if (uiOperations && uiOperations.length > 0) {
          this.debouncedUIUpdate(uiOperations)
        }
      },
      /**
       * 批量更新设备状态
       * @param updates
       */
      batchUpdateDeviceStatus(updates){
        if (!updates || updates.length === 0) return
        updates.forEach(update => {
          this.deviceStatusBuffer.set(update.ext,update)
        })
        this.debouncedStatusUpdate(Array.from(this.deviceStatusBuffer.values()))
      },
      executeDeviceStatusUpdate(updates){
        if (!updates || updates.length === 0) return
        const devices = {...this.$store.state.cacheData.devices}
        const roleExten = {...this.$store.state.cacheData.roleExten}
        let hasUpdate = false
        updates.forEach(({ext,status,registerIp}) => {
          if (devices[ext]) {
            devices[ext].status = status
            if (registerIp) {
              devices[ext].registerIp = registerIp
            }
            hasUpdate = true
          }
          if (roleExten[ext]) {
            roleExten[ext].status = status
            if (registerIp) {
              devices[ext].registerIp = registerIp
            }
            hasUpdate = true
          }
        })

        if (hasUpdate) {
          this.$store.commit('setDevices',devices)
          this.$store.commit('setRoleExten',roleExten)
        }
        this.deviceStatusBuffer.clear()
      },
      /**
       * 批量触发事件
       * @param events
       */
      batchEmitEvents(events){
        if (!events || events.length === 0) return
        // 直接触发事件，不进行分组
        events.forEach(event => {
          switch(event.type) {
            case 'extenStatusChange':
              this.$root.bus.$emit('extenStatusChange', event.data.ext, event.data.status)
              break
            case 'OnlineOrOffLine':
              this.$root.bus.$emit('OnlineOrOffLine', event.data.ext, event.data.status)
              //this.$store.commit('setControlLeft', Math.random() + '')
              this.handleNeedFresh()
              break
            case 'offline':
              this.$root.bus.$emit('offline', event.data.ext)
              break
            case 'leftStatusChange':
              this.$store.commit('setLeftStatus', event.data)
              break
            case 'rightStatusChange':
              this.$store.commit('setRightStatus', event.data)
              break
            case 'conferenceUpdate':
              this.handleConferenceUpdate(event.data)
              break
            case 'tempConferenceUpdate':
              this.handleTempConferenceUpdate(event.data)
              break
            case 'hangClear':
              this.$root.bus.$emit('hangClear', event.data.displayNum || event.data.ext)
              break
            case 'conferenceStatusUpdate':
              this.handleConferenceStatusUpdate(event.data)
              break
            case 'showNotification':
              this.$Notice.warning({
                title: event.data.title,
                desc: event.data.desc,
                duration: event.data.duration,
              })
              break
            default:
              this.$root.bus.$emit(event.type, event.data)
          }
        })
      },
      /**
       * 处理会议室更新
       * @param data
       */
      handleConferenceUpdate(data) {
        const { confName, ext, appKey, method, displayNum } = data

        this.$store.dispatch('getRoom', confName).then(res => {
          if (res) {
            if (method === 'ring') {
              res.inFixReloadRoom(ext, appKey, 500)
            } else if (method === 'answer' || method === 'broading') {
              res.inFixReloadRoom(ext, appKey, 500)
            } else if (method === 'handup') {
              res.inFixReloadRoom(ext, appKey, 1000)
            }

            if (this.$store.state.conferencejs.currRoom === res.name) {
              res.reloadRoom(1000)
            }
          }
        })
      },
      /**
       * 处理临时会议室更新
       * @param data
       */
      handleTempConferenceUpdate(data) {
        const { confName, displayNum, method } = data

        if (method === 'ring') {
          this.$store.dispatch('getRoom', confName).then(res => {
            if (!res) {
              let room = new Room(confName, confName, displayNum, '', '', '', confName.indexOf('-v-') > -1, false, '-1', true);
              this.$store.commit('addRoom', room)
              this.$root.bus.$emit('meetingChange', confName)
              //需要增加視頻會議的處理
            }
            let tempRoom = this.$store.state.conferencejs.tempRoom
            if (tempRoom && tempRoom == confName) {
              this.$root.bus.$emit('selectRoom', confName)
            }
          })
        }
      },
      /**
       * 处理会议室状态更新
       * @param data
       */
      handleConferenceStatusUpdate(data) {
        const { ext, status } = data

        this.$store.dispatch('getRoom', this.$store.state.conferencejs.currRoom).then(res => {
          if (res) {
            res.inFixReloadRoom(ext, null)
          }
        })
      },
      /**
       * 处理UI操作
       * @param operations
       */
      processUIOperations(operations){
        if (!operations || operations.length === 0) return
        operations.forEach(operation => {
          switch (operation.type) {
            case 'showCall':
              this.debouncedShowCall(operation.info,operation.infoTwo,operation.infoExten)
              break
            case 'showSoft':
              this.debouncedShowSoft(operation.softInfo,operation.softInfoTwo,operation.rejectExten)
              break
            case 'showAlarm':
              this.alarmModal(operation.exten)
              break
            case 'changeColor':
              this.changeColor(operation.data)
              break
            case 'triggerVideo':
              this.triggerVideoAlert(operation.data)
              break
            case 'closeVideoAlert':
              this.closeVideoAlert(operation.data)
              break
            case 'handleNeedFresh':
              this.handleNeedFresh()
              break
            case 'updateDeviceStatus':
              this.updateDeviceStatus(operation.data)
              break
            case 'setRightOut':
              this.rightOut = operation.data
              break
            case 'setLeftOut':
              this.leftOut = operation.data
              break
            case 'setRejectExten':
              this.rejectExten = operation.data
              break
          }
        })
      },
      /**
       * 触发视频弹窗
       * @param data
       */
      triggerVideoAlert(data) {
        const { exten, displayNum, alarmControl } = data

        this.videoExten = exten
        this.showVideoList.push(exten)

        if (alarmControl === 'right') {
          this.alarmControl.right = true
        } else if (alarmControl === 'left') {
          this.alarmControl.left = true
        }

        if (!this.timeOutLife) {
          this.timeOutLife = setTimeout(async () => {
            let newList = JSON.parse(JSON.stringify(this.showVideoList))
            this.showVideoList = []
            this.timeOutLife = null
            if (newList.length > 0) {
              await this.getVideoPop(newList[0], '1', '1', this.$store.state.user.userName, displayNum)
            }
          }, 1000)
        }
      },
      /**
       * 关闭视频弹窗
       * @param data
       */
      closeVideoAlert(data) {
        const { ext, displayNum } = data

        if (ext === this.$store.state.user.right || displayNum === this.$store.state.user.right) {
          this.alarmControl.right = false
        }
        if (ext === this.$store.state.user.left || displayNum === this.$store.state.user.left) {
          this.alarmControl.left = false
        }
        if (!this.alarmControl.left && !this.alarmControl.right) {
          this.visibleChange(false)
          if (this.autoCloseDialog) {
            this.videoExten = null
            this.showAlarm = false
          }
        }
      },

      /**
       * 更新extractDevices状态
       */
      updateExtractDevices(data) {
        const { ext, status } = data
        let extractDevices = changeExtenStatus(this.$store.state.cacheData.extractDevices, ext, status)
        if (extractDevices) {
          this.$store.commit('setExtractDevices', extractDevices)
        }
      },

      /**
       * 添加通话记录
       */
      addCallRecord(data) {
        const { jsonData, ext, displayNum } = data
        const info = generInfo(jsonData)
        if (info) {
          this.addCallList(info)
        }
      },

      /**
       * 更新alarmControl状态
       */
      updateAlarmControl(data) {
        const { ext, displayNum, userLeft, userRight } = data
        // 处理右侧设备
        if (ext == userRight || displayNum == userRight) {
          this.alarmControl.right = false
        }
        // 处理左侧设备
        if (ext == userLeft || displayNum == userLeft) {
          this.alarmControl.left = false
        }
        // 如果两侧都没有告警，关闭弹窗
        if (!this.alarmControl.left && !this.alarmControl.right) {
          this.visibleChange(false)
          if (this.autoCloseDialog) {
            this.videoExten = null
            this.showAlarm = false
          }
        }
      },

      /**
       * 处理队列挂断逻辑
       */
      handleQueueHangup(data) {
        const { ext, displayNum, jsonData } = data
        // 处理队列信息
        let queueCallInfo = this.$store.state.cacheData.queueCallInfo
        if (queueCallInfo) {
          if (ext === queueCallInfo.exten || displayNum === queueCallInfo.exten) {
            if (jsonData.uuid !== queueCallInfo.uuid) {
              this.$store.commit('setQueueCallInfo', null)
              let deviceArr3 = deviceQueueArrNoExtens(this.$store.state.cacheData.queueList, jsonData)
              this.$store.commit('setQueueList', deviceArr3)
            }
          }
        }
      },

      /**
       * 移除外线设备
       */
      removeOutlineDevice(data) {
        const { ext, displayNum } = data
        let extract = this.$store.state.cacheData.extractDevices
        if (extract && extract.length > 0) {
          extract = extract.filter(item => {
            return item.exten !== ext && item.exten !== displayNum && item.name !== ext && item.name !== displayNum
          })
          this.$store.commit('setExtractDevices', extract)
        }
      },

      /**
       * 清理无权限通话记录
       */
      cleanNoAccessTalking(data) {
        const { ext, displayNum } = data
        let noAccess = this.$store.state.cacheData.noAccessTalkingExten
        if (noAccess && noAccess.length > 0) {
          let kIndex = -1
          for (let i = 0; i < noAccess.length; i++) {
            let ne = noAccess[i]
            if (ne.exten == ext || ne.exten == displayNum) {
              kIndex = i
              break
            }
          }
          if (kIndex > -1) {
            noAccess.splice(kIndex, 1)
          }
        }
      },

      /**
       * 添加访问通话记录
       */
      addAccessCallRecord(data) {
        const { ext, displayNum, startTime } = data
        // 生成通话记录信息
        const info = generInfo({ ExtenInfo: ext, displayNum, method: 'answer', startTime })
        if (info) {
          this.addCallList(info)
        }
      },

      /**
       * 更新队列状态
       */
      updateQueueStatus(data) {
        const { ext, status, queueInfo } = data
        let ques1 = this.$store.state.cacheData.queueList
        let beforeArr = [].concat(ques1)
        // 更新队列数据
        let deviceArr = deviceQueueArr(ques1, this.queueExtens, { ExtenInfo: ext, displayNum: queueInfo.callerId })
        let diffInfo = getDiff2(beforeArr, deviceArr)
        if (diffInfo && diffInfo.length > 0) {
          diffInfo[0].uuid = queueInfo.queueCallId
          this.$store.commit('setQueueCallInfo', diffInfo[0])
        }
        this.$store.commit('setQueueList', deviceArr)
      },

      /**
       * 设置通话信息显示
       */
      setInfo(data) {
        const { info, infoTwo } = data
        this.info = info
        this.infoTwo = infoTwo
      },

      /**
       * 重载会议室
       */
      reloadRoom(confName) {
        this.$store.dispatch('getRoom', confName).then(res => {
          if (res) {
            res.reloadRoom(1000)
          }
        })
      },

      /**
       * 修复重载会议室
       */
      inFixReloadRoom(confName) {
        this.$store.dispatch('getRoom', confName).then(res => {
          if (res) {
            res.inFixReloadRoom(confName, null, 500)
          }
        })
      },

      /**
       * 处理报警消息
       * @param jsonData
       * @returns {Promise<void>}
       */
      async handleAlarmMessage(jsonData) {
        await this.originalOnHandle(JSON.stringify(jsonData))
      },
      /**
       * 处理needFreshFlag逻辑
       */
      handleNeedFresh() {
        if(!this.needFreshFlag){
          this.needFreshFlag = true;
          this.needFreshTime = null;
          clearTimeout(this.needFreshTime)
          this.needFreshTime = setTimeout(() => {
            this.needFreshFlag = false;
            this.$store.commit('setControlLeft', Math.random() + '')
          }, 1000)
        }
      },
      /**
       * 更新设备状态
       * @param data
       */
      updateDeviceStatus(data) {
        const { ext, status, registerIp, isOnline } = data

        // 更新设备状态
        let extens = changeExtenStatusForMap(this.$store.state.cacheData.devices, ext, status, registerIp)
        changeExtenStatusForMap(this.$store.state.cacheData.roleExten, ext, status, registerIp)
        this.cacheExtens(extens)
      },
      /**
       * 添加外线设备
       * @param callInfo
       */
      addOutLineDevice(callInfo) {
        let arr = this.$store.state.cacheData.extractDevices
        let pushFlag = true
        if (Array.isArray(arr) && arr.length > 0) {
          forEach(arr,item=>{
            if (item.exten == callInfo.exten) {
              pushFlag = false
            }
          })
        }
        if (pushFlag) {
          arr.push(callInfo)
          this.$store.commit('setExtractDevices', arr)
          let devices = this.$store.state.cacheData.devices
          devices[callInfo.exten] = callInfo
          this.$store.commit('setDevices', devices)
        }
      },
      /**
       * 处理自动接听
       * @param callType
       */
      handleAutoAnswer(callType) {
        try {
          this.myWebRtc.VoiceAnswer(callType == 'video');
        } catch (e){
          console.error('webrtc answer error:', e);
          let method = 'handup'
          let ext = this.$store.state.user.left
          if (ext) {
            this.sendMsg({method, ext})
          }
          this.registerSIP()
        }
      },
      /**
       * 添加无权限通话设置
       * @param aE
       */
      addNoAccessTalking(aE) {
        if (this.$store.state.cacheData.noAccessTalkingExten.indexOf(aE) < 0) {
          this.$store.state.cacheData.noAccessTalkingExten.push(aE)
        }
      },
      /**
       * 原有处理逻辑
       * @param data
       * @returns {Promise<void>}
       */
      async originalOnHandle(data) {
        this.$store.commit('addHeart', 0)
        let jsonData = JSON.parse(data)
        let type = jsonData.type
        let remethod = jsonData.method
        let ext = ''
        let status = ''
        let info = ''
        let display = ''
        let displayOut = null
        let _right = this.$store.state.user.right
        let _left = this.$store.state.user.left
        let confName = ''
        let method = ''
        let extens = []
        let that = this
        if (type === 'event') {//事件
          switch (remethod) {
            case 'get_ext_status':
              let devices = this.$store.state.cacheData.devices
              if (!devices) {
                break
              }
              produceExten(this.$store.state.cacheData.devices, jsonData.extens.exten)
              produceExten(this.$store.state.cacheData.roleExten, jsonData.extens.exten)
              let leftStatus = getStatusExten(devices, this.$store.state.user.left)
              let rightStatus = getStatusExten(devices, this.$store.state.user.right)
              if (leftStatus) {
                this.$store.commit('setLeftStatus', leftStatus.status)
              }
              if (rightStatus) {
                this.$store.commit('setRightStatus', rightStatus.status)
              }
              break
            case 'ring':
              ext = jsonData.ExtenInfo.split('@')[0]
              display = jsonData.displayNum
              displayOut = jsonData.displayOut
              //呼出
              let showExten = ''
              let callInfo = ''
              let outExten = display
              confName = jsonData.confName
              let appKey = jsonData.appKey
              let call = this.$store.state.clickData.call
              if (!appKey) {
                //通知地图改变终端状态
                this.$root.bus.emitAsync('extenStatusChange', ext, 'Ringing')
              }
              if (jsonData.isSOS === '1') {
                this.changeColor(true)
              }
              //根据振铃里的消息往会议室添加成员
              if (confName) {
                if (confName.indexOf('meeting') > -1) {
                  //临时会议室,查询是否存在
                  this.$store.dispatch('getRoom', confName).then(res => {
                    if (!res) {
                      let room = new Room(confName, confName, display, '', '', '', confName.indexOf('-v-') > -1, false, '-1', true)
                      this.$store.commit('addRoom', room)
                      this.$root.bus.emitAsync('meetingChange', confName)
                    }
                    let tempRoom = this.$store.state.conferencejs.tempRoom
                    if (tempRoom && tempRoom == confName) {
                      this.$root.bus.emitAsync('selectRoom', confName)
                    }
                  })
                }

                let currRoom = this.$store.state.conferencejs.currRoom
                this.$store.dispatch('getRoom', currRoom).then(res => {
                  if (res) {
                    if (confName === res.no) {
                      //刷新当前会议室
                      //this.$root.bus.$emit('reloadConference',res.name)
                      res.reloadRoom(500);
                      return
                    }
                    res.inFixReloadRoom(ext, appKey, 500)
                  }
                })
              } else {
                if (this.currRouteName == 'conference' && this.$store.state.conferencejs.currRoom) {
                  this.$store.dispatch('getRoom', this.$store.state.conferencejs.currRoom).then(res => {
                    if (res) {
                      res.inFixReloadRoom(ext, appKey, 500)
                    }
                  })
                }
              }
              //判断当前是否是会议室页面

              if (ext === this.$store.state.user.left) {
                if (this.register) {
                  let _lstatus = this.$store.state.cacheData.leftStatus
                  if (_lstatus === 'Idle') {
                    this.$store.commit('setLeftStatus', 'Ringing')
                  } else {
                    break
                  }
                } else {
                  this.$store.commit('setLeftStatus', 'Ringing')
                }
              } else if (ext === this.$store.state.user.right) {
                this.$store.commit('setRightStatus', 'Ringing')
              }
              if (this.refreshCount > 0) {
                if (ext !== this.$store.state.user.left
                  && ext !== this.$store.state.user.right
                  && display !== this.$store.state.user.left
                  && display !== this.$store.state.user.right) {
                  break
                }
              }
              let qStatus1 = 'Ringing'
              let qStatus2 = 'Ringing'
              let qArr = this.$store.state.cacheData.queueList
              if (qArr.length > 0) {
                let qe = qArr.filter(item => item.exten === ext)
                if (qe.length > 0) {
                  qStatus1 = 'Talking'
                  updateQueue(qArr, ext, display)
                }
                let qe2 = qArr.filter(item => item.exten === display)
                if (qe2.length > 0) {
                  qStatus2 = 'Talking'
                  updateQueue(qArr, display, ext)
                }
              }
              extens = changeExtenStatusForMap(this.$store.state.cacheData.devices, ext, qStatus1)
              changeExtenStatusForMap(this.$store.state.cacheData.roleExten, ext, 'Ringing')
              this.$store.commit('setDevices', extens)

              if (confName) {
                outExten = ext
                displayOut = false
              }
              /*if (displayOut) {
              await this.addOutLine(outExten, qStatus2)
            }*/
              showExten = this.$store.state.cacheData.devices ? this.$store.state.cacheData.devices[outExten] : null;

              if (showExten) {
                let outExt = queryShowExtenInfo(this.$store.state.cacheData.extractDevices,outExten)
                if(outExt){
                  showExten = ''
                }
              }

              if (displayOut && outExten != this.$store.state.user.displayNum) {
                let outExt = queryShowExtenInfo(this.$store.state.cacheData.extractDevices, outExten)
                if (!outExt) {
                  //存在
                  //生成外线数据
                  let name = this.$t('outLine')
                  let groupName = jsonData.groupName
                  let realName = jsonData.name
                  callInfo = {
                    exten: outExten,
                    status: qStatus2,
                    out: '2',
                    deptid: '-1',
                    deptname: groupName ? groupName : name,
                    cameraflag: '0',
                    employeename: realName || outExten,
                    employeeid: '',
                    position: '',
                    order: '-5'
                  }
                  let arr = this.$store.state.cacheData.extractDevices
                  let pushFlag = true
                  if (Array.isArray(arr) && arr.length > 0) {
                    forEach(arr, item => {
                      if (item.exten === callInfo.exten) {
                        pushFlag = false
                      }
                    })
                  }
                  if (pushFlag) {
                    arr.push(callInfo)
                    this.$store.commit('setExtractDevices', arr)
                    let devices = this.$store.state.cacheData.devices
                    devices[callInfo.exten] =callInfo
                    this.$store.commit('setDevices', devices)
                  }
                }
              }
              if (ext === _right) {
                this.rightOut = display
              } else if (ext === _left) {
                this.leftOut = display
              }
              //查询呼叫信息

              if (this.register) {
                //SIP话机在线
                if ((this.SIPControl !== display && ext === this.SIPControl) || (this.SIPControl === display && ext === this.SIPControl)) {
                  this.myWebRtc.customerRing(jsonData.isSOS==1)
                  //弹出SIP接听弹窗
                  //查询是否对讲
                  let autoSpeak = this.$store.state.clickData.autoCall
                  if (showExten) {
                    this.rejectExten = showExten.exten
                  } else {
                    if (callInfo.hasOwnProperty('exten')) {
                      this.rejectExten = callInfo.exten
                    }
                  }
                  if (this.showModal && !autoSpeak) {
                    //如果是左话机注册，直呼主叫不弹屏。。被叫弹屏。
                    if (((this.$store.state.user.SIPControl === '1' && ext === this.$store.state.user.left)
                      || (this.$store.state.user.SIPControl === '2' && ext === this.$store.state.user.right))
                      && '0' === this.$store.state.cacheData.isOtherCall) {
                      this.showSoft = true

                      this.softInfo = this.$t('left_mobile') + ' : ' + this.$t('ring') + ' , ' + (call ? this.$t('caller_pre') : this.$t('calling_pre')) + ':' + display
                      if (showExten) {
                        this.softInfoTwo = this.$t('device_station') + ' : ' + showExten.deptname + ' , ' + this.$t('device_name') + ' : ' + showExten.employeename
                      } else {
                        if (callInfo) {
                          this.softInfoTwo = this.$t('linkman_groupname') + ' : ' + callInfo.deptname + ' , ' + this.$t('linkman_name') + ' : ' + callInfo.employeename
                        } else {
                          if (displayOut && jsonData.groupName) {
                            this.softInfoTwo = this.$t('linkman_groupname') + ' : ' + jsonData.groupName + ' , ' + this.$t('linkman_name') + ' : ' + jsonData.name
                          } else {
                            this.softInfoTwo = this.$t('linkman_groupname') + ' : ' + this.$t('UnKnow') + ' , ' + this.$t('linkman_name') + ' : ' + this.$t('UnKnow')
                          }
                        }
                      }
                    }
                    if (jsonData.isSOS === '1') {
                      this.softInfo = this.softInfo + '_split_'
                    }
                  } else {
                    this.$store.commit('setAutoCall', false)
                    if (this.$store.state.user.SIPControl === '1' || this.$store.state.user.SIPControl === '2' ) {
                      try {
                        if (this.callType === 'audio') {
                          this.myWebRtc.VoiceAnswer(false)
                        } else if (this.callType === 'video') {
                          this.myWebRtc.VoiceAnswer(true)
                        } else {
                          this.myWebRtc.VoiceAnswer(false)
                        }
                      } catch (e) {
                        console.log(e)
                        //补偿挂断
                        method = 'handup'
                        let ext = this.$store.state.user.left
                        if (ext) {
                          this.sendMsg({method, ext})
                        }
                        this.registerSIP()
                      }
                    }
                  }
                } else if ((ext === _left || ext === _right) && ext !== this.SIPControl && (display !== _left && display !== _right)) {
                  if (!call) {
                    this.showCall = true
                    if (ext === _left) {
                      this.info = this.$t('left_mobile') + ' : ' + this.$t('ring') + ' , ' + (call ? this.$t('caller_pre') : this.$t('calling_pre')) + ' : ' + display
                    }
                    if (ext === _right) {
                      this.info = this.$t('right_mobile') + ' : ' + this.$t('ring') + ' , ' + (call ? this.$t('caller_pre') : this.$t('calling_pre')) + ' : ' + display
                    }
                    if (showExten) {
                      this.infoTwo = this.$t('device_station') + ' : ' + showExten.deptname + ' , ' + this.$t('device_name') + ' : ' + showExten.employeename
                      this.infoExten = display
                    } else {
                      if (callInfo) {
                        this.infoTwo = this.$t('linkman_groupname') + ' : ' + callInfo.deptname + ' , ' + this.$t('linkman_name') + ' : ' + callInfo.employeename
                      } else {
                        if (displayOut && jsonData.groupName) {
                          this.infoTwo = this.$t('linkman_groupname') + ' : ' + jsonData.groupName + ' , ' + this.$t('linkman_name') + ' : ' + jsonData.name
                        } else {
                          this.infoTwo = this.$t('linkman_groupname') + ' : ' + this.$t('UnKnow') + ' , ' + this.$t('linkman_name') + ' : ' + this.$t('UnKnow')
                        }
                      }
                      this.infoExten = display
                    }
                    if (jsonData.isSOS === '1') {
                      this.info = this.info + '_split_'
                    }
                  }
                }
              } else {
                //无SIP话机
                if ((ext === _left || ext === _right) && (display !== _left && display !== _right)) {
                  //是左右话机来电
                  //生成来电信息
                  this.showCall = true
                  if (ext === _left) {
                    this.info = this.$t('left_mobile') + ' : ' + this.$t('ring') + ' , ' + (call ? this.$t('caller_pre') : this.$t('calling_pre')) + ' : ' + display
                  }
                  if (ext === _right) {
                    this.info = this.$t('right_mobile') + ' : ' + this.$t('ring') + ' , ' + (call ? this.$t('caller_pre') : this.$t('calling_pre')) + ' : ' + display
                  }
                  if (showExten) {
                    this.infoTwo = this.$t('device_station') + ' : ' + showExten.deptname + ' , ' + this.$t('device_name') + ' : ' + showExten.employeename
                    this.infoExten = display
                  } else {
                    if (callInfo) {
                      this.infoTwo = this.$t('linkman_groupname') + ' : ' + callInfo.deptname + ' , ' + this.$t('linkman_name') + ' : ' + callInfo.employeename
                    } else {
                      if (displayOut && jsonData.groupName) {
                        this.infoTwo = this.$t('linkman_groupname') + ' : ' + jsonData.groupName + ' , ' + this.$t('linkman_name') + ' : ' + jsonData.name
                      } else {
                        this.infoTwo = this.$t('linkman_groupname') + ' : ' + this.$t('UnKnow') + ' , ' + this.$t('linkman_name') + ' : ' + this.$t('UnKnow')
                      }
                    }
                    this.infoExten = display
                  }
                  if (jsonData.isSOS === '1') {
                    this.info = this.info + '_split_'
                  }
                }
              }
              //最后
              if (call) {
                //不是左右话机
                if (_right !== ext && _left !== ext) {
                  //修改呼叫状态
                  this.$store.commit('setCall', false)
                }
              }
              if (ext !== display) {
                if ((_right !== ext && _left !== ext) && (display === _right || display === _left)) {
                  let exten = ext
                  let userName = this.$store.state.user.userName
                  let cameraIds = '1'
                  let type = '1'
                  let that = this
                  if (display === _right) {
                    this.alarmControl.right = true
                  }else if (display == _left) {
                    this.alarmControl.left = true
                  }
                  if (!(this.videoExten && this.videoExten === exten)) {
                    this.videoExten = exten
                    this.showVideoList.push(exten)
                    if (!that.timeOutLife) {
                      that.timeOutLife = setTimeout(async function () {
                        //定时器结束后，将数据拷贝过来，然后将数据和定时器初始化。
                        let newList = JSON.parse(JSON.stringify(that.showVideoList))
                        that.showVideoList = []
                        that.timeOutLife = null
                        //从尾到头去遍历，直到找到支持联动的摄像头。
                        if (newList.length > 0) {
                          await that.getVideoPop(newList[0], cameraIds, type, userName, displayOut)
                        }

                      }, 1000)
                    }
                  }
                }

                if ((_right !== display && _left !== display) && (ext === _right || ext === _left)) {
                  let exten = display
                  let userName = this.$store.state.user.userName
                  let cameraIds = '1'
                  let type = '1'
                  let that = this
                  if (ext == _right) {
                    this.alarmControl.right = true
                  }else if (ext == _left) {
                    this.alarmControl.left = true
                  }
                  if (!(this.videoExten && this.videoExten === exten)) {
                    this.videoExten = exten
                    this.showVideoList.push(exten)
                    if (!that.timeOutLife) {
                      that.timeOutLife = setTimeout(async function () {
                        //定时器结束后，将数据拷贝过来，然后将数据和定时器初始化。
                        let newList = JSON.parse(JSON.stringify(that.showVideoList))
                        that.showVideoList = []
                        that.timeOutLife = null
                        //从尾到头去遍历，直到找到支持联动的摄像头。
                        if (newList.length > 0) {
                          await that.getVideoPop(newList[0], cameraIds, type, userName, displayOut)
                        }

                      }, 1000)
                    }
                  }
                }

                let noAccessExten = ''
                //处理权限外的呼入呼出
                if (_right === ext || _left === ext) {
                  if (display.length <= 7) {
                    //判断是否在分机状态里
                    noAccessExten = display
                  }
                }
                if (_right === display || _left === display) {
                  if (ext.length <= 7) {
                    //判断是否在分机状态里
                    noAccessExten = ext
                  }
                }
                if (noAccessExten) {
                  let rE = this.$store.state.cacheData.roleExten[noAccessExten]
                  if (!rE) {
                    let aE = this.$store.state.cacheData.devices[noAccessExten]
                    if (aE) {
                      if (this.$store.state.cacheData.noAccessTalkingExten.indexOf(aE) < 0) {
                        this.$store.state.cacheData.noAccessTalkingExten.push(aE)
                      }
                    }

                  }

                }
              }
              break
            case 'answer':
              ext = jsonData.ExtenInfo.split('@')[0]
              isLeft = this.$store.state.user.SIPControl
              if ((isLeft === '1' && (ext === this.$store.state.user.left || ext.split('@')[0] === this.$store.state.user.left))
                || (isLeft === '2' && (ext === this.$store.state.user.right || ext.split('@')[0] === this.$store.state.user.right) )) {
                this.$store.commit('setIsOtherCall', '0')
              }
              displayOut = jsonData.displayOut
              display = jsonData.displayNum
              appKey = jsonData.appKey
              if (!appKey) {
                this.$root.bus.emitAsync('extenStatusChange', ext, 'Talking')
              }
              if (jsonData.ExtenInfo && jsonData.ExtenInfo.indexOf('@') < 0) {
                await this.addOutLine(ext, 'Talking')
                //处理权限外的呼入呼出
                if (_right === display || _left === display) {
                  let extA = this.$store.state.cacheData.extractDevices
                  if (extA) {
                    let noAcA = this.$store.state.cacheData.noAccessTalkingExten
                    let roleExten = this.$store.state.cacheData.roleExten
                    let exD = extA.filter(item => item.exten == ext)
                    let rD = roleExten[ext]
                    if (exD && (!rD || rD.length <= 0)) {
                      let ad = true
                      for (let i = 0; i < noAcA.length; i++) {
                        let nA = noAcA[i]
                        if (nA.exten == ext) {
                          ad = false
                          break
                        }
                      }
                      if (ad) {
                        noAcA.push(exD[0])
                        this.$store.commit('setNoAccessTalkingExten', noAcA)
                      }
                    }
                  }
                }
              }
              this.$store.dispatch('getRoom', this.$store.state.conferencejs.currRoom).then(res => {
                if (res) {
                  res.inFixReloadRoom(ext, appKey, 500)
                }
              })
              if (this.$store.state.user.left) {
                if (ext === this.$store.state.user.left) {
                  this.$store.commit('setLeftStatus', 'Talking')
                }
              }
              if (this.$store.state.user.right) {
                if (ext === this.$store.state.user.right) {
                  this.$store.commit('setRightStatus', 'Talking')
                }
              }
              if (this.refreshCount > 0) {
                if (ext !== this.$store.state.user.left
                  && ext !== this.$store.state.user.right
                  && display !== this.$store.state.user.left
                  && display !== this.$store.state.user.right) {
                  break
                }
              }

              if (this.queueCaller === display) {
                this.queueCallee = ext
              }

              if (this.register) {
                if (ext == this.SIPControl) {
                  let autoSpeak = this.$store.state.clickData.autoCall
                  if (this.showModal && !autoSpeak) {
                    if (!this.rejectExten || this.rejectExten != display) {
                      this.rejectExten = display
                    }
                  }
                }
              }

              //判断是否是系统内的
              let extractDevices = changeExtenStatus(this.$store.state.cacheData.extractDevices, ext, 'Talking')
              if (extractDevices) {
                this.$store.commit('setExtractDevices', extractDevices)
              }
              if (display == ext) {
                if (this.queueCaller && display != this.queueCaller) {
                  if (display === this.infoExten) {
                    this.showCall = false
                  }
                  if (ext === this.SIPControl) {
                    this.showSoft = false
                  }
                }
              }else {
                if (display === this.infoExten) {
                  this.showCall = false
                }
                if (ext === this.SIPControl) {
                  this.showSoft = false
                }
              }
              extens = changeExtenStatusForMap(this.$store.state.cacheData.devices, ext, 'Talking')
              changeExtenStatusForMap(this.$store.state.cacheData.roleExten, ext, 'Talking')
              this.$store.commit('setDevices', extens)
              info = generInfo(jsonData)
              if (info) {
                this.addCallList(info)
              }

              let ques1 = this.$store.state.cacheData.queueList
              let beforeArr = [].concat(ques1)
              //判读队列中是否存在
              let deviceArr = deviceQueueArr(ques1, this.queueExtens, jsonData)
              let diffInfo = getDiff2(beforeArr, deviceArr)
              if (diffInfo && diffInfo.length > 0) {
                diffInfo[0].uuid = jsonData.uuid
                this.$store.commit('setQueueCallInfo', diffInfo[0])
              }
              this.$store.commit('setQueueList', deviceArr)
              //相等再次处理
              if (ext === display && displayOut) {
                setTimeout(() => {
                  changeExtenStatus(this.$store.state.cacheData.extractDevices, ext, 'Talking')
                  changeExtenStatusForMap(this.$store.state.cacheData.devices, ext, 'Talking')
                  changeExtenStatusForMap(this.$store.state.cacheData.roleExten, ext, 'Talking')
                }, 2000)
              }
              break
            case 'broading':
              ext = jsonData.ExtenInfo.split('@')[0]
              isLeft = this.$store.state.user.SIPControl
              if ((isLeft === '1' && (ext === this.$store.state.user.left || ext === this.$store.state.user.left))
              || (isLeft === '2' && (ext === this.$store.state.user.right || ext === this.$store.state.user.right))) {
                this.$store.commit('setIsOtherCall', '0')
              }
              displayOut = jsonData.displayOut
              display = jsonData.displayNum
              this.$root.bus.emitAsync('extenStatusChange', ext, 'Broading')
              this.$store.dispatch('getRoom', this.$store.state.conferencejs.currRoom).then(res => {
                if (res) {
                  res.inFixReloadRoom(ext, appKey, 500)
                }
              })
              if (this.$store.state.user.left) {
                if (ext === this.$store.state.user.left) {
                  this.$store.commit('setLeftStatus', 'Broading')
                }
              }
              if (this.$store.state.user.right) {
                if (ext === this.$store.state.user.right) {
                  this.$store.commit('setRightStatus', 'Broading')
                }
              }
              if (this.refreshCount > 0) {
                if (ext !== this.$store.state.user.left
                  && ext !== this.$store.state.user.right
                  && display !== this.$store.state.user.left
                  && display !== this.$store.state.user.right) {
                  break
                }
              }

              if (this.queueCaller === display) {
                this.queueCallee = ext
              }

              //判断是否是系统内的
              let extractDevices2 = changeExtenStatus(this.$store.state.cacheData.extractDevices, ext, 'Broading')
              if (extractDevices2) {
                this.$store.commit('setExtractDevices', extractDevices2)
              }
              if (display === this.infoExten) {
                this.showCall = false
              }
              if (ext === this.SIPControl) {
                this.showSoft = false
              }
              extens = changeExtenStatusForMap(this.$store.state.cacheData.devices, ext, 'Broading')
              changeExtenStatusForMap(this.$store.state.cacheData.roleExten, ext, 'Broading')
              this.$store.commit('setDevices', extens)
              info = generInfo(jsonData)
              if (info) {
                this.addCallList(info)
              }

              let ques12 = this.$store.state.cacheData.queueList
              let beforeArr2 = [].concat(ques12)
              //判读队列中是否存在
              let deviceArr3 = deviceQueueArr(ques12, this.queueExtens, jsonData)
              let diffInfo2 = getDiff2(beforeArr2, deviceArr3)
              if (diffInfo2 && diffInfo2.length > 0) {
                diffInfo2[0].uuid = jsonData.uuid
                this.$store.commit('setQueueCallInfo', diffInfo2[0])
              }

              this.$store.commit('setQueueList', deviceArr3)
              //相等再次处理
              if (ext === display && displayOut) {
                setTimeout(() => {
                  changeExtenStatus(this.$store.state.cacheData.extractDevices, ext, 'Broading')
                  changeExtenStatusForMap(this.$store.state.cacheData.devices, ext, 'Broading')
                  changeExtenStatusForMap(this.$store.state.cacheData.roleExten, ext, 'Broading')
                }, 2000)
              }
              break
            case 'handup':
              ext = jsonData.ExtenInfo
              isLeft = this.$store.state.user.SIPControl
              if ((isLeft === '1' && (ext === this.$store.state.user.left || ext.split('@')[0] === this.$store.state.user.left)) ||
                (isLeft === '2' && (ext === this.$store.state.user.right || ext.split('@')[0] === this.$store.state.user.right))) {
                this.$store.commit('setIsOtherCall', '0')
              }
              display = jsonData.displayNum
              displayOut = jsonData.displayOut
              appKey = jsonData.appKey
              if (!appKey) {
                this.$root.bus.emitAsync('extenStatusChange', ext, 'Idle')
              }
              /*if(appKey){
              conferencesTalking(this.$store.state.cacheData.nowconferences, this.$store.state.cacheData.conferences, ext.split('@')[0],"UnKnow",appKey)
              //去除会议室中的分机
              let confMembers = ConferencesDel(this.$store.state.cacheData.conferences, ext.split('@')[0], this.$store.state.cacheData.invateOutLines,appKey)
              this.$store.commit('setConferences', confMembers)
              break;
            }*/
              let rooms = this.$store.state.conferencejs.rooms
              forEach(rooms, room => {
                room.changeInviteState('number', appKey, ((ext.indexOf('@') > -1) ? (ext.split('@')[0]) : ext), 1000)
              })
              this.$store.dispatch('getRoom', this.$store.state.conferencejs.currRoom).then(res => {
                if (res) {
                  res.inFixReloadRoom(ext, appKey, 500)
                }
              })
              //更新临时会议数据
              confName = jsonData.confName
              if (display == this.$store.state.user.displayNum && confName) {
                this.$store.dispatch('getRoom', confName).then(res => {
                  if (res) {
                    res.removeParticipant('number', ext, appKey)
                    if (this.$store.state.conferencejs.currRoom === res.name) {
                      //刷新当前会议室
                      //this.$root.bus.$emit('reloadConference',res.name)
                      res.reloadRoom(1000)
                    }
                  }
                })
              }

              if (this.refreshCount > 0) {
                if (ext !== this.$store.state.user.left
                  && ext !== this.$store.state.user.right
                  && display !== this.$store.state.user.left
                  && display !== this.$store.state.user.right) {
                  break
                }
              }
              if (display === this.infoExten) {
                this.showCall = false
              }
              if (ext.indexOf('@') > -1) {
                status = 'Idle'
              } else {
                if (ext.length < 7) {
                  status = 'Idle'
                } else {
                  status = 'UnKnow'
                }
              }
              ext = jsonData.ExtenInfo.split('@')[0]

              let noAccess = this.$store.state.cacheData.noAccessTalkingExten
              if (noAccess && noAccess.length > 0) {
                let kIndex = -1
                for (let i = 0; i < noAccess.length; i++) {
                  let ne = noAccess[i]
                  if (!ne) {
                    continue
                  }
                  if (ne.exten == ext || ne.exten == display) {
                    kIndex = i;
                    break;
                  }
                }
                if (kIndex > -1) {
                  noAccess.splice(kIndex, 1)
                }

              }
              if (this.$store.state.user.left) {
                if (ext === this.$store.state.user.left) {
                  this.$store.commit('setLeftStatus', 'Idle')
                  this.$root.bus.emitAsync('hangClear', display)
                }
                if (display == this.$store.state.user.left) {
                  this.$root.bus.emitAsync('hangClear', ext)
                }
              }
              if (this.$store.state.user.right) {
                if (ext === this.$store.state.user.right) {
                  this.$store.commit('setRightStatus', 'Idle')
                  this.$root.bus.emitAsync('hangClear', display)
                }
                if (display == this.$store.state.user.right) {
                  this.$root.bus.emitAsync('hangClear', ext)
                }
              }
              if (ext !== display) {
                if ((ext === this.videoExten || display === this.videoExten)&&
                  (ext==this.$store.state.user.right || display==this.$store.state.user.right ||ext==this.$store.state.user.left || display==this.$store.state.user.left)) {
                  //
                  if (ext == this.$store.state.user.right || display == this.$store.state.user.right) {
                    this.alarmControl.right = false
                  }
                  if (ext == this.$store.state.user.left || display == this.$store.state.user.left) {
                    this.alarmControl.left = false
                  }
                  if (!this.alarmControl.left && !this.alarmControl.right) {
                    this.visibleChange(false)
                    if (this.autoCloseDialog) {
                      this.videoExten = null
                      this.showAlarm = false
                    }
                  }
                }
              }else {
                if (confName && this.videoExten == ext) {
                  //修改喊话支持弹窗关闭
                  if (this.autoCloseDialog) {
                    this.videoExten = null
                    this.showAlarm = false
                  }
                }
              }

              if (!this.videoExten && this.closeForExt === ext) {
                this.closeForExt = null
                if (this.autoCloseDialog && this.alarmOpenW !== '' && this.alarmOpenW !== null && this.alarmOpenW !== undefined) {
                  if (this.alarmOpenW.name !== '') {
                    this.alarmOpenW.close()
                  }
                }
              }

              let noticeDis = null
              if (ext === display) {
                //呼叫号等于显示号即为广播任务
                let _left = this.$store.state.user.left
                let _right = this.$store.state.user.right
                if (ext === _left) {
                  noticeDis = this.leftOut
                } else if (ext === _right) {
                  noticeDis = this.rightOut
                }
              }
              let removeOut = true
              let queueCallInfo = this.$store.state.cacheData.queueCallInfo
              if (queueCallInfo) {
                if (ext === queueCallInfo.exten || display === queueCallInfo.exten) {
                  if (jsonData.uuid !== queueCallInfo.uuid) {
                    removeOut = false
                  } else {
                    this.$store.commit('setQueueCallInfo', null)
                    let deviceArr3 = deviceQueueArrNoExtens(this.$store.state.cacheData.queueList, jsonData)
                    this.$store.commit('setQueueList', deviceArr3)
                  }
                }
              }
              if (removeOut) {
                //系统外挂断，去除数据
                let extract = this.$store.state.cacheData.extractDevices
                if (Array.isArray(extract) && extract.length > 0) {
                  let k = -1
                  for (let i = 0; i < extract.length; i++) {
                    let dev = extract[i]
                    if (dev.exten === ext || dev.exten === display || dev.exten === noticeDis) {
                      k = i
                      break
                    }
                  }
                  if (k !== -1) {
                    extract.splice(k, 1)
                  }
                  this.$store.commit('setExtractDevices', extract)
                  let devices = this.$store.state.cacheData.devices
                  // let dk = -1
                  // for (let i = 0; i < devices.length; i++) {
                  //   let dev = devices[i]
                  //   if ((dev.exten === ext || dev.exten === display || dev.exten === noticeDis) && dev.out === '2') {
                  //     dk = i
                  //     break
                  //   }
                  // }
                  // if (dk > -1) {
                  //   devices.splice(dk, 1)
                  // }
                  let dev = devices[ext] ? devices[ext] : devices[display] ? devices[display] : devices[noticeDis];
                  if(dev && dev.out === '2'){
                    delete devices[ext];
                  }
                  this.$store.commit('setDevices', devices)
                }
              }

              //去除会议室中所有的分机
              //获取分机号()
              let displayNum1 = this.$store.state.user.displayNum
              let confList1 = this.$store.state.cacheData.confNums
              if (display === displayNum1 || confList1.indexOf(display) > -1) {
                let confMembers = ConferencesDel(this.$store.state.cacheData.conferences, ext, this.$store.state.cacheData.invateOutLines)
                this.$store.commit('setConferences', confMembers)
              }
              if (ext === this.SIPControl) {
                this.showSoft = false
              }
              extens = changeExtenStatusForMap(this.$store.state.cacheData.devices, ext, status)
              changeExtenStatusForMap(this.$store.state.cacheData.roleExten, ext, status)
              this.cacheExtens(extens)
              info = generInfo(jsonData)
              if (info) {
                this.addCallList(info)
              }

              if (ext === display) {
                let deviceArr3 = deviceQueueArrNoExtens(this.$store.state.cacheData.queueList, jsonData)
                this.$store.commit('setQueueList', deviceArr3)
              }

              this.$store.commit('setHangup', true)
              this.$store.commit('setHangExten', ext)
              break
            case 'online':
              ext = jsonData.ExtenInfo.split('@')[0]
              let isLeft = this.$store.state.user.SIPControl
              if ((isLeft === '1' && (ext === this.$store.state.user.left || ext.split('@')[0] === this.$store.state.user.left)) ||
                (isLeft === '2' && (ext === this.$store.state.user.right || ext.split('@')[0] === this.$store.state.user.right))) {
                this.$store.commit('setIsOtherCall', '0')
              }
              this.$root.bus.emitAsync('extenStatusChange', ext, 'Idle')
              this.$root.bus.emitAsync('OnlineOrOffLine', ext, 'Online')
              if (ext === this.$store.state.user.left) {
                this.$store.commit('setLeftStatus', 'Idle')
              }
              if (ext === this.$store.state.user.right) {
                this.$store.commit('setRightStatus', 'Idle')
              }
              if(!that.needFreshFlag){
                that.needFreshFlag = true;
                that.needFreshTime = null;
                clearTimeout(that.needFreshTime)
                that.needFreshTime = setTimeout(function (){
                  that.needFreshFlag = false;
                  that.$store.commit('setControlLeft', Math.random() + '')
                },1000)
              }

              let registerIp = jsonData.NetWork
              extens = changeExtenStatusForMap(this.$store.state.cacheData.devices, ext, 'Idle', registerIp)
              changeExtenStatusForMap(this.$store.state.cacheData.roleExten, ext, 'Idle', registerIp)
              this.cacheExtens(extens)

              this.$store.dispatch('getRoom', this.$store.state.conferencejs.currRoom).then(res => {
                if (res) {
                  res.inFixReloadRoom(ext, appKey)
                }
              })
              if (1 === this.$store.state.user.enableRemind) {
                this.$Notice.warning({
                  title: this.$t('status'),
                  desc: this.$t('ext') + ext + this.$t('online'),
                  duration: parseInt(this.$store.state.user.remindCloseTime),
                })
              }
              // groups = generArea(extens, this.deptList)
              //this.setGroups(this.deptList)
              break
            case 'offline':
              ext = jsonData.ExtenInfo.split('@')[0]
              this.$root.bus.emitAsync('extenStatusChange', ext, 'OffLine')
              this.$root.bus.emitAsync('OnlineOrOffLine', ext, 'OffLine')
              isLeft = this.$store.state.user.SIPControl

              if ((isLeft === '1' && (ext === this.$store.state.user.left || ext.split('@')[0] === this.$store.state.user.left)) ||
                (isLeft === '2' && (ext === this.$store.state.user.right || ext.split('@')[0] === this.$store.state.user.right))) {
                this.$store.commit('setIsOtherCall', '0')
              }
              if (ext === this.$store.state.user.left) {
                this.$store.commit('setLeftStatus', 'OffLine')
              }
              if (ext === this.$store.state.user.right) {
                this.$store.commit('setRightStatus', 'OffLine')
              }
              if(!that.needFreshFlag){
                that.needFreshFlag = true;
                if(that.needFreshTime){
                  that.needFreshTime = null;
                  clearTimeout(that.needFreshTime)
                }
                that.needFreshTime = setTimeout(function (){
                  that.needFreshFlag = false;
                  that.$store.commit('setControlLeft', Math.random() + '')
                },1000)
              }
              extens = changeExtenStatusForMap(this.$store.state.cacheData.devices, ext, 'OffLine')
              changeExtenStatusForMap(this.$store.state.cacheData.roleExten, ext, 'OffLine')
              this.cacheExtens(extens)
              this.$store.dispatch('getRoom', this.$store.state.conferencejs.currRoom).then(res => {
                if (res) {
                  res.inFixReloadRoom(ext, appKey)
                }
              })
              if (1 === this.$store.state.user.enableRemind) {
                this.$Notice.warning({
                  title: this.$t('status'),
                  desc: this.$t('ext') + ext + this.$t('extOffline'),
                  duration: parseInt(this.$store.state.user.remindCloseTime),
                })
              }
              this.$root.bus.emitAsync('offline', ext)
              break
            case 'alarm':
              //报警弹出
              //查询报警信息
              this.$Notice.config({
                top: this.noticeBottom
              })
              let id = jsonData.id
              var typeA = jsonData.alert_type + ''
              var alarmData = ''
              let title = this.$t('device_alarm')
              if (typeA === '1') {
                title = this.$t('tamper_alarm')
              } else if (typeA === '2') {
                title = this.$t('one_alarm')
              } else if (typeA === '3') {
                title = this.$t('gateway_alarm')
              } else if (typeA === '4') {
                title = this.$t('motion_alarm')
              } else if (typeA === '5') {
                title = this.$t('helmet_alarm')
              }
              detailAlarm({alarm_id: id}).then(res => {
                let response = res.data
                if (response.statuscode === '000000') {
                  if (response.data.length <= 0) {
                    return
                  } else {
                    //播放音频
                    if ('1' == this.$store.state.user.webWarnVoice) {
                      this.playAudio()
                    }

                    let noticeName = 'alarm' + new Date().getTime()
                    let exten = jsonData.ExtenInfo
                    let devicename = exten
                    alarmData = response.data[0].alarm_data
                    let prefix = this.$t('device')
                    let cameraAlarm = false
                    if (typeA === '3') {
                      devicename = response.data[0].device_name
                    }
                    if (typeA === '4' || typeA === '5') {
                      devicename = response.data[0].device_name
                      prefix = this.$t('camera')
                      cameraAlarm = true
                    }
                    if (!cameraAlarm) {
                      //存储报警终端
                      let alarms = this.$store.state.cacheData.alarmDevs
                      if (alarms.indexOf(exten) < 0) {
                        alarms.push(exten)
                      }
                      this.$store.commit('setAlarmDevs', alarms)
                    }

                    this.$Notice.warning({
                      title: title,
                      duration: 0,
                      name: noticeName,
                      desc: prefix + ' : ' + devicename + this.$t('warning'),
                      onClose: () => {
                        //复原报警设备
                        //this.resetAlarm(response.data[0],noticeName)
                        if (!cameraAlarm) {
                          this.resetIcon(response.data[0])
                        }
                        this.$Notice.close(noticeName)
                        if ('1' == this.$store.state.user.webWarnVoice) {
                          this.stopAudio()
                        }
                      },
                      render: h => {
                        return h('div',
                          [
                            h('p', {
                              style: {
                                fontSize: '14px',
                                marginBottom: '10px',
                                wordBreak: 'break-all'
                              }
                            }, [prefix + ' : ' + devicename + this.$t('warning')]),
                            h('Button', {
                              style: {
                                marginRight: '10px'
                              },
                              on: {
                                click: () => {
                                  //复原报警设备
                                  //this.resetAlarm(response.data[0],noticeName)
                                  if (!cameraAlarm) {
                                    this.resetIcon(response.data[0])
                                  }
                                  this.$Notice.close(noticeName)
                                  if ('1' == this.$store.state.user.webWarnVoice) {
                                    this.stopAudio()
                                  }

                                }
                              }
                            }, [this.$t('ignore')]),
                            h('Button', {
                              style: {
                                marginRight: '10px'
                              },
                              on: {
                                click: () => {
                                  let pid = response.data[0].id
                                  //跳转报警页面，弹出报警确认弹窗
                                  let param = {alarmId: pid, aexten: exten, alarmType: typeA}
                                  if (this.currRouteName == 'alarm') {
                                    //不在报警页面
                                    this.$root.bus.emitAsync('confirmAlarmFather', param)
                                    setTimeout(function (){
                                      that.$root.bus.emitAsync('confirmAlarm', param)
                                    },100)
                                  } else {
                                    this.$router.push({
                                      name: 'alarm',
                                      params: param
                                    })//传入参数
                                  }
                                  //复原报警设备
                                  if (!cameraAlarm) {
                                    this.resetAlarm(response.data[0], noticeName)
                                  } else {
                                    this.$Notice.close(noticeName)
                                  }
                                  if ('1' == this.$store.state.user.webWarnVoice) {
                                    this.stopAudio()
                                  }
                                }
                              }
                            }, [this.$t('warning_sure')])
                          ])
                      }
                    })
                  }
                  //传入该报警类型获取报警对应预案
                  //查询该报警下有无视频联动,是否是自动的
                  var exten = jsonData.ExtenInfo
                  let isActive = '1'//自动的联动
                  let type = response.data[0].alert_type + ''
                  let cameraAlarm = '0'
                  let videoAlarm = '0'
                  //改由后台发送
                  /*if (type === '4' || type === '5') {
                    cameraAlarm = '1'
                    videoAlarm = '1'
                    let _this = this
                    queryPrePlanByParams({type: type, cameraId: exten, isActive: 1}).then(res => {
                      let response = res.data
                      if (response.code === 200) {
                        let plans = response.data
                        if (plans && plans.length > 0) {
                          _this.sendMsg({
                            method: 'alarm_send',
                            ext: exten,
                            msg: '\'alert_type\':' + type + ',\'ext\':' + exten + ',\'alarm_data\':\'' + alarmData + '\''
                          })
                          //执行视频预案
                          _this.$store.commit('setBroadStart', true)
                        }
                      }
                    }).catch(err => console.log('err', err))
                  }*/
                  if (type === '3') {
                    cameraAlarm = '1'
                  }


                  queryVideo({exten, type, isActive, cameraAlarm: videoAlarm}).then(res => {
                    let response = res.data
                    if (response.code === 200) {
                      if (response.data !== null && response.data.length > 0) {
                        var cameraIds = ''
                        for (let i = 0; i < response.data.length; i++) {
                          cameraIds = cameraIds + response.data[i].cameraId + ','
                        }
                        cameraIds = cameraIds.substring(0, cameraIds.length - 1)
                        let userName = this.$store.state.user.userName
                        let type = '2'
                        queryRTMPByExten({exten, cameraIds, type, userName, cameraAlarm}).then(res => {
                          let response = res.data
                          this.cameras = []
                          if (response.code === 200) {
                            let data = response.data
                            if (data !== null && data.length > 0) {
                              //this.showAlarm = true
                              this.cameras = data
                              this.cameras.exten = exten
                              this.alarmModal(exten)
                            }
                          }
                        }).catch(err => {
                          console.log(err)
                        })
                      }
                    }
                  })
                } else {
                  this.$Message.error(this.$t('fail'))
                }


              }).catch(err => {
                console.log('err', err)
              })
              this.$store.commit('setBroadStart', true)

              break
            case 'getconferencelist':
              let conferences = []
              conferences = jsonData.confInfos
              //生成临时会议室
              for (let i = 0; i < conferences.length; i++) {
                let cm = conferences[i]
                let confName = cm.confname
                if (confName.indexOf('-a-') > -1) {
                  //临时会议室,查询是否存在
                  await this.$store.dispatch('getRoom', confName).then(res => {
                    if (!res) {
                      let room = new Room(confName, confName, confName, '', '', '', confName.indexOf('-v-') > -1, false, '-1', true);
                      room.addMeetingNum()
                      this.$store.commit('addRoom', room)
                    }else {
                      res.addMeetingNum()
                    }
                  });
                } else {
                  await this.$store.dispatch('getRoom',confName).then(res=>{
                    if (res){
                      res.addMeetingNum()
                    }
                  })
                }
              }
              if (conferences.length > 0) {
                this.$root.bus.emitAsync('meetingChange')
              }
              break;
            case 'LeaveConferce':
              ext = jsonData.ExtenInfo.split('@')[0]
              appKey = jsonData.appKey
              confName = jsonData.confname
              let leName = jsonData.ExtenName
              if (!leName) {
                leName = ext
              }
              this.$store.dispatch('getRoom', confName).then(res => {
                if (res) {
                  res.removeParticipant('number', ext, appKey)
                  res.aysncInfo(ext, 'leave')
                  if (this.$store.state.conferencejs.currRoom === res.name) {
                    //刷新当前会议室
                    //this.$root.bus.$emit('reloadConference',res.name)
                    res.reloadRoom(1000)
                  }

                }
              })
              break
            case 'EnterConference':
              ext = jsonData.ExtenInfo.split('@')[0]
              confName = jsonData.confname
              let eName = jsonData.ExtenName
              appKey = jsonData.appKey
              if (this.$store.state.user.left) {
                if (ext === this.$store.state.user.left) {
                  this.$store.commit('setLeftStatus', 'Talking')
                }
              }
              if (this.$store.state.user.right) {
                if (ext === this.$store.state.user.right) {
                  this.$store.commit('setRightStatus', 'Talking')
                }
              }
              extens = changeExtenStatusForMap(this.$store.state.cacheData.devices, ext, 'Talking')
              changeExtenStatusForMap(this.$store.state.cacheData.roleExten, ext, 'Talking')
              this.$store.commit('setDevices', extens)
              if (!eName) {
                eName = ext
              }
              this.$store.dispatch('getRoom', confName).then(res => {
                if (res) {
                  res.removeInviteParticipant('number', ext, appKey)
                  res.aysncInfo(ext, 'enter')
                  if (this.$store.state.conferencejs.currRoom === res.name) {
                    //刷新当前会议室
                    //this.$root.bus.$emit('reloadConference',res.name)
                    res.reloadRoom(1000)
                  }
                } else {
                  if (confName.indexOf('-a-') > -1) {
                    let room = new Room(confName, confName, call, '', '', '', confName.indexOf('-v-') > -1, false, '-1', true)
                    this.$store.commit('addRoom', room)
                  }
                }
              })

              //设置当前会议室话机状态为通话中，其余移出
              /*removeOtherExten(confname, this.$store.state.cacheData.conferences, this.$store.state.cacheData.invateOutLines, ext,appKey)
            let confs = ConferencesAdd(confname, this.$store.state.cacheData.conferences, this.$store.state.cacheData.devices, ext,null,appKey)
            if (confs != null) {
              this.setConferences(confs)
            }
            info = generConfInfo(jsonData, this.$store.state.cacheData.confList, this.$store.state.cacheData.callConfList)
            if (info) {
              info.sysName = jsonData.sysName ? jsonData.sysName +":" : "";
              this.addCallConfList(info)
            }*/
              break
            case 'MuteConference':
              appKey = jsonData.appKey
              ext = jsonData.ExtenInfo.split('@')[0]
              confName = jsonData.confname
              this.$store.dispatch('getRoom', confName).then(res => {
                if (res) {
                  res.info('number', ext, appKey, 'mute')
                  let participant = res.getParticipantByNumber(ext, appKey)
                  participant ? participant.setMute(true) : null
                }
              })
              break
            case 'CancelMuteConference':
              appKey = jsonData.appKey
              ext = jsonData.ExtenInfo.split('@')[0]
              confName = jsonData.confname
              this.$store.dispatch('getRoom', confName).then(res => {
                if (res) {
                  res.info('number', ext, appKey, 'unMute')
                  let participant = res.getParticipantByNumber(ext, appKey)
                  participant ? participant.setMute(false) : null
                }
              })
              break
            case 'enterqueue':
              this.queueCaller = info.ExtenInfo
              this.getQueueExten(jsonData.queuename, list => {
                if (list.length > 0) {
                  if (list.indexOf(this.$store.state.user.right) > -1 || list.indexOf(this.$store.state.user.left) > -1) {
                    let arr = this.$store.state.cacheData.queueList
                    if (jsonData.isSOS === '1') {
                      this.changeColor(true)
                    }
                    let queueArr = addQueueArr(arr, jsonData)
                    this.$store.commit('setQueueList', queueArr)
                  }
                }
              })
              break
            case 'leavequeue':
              let deviceArr2 = deviceQueueArrNoExtens(this.$store.state.cacheData.queueList, jsonData)
              this.$store.commit('setQueueList', deviceArr2)
              if (jsonData.isSOS === '1') {
                clearTimeout(this.colorTimer)
                this.colorTimer = null
                document.getElementById('main_page').style.boxShadow = 'unset'
              }
              break
            case 'BroadcastStart':
              let taskId = jsonData.taskId
              let counts = jsonData.extenCounts
              if (counts > 100) {
                this.refreshCount = parseInt(counts / 100) + 1
              }
              let broadTime = this.$store.state.cacheData.playingBroad

              let json = {}
              json.id = taskId
              json.startTime = Date.now()
              json.name = jsonData.taskName
              let pushF = true
              for (let i = 0; i < broadTime.length; i++) {
                let ib = broadTime[i]
                if (ib.id === taskId) {
                  ib.startTime = Date.now()
                  pushF = false
                }
              }
              if (pushF) {
                broadTime.push(json)
              }
              this.$store.commit('setPlayingBroad', broadTime)
              this.$root.bus.emitAsync('startBroad', taskId)
              break
            case 'BroadcastStop':
              let taskId2 = jsonData.taskId
              let broadTime2 = this.$store.state.cacheData.playingBroad
              let k = -1
              for (let i = 0; i < broadTime2.length; i++) {
                let b = broadTime2[i]
                if (b.id === taskId2) {
                  k = i
                }
              }
              if (k > -1) {
                broadTime2.splice(k, 1)
                this.$store.commit('setPlayingBroad', broadTime2)
              }
              this.$root.bus.emitAsync('stopBroad', taskId2)
              break
            case 'vol_update':
              let vol = jsonData.vol
              let ext = jsonData.ext
              if (ext.indexOf('@') > -1) {
                ext = ext.split('@')[0]
              }
              let vjson = {}
              vjson.vol = vol
              vjson.exten = ext
              this.updateVolume.push(vjson)
              //定时器3秒更新数据
              this.updateInterval = setInterval(() => {
                if (this.updateVolume.length > 0) {
                  let devices = this.$store.state.cacheData.roleExten
                  let has = [].concat(this.updateVolume)
                  this.updateVolume = []
                  forEach(has, it => {
                    if (devices[it.exten]) {
                      devices[it.exten].volume = it.vol
                    }
                  })
                  // forEach(devices, item => {
                  //   forEach(has, it => {
                  //     if (item.exten === it.exten) {
                  //       item.volume = it.vol
                  //     }
                  //   })
                  // })
                }
              }, 3000)
              break
            case 'BroadcastVolumeUpdate':
              //通知更新广播
              this.$root.bus.emitAsync('broadcastVolumeUpdate', jsonData.bId,jsonData.vol)
              break
            case 'alarmRecover':
              let exten = jsonData.ExtenInfo
              if (this.autoRecover) {
                //this.$root.bus.$emit('alarmRecover',jsonData)
                //关闭弹屏
                if (this.alarmOpen) {
                  this.visibleChange(false)
                  this.videoExten = null
                  this.showAlarm = false
                }
              }
              break
            case 'Bridge':
              ext = jsonData.ExtenInfo.split('@')[0]
              let tra = jsonData.ExtenInfo_a
              let trb = jsonData.ExtenInfo_b
              let traO = jsonData.ExtenInfo_a_out
              let trbO = jsonData.ExtenInfo_b_out
              let trab = trb
              let trabo = trbO
              if (ext !== tra) {
                trab = tra
                trabo = traO
              }

              let is_Broadcast = this.$store.state.cacheData.devices ? this.$store.state.cacheData.devices[jsonData.ExtenInfo_b] : null;
              if (is_Broadcast != undefined && is_Broadcast.status == 'Broading') {
                var ext2 = jsonData.ExtenInfo_b
                if (this.$store.state.user.left) {
                  if (ext2 === this.$store.state.user.left) {
                    this.$store.commit('setLeftStatus', 'Talking')
                  }
                }
                if (this.$store.state.user.right) {
                  if (ext2 === this.$store.state.user.right) {
                    this.$store.commit('setRightStatus', 'Talking')
                  }
                }
                if (this.refreshCount > 0) {
                  if (ext2 !== this.$store.state.user.left
                    && ext2 !== this.$store.state.user.right
                    && ext2 !== this.$store.state.user.left
                    && ext2 !== this.$store.state.user.right) {
                    break
                  }
                }

                if (this.queueCaller === ext2) {
                  this.queueCallee = ext2
                }

                //判断是否是系统内的
                let extractDevices = changeExtenStatus(this.$store.state.cacheData.extractDevices, ext2, 'Talking')
                if (extractDevices) {
                  this.$store.commit('setExtractDevices', extractDevices)
                }
                if (ext2 === this.infoExten) {
                  this.showCall = false
                }
                if (ext2 === this.SIPControl) {
                  this.showSoft = false
                }
                extens = changeExtenStatusForMap(this.$store.state.cacheData.devices, ext2, 'Talking')
                changeExtenStatusForMap(this.$store.state.cacheData.roleExten, ext2, 'Talking')
                this.$root.bus.emitAsync('extenStatusChange', ext2, 'Talking')
                this.$store.commit('setDevices', extens)
                info = generInfo(jsonData)
                if (info) {
                  this.addCallList(info)
                }

                let ques1 = this.$store.state.cacheData.queueList
                let beforeArr = [].concat(ques1)
                //判读队列中是否存在
                let deviceArr = deviceQueueArr(ques1, this.queueExtens, jsonData)
                let diffInfo = getDiff2(beforeArr, deviceArr)
                if (diffInfo && diffInfo.length > 0) {
                  diffInfo[0].uuid = jsonData.uuid
                  this.$store.commit('setQueueCallInfo', diffInfo[0])
                }
                this.$store.commit('setQueueList', deviceArr)
              }

              if (this.$store.state.user.left) {
                if (ext === this.$store.state.user.left) {
                  this.$store.commit('setLeftStatus', 'Talking')
                }
              }
              if (this.$store.state.user.right) {
                if (ext === this.$store.state.user.right) {
                  this.$store.commit('setRightStatus', 'Talking')
                }
              }
              if (trabo) {
                showExten = this.$store.state.cacheData.devices ? this.$store.state.cacheData.devices[trab] : null;
                if (!showExten) {
                  //生成外线数据
                  let name2 = this.$t('outLine')
                  let callInfo2 = {
                    exten: trab,
                    status: 'Talking',
                    out: '2',
                    deptid: '-1',
                    deptname: name2,
                    cameraflag: '0',
                    employeename: trab,
                    employeeid: '',
                    position: '',
                    order: '-5'
                  }
                  //同步等待数据返回
                  let ass = await this.outLineInfo(trab)
                  let addFlag = true
                  if (ass) {
                    if (ass.hasOwnProperty('statuscode') && ass.statuscode === '000000') {
                      let dataA = ass.data
                      if (Array.isArray(dataA) && dataA.length > 0) {
                        callInfo2.deptname = ass.data[0].groupName
                        callInfo2.employeename = ass.data[0].name
                      }
                      let noData = ass.noAccess
                      if (Array.isArray(noData) && noData.length > 0) {
                        addFlag = noData.indexOf(phone) < 0
                      }
                    }
                  }
                  if (addFlag) {
                    let arr2 = this.$store.state.cacheData.extractDevices
                    let pushFlag2 = true
                    if (Array.isArray(arr2) && arr2.length > 0) {
                      forEach(arr2, item => {
                        if (item.exten === callInfo2.exten) {
                          pushFlag2 = false
                        }
                      })
                    }
                    if (pushFlag2) {
                      arr2.push(callInfo2)
                      this.$store.commit('setExtractDevices', arr2)
                      let devices2 = this.$store.state.cacheData.devices
                      devices2[callInfo2.exten] = callInfo2
                      this.$store.commit('setDevices', devices2)
                    }
                  }
                }

              }
              //存在

              break
            case 'preplan_start':
              //收到预案启动事件进行刷新页面。
              let newPlanId = this.$store.state.clickData.actionPlanId
              this.$store.state.clickData.actionPlanId = '-1'
              this.$store.state.clickData.actionPlanId = newPlanId
              // 在数据更新后强制刷新组件
              this.$forceUpdate();
              break
            case 'device_alarm':
              ext = jsonData.ExtenInfo.split('@')[0]
              let resultParam = changeExtenAlarm(this.$store.state.cacheData.roleExten, ext, '1')
              this.$store.commit('addIsAlarmDept', resultParam.deptId)
              extens = resultParam.extens
              this.cacheExtens(extens)
              this.$store.commit('setRoleExten', extens)
              // 在数据更新后强制刷新组件
              this.$forceUpdate();
              break
            case 'device_reset':
              ext = jsonData.ExtenInfo.split('@')[0]
              let newParam = changeExtenAlarm(this.$store.state.cacheData.roleExten, ext, '0')
              this.$store.commit('reduceIsAlarmDept', newParam.deptId)
              extens = newParam.extens
              this.cacheExtens(extens)
              this.$store.commit('setRoleExten', extens)
              break
            case 'monitor_video_call':
              let action = jsonData.action
              let uuid = jsonData.uuid
              let line = jsonData.line
              if ('stop' == action && '0' == line) {
                //自主断流。
                // this.setMonitorUUID(uuid);
              }
              break
            case 'BroadcastResume':
              setTimeout(() => {
                this.$store.commit('setBroadFresh', true)
              }, 1000)
              break
            case 'BroadcastPause':
              setTimeout(() => {
                this.$store.commit('setBroadFresh', true)
              }, 1000)
              break
            case 'videoConferenceInvite':
              let inviteUser = jsonData.userID
              let roomName = jsonData.roomName
              let roomNum = jsonData.roomNum
              if (this.showVcsInvite) {
                //直接拒接
                this.sendRejectVcs(roomName, roomNum)
                return
              }
              this.inviteInfo.content = this.$t('meeting.invite.content_pre') + inviteUser + this.$t('meeting.invite.content_suf') + roomName
              this.inviteInfo.userId = inviteUser
              this.inviteInfo.roomName = roomName
              this.inviteInfo.roomNum = roomNum
              this.showVcsInvite = true
              break
            case 'vcsReject':
              let rjn = jsonData.roomName
              let rjm = jsonData.roomNum
              let rui = jsonData.rejectUserId
              //添加到未进入
              this.$store.dispatch('getRoom', rjn).then(room => {
                if (room) {
                  room.changeInviteState('name', null, rui)
                }
              })
              break
            case 'statusChange':
              ext = jsonData.ExtenInfo.split('@')[0]
              let state = jsonData.state
              confName = jsonData.confname
              appKey = jsonData.appKey
              if (this.$store.state.user.left) {
                if (ext === this.$store.state.user.left) {
                  this.$store.commit('setLeftStatus', state)
                }
              }
              if (this.$store.state.user.right) {
                if (ext === this.$store.state.user.right) {
                  this.$store.commit('setRightStatus', state)
                }
              }
              extens = changeExtenStatusForMap(this.$store.state.cacheData.devices, ext, state)
              changeExtenStatusForMap(this.$store.state.cacheData.roleExten, ext, state)
              this.$store.commit('setDevices', extens)

              this.$store.dispatch('getRoom', confName).then(res => {
                if (res) {
                  res.removeInviteParticipant('number', ext, appKey)
                  res.info('number', ext, appKey, 'enter')
                  if (this.$store.state.conferencejs.currRoom === res.no) {
                    //刷新当前会议室
                    //this.$root.bus.$emit('reloadConference',res.name)
                    res.reloadRoom(1000)
                  }
                }
              })
              break
            case 'appMove':
              this.$root.bus.emitAsync('appMove', jsonData.devId, jsonData.devType, jsonData.lng, jsonData.lat, jsonData.add, jsonData.reportTime)
              break
            case 'fenceWarn':
              //弹屏，播放声音
              this.$Notice.config({
                top: this.noticeBottom
              })
              let fenceType = jsonData.fenceType == '1' ? this.$t('gis_map.fence.setting.type.no_enter') : this.$t('gis_map.fence.setting.type.no_leave')
              if ('1' == this.$store.state.user.webWarnVoice) {
                this.playAudio()
              }
              let lang = this.$store.state.app.local
              let fenceClass = 'fence-warn'
              if (lang == 'en-US') {
                fenceClass = 'fence-warn-en'
              }

              let content = '<div class="' + fenceClass + '">' +
                '<p><span>' + this.$t('gis_map.warn.columns.name') + '：</span><span>' + jsonData.fenceName + '</span></p>' +
                '<p><span>' + this.$t('gis_map.warn.columns.type') + '：</span><span>' + fenceType + '</span></p>' +
                '<p><span>' + this.$t('gis_map.warn.columns.member') + '：</span><span>' + jsonData.appName + '</span></p>' +
                '<p><span>' + this.$t('gis_map.warn.columns.time') + '：</span><span style="color:red">' + jsonData.warnTime + '</span></p>' +
                '</div>'
              this.$Notice.warning({
                title: this.$t('gis_map.warn.tip_title'),
                desc: content,
                duration: 0,
                onClose: () => {
                  if ('1' == this.$store.state.user.webWarnVoice) {
                    this.stopAudio()
                  }
                }
              })

              break
            case 'alarm_device_online':
              this.alarmOnline(1, jsonData)
              break
            case 'alarm_device_offline':
              this.alarmOnline(0, jsonData)
              break
            case 'chatMessage':
              this.chatMessage(jsonData)
              break
            case 'sessionChange':
              let changeType = jsonData.changeType
              let sessionId = jsonData.sessionId
              //changeType 是修改的类型 2成员、名称都修改了 0名称 1成员
              if ('0' === changeType) {
                this.reloadOneSession(jsonData)
              } else {
                this.getParamByOpenId(sessionId).then(res => {
                  if (res) {
                    let id = res.id
                    if (id) {
                      this.initMember(id, jsonData)
                    }
                  }
                })
              }
              break
            case 'enterSession':
            case 'leaveSession':
              let newList = []
              let allUnRead = 0
              if (jsonData.openId) {
                let list = JSON.parse(JSON.stringify(this.$store.state.chatChannel.allChatList))
                getChannelGroup().then(res => {
                  let response = res.data
                  if (response.code !== 200) {
                    this.$Message.error(this.$t('operate_fail'))
                  } else {
                    for (let i = 0; i < response.data.length; i++) {
                      let itemOne = response.data[i]
                      allUnRead += itemOne.unread
                      let index = list.filter(item => item.openId === itemOne.openId)
                      if (index && index.length > 0) {
                        newList.push(index[0])
                      } else {
                        newList.push(itemOne)
                      }
                    }
                    if (remethod === 'enterSession') {
                      //加入会话时，如果是自己创建的，需要打开当前界面。
                      let createOpenId = localStorage.getItem('createSession_' + this.$store.state.user.sys_user_id)
                      if (createOpenId) {
                        if (createOpenId === jsonData.openId) {
                          localStorage.setItem('createSession_' + this.$store.state.user.sys_user_id, null)
                          let itemList = newList.filter(item => item.openId === createOpenId)
                          if (itemList && itemList.length > 0) {
                            itemList[0].haveSearchHistory = '0'
                            itemList[0].unread = 0
                            this.$store.commit('setCurrentLeftClick', itemList[0])
                            this.$store.commit('setMapClick', itemList[0])
                            this.$store.commit('setSplitScreenClick', itemList[0])

                          } else {
                            this.$store.commit('setChannelTotalUnread', allUnRead)
                          }
                        } else {
                          this.$store.commit('setChannelTotalUnread', allUnRead)
                        }
                      }
                    }
                    this.$store.commit('setAllChatList', newList)
                    this.$store.commit('setNeedToGet', Math.random())
                  }
                }).catch(err => console.log('err', err))
              }
              if (remethod === 'leaveSession') {
                //如果删除的会话和自己的所选的会话一致，需要刷掉。
                if (this.$store.state.chatChannel.currentLeftClick && this.$store.state.chatChannel.currentLeftClick.openId === jsonData.openId) {
                  this.$store.commit('setCurrentLeftClick', {})
                }
              }
              break
            case 'need_get_camera':
              queryRTMPByExten({
                exten: jsonData.exten,
                cameraIds: jsonData.ids,
                type: '2',
                userName: '',
                cameraAlarm: jsonData.alarmType
              }).then(res => {
                let response = res.data
                let _this = this
                if (response.code === 200) {
                  let data = response.data
                  if (data.length > 0) {
                    _this.$store.commit('setVideoModal', true)
                    _this.$store.commit('setModalCameras', data)
                  }
                }
              }).catch(err => {
                console.log(err)
              })
              break
            case 'currentCalls':
              let calls_ = jsonData.data
              if (calls_) {
                this.$store.commit('setCallListData', calls_)
              }
              break
            case 'monitorCount':

              this.videoCount = jsonData.data ? jsonData.data : 0
              this.$store.commit('setVideoCount', jsonData.data ? jsonData.data : 0)
              break
            case 'noanswers':
              let noanswers_ = jsonData.data
              if (noanswers_) {
                this.$store.commit('setNoAnswers', noanswers_)
              }
              break
            case 'upInfoCount':
              this.noReadCount = jsonData.data ? jsonData.data : 0
              break
            case 'notice':
              this.layerInfo(jsonData)
              break
            default:
              break
          }
        } else if (type === 'response') {//响应
          switch (remethod) {
            case 'HeatBeat':
              this.$store.commit('addHeart', 0)
              let tt = jsonData.timestamp
              if (tt) {
                window.time = tt
                sessionStorage.setItem('sysTime', tt + '')
              }
              this.serverTime = jsonData.currentTime
              break
            case 'login':
              let reasonCode = jsonData.retCode + ''
              if (reasonCode === '-8') {
                //重发登录命令
                let msg = '\'isNew\':\'1\''
                this.sendMsg({method: 'auth', msg: msg})
              }
              break
            case 'auth':
              if (jsonData.timestamp) {
                window.time = jsonData.timestamp
                sessionStorage.setItem('sysTime', jsonData.timestamp + '')
              }
              if (jsonData.retCode == 0) {
                this.$store.commit('setUserInline', true)
              }
              let send = localRead('sendNotice')
              if (send === '1') {
                this.sendMsg({method: 'notice'})
                localStorage.removeItem('sendNotice')
              }
              this.sendMsg({method: 'systemnotice'})
              //登录成功订阅消息
              this.sendMsg({method: 'subscribe', msg: '\'message\':\'all\''})
              this.sendMsg({method: 'getext'})
              this.sendMsg({method: 'playingbroad'})
              break
            case 'extens':
              extens = jsonData.extens
              this.setNoStatusDevices(extens)
              await this.loginExten(extens)
              // method = 'getconferencelist'
              // this.sendMsg({method})
              break
            case 'playingbroad':
              let data = jsonData.data
              let arr = []
              if (Array.isArray(data) && data.length > 0) {
                for (let i = 0; i < data.length; i++) {
                  let p = data[i]
                  let json = {}
                  json.id = p.taskId
                  json.startTime = p.time
                  json.name = p.taskName
                  arr.push(json)
                }
              }
              this.$store.commit('setPlayingBroad', arr)
              break
            case 'emp_timestamp':
              //修改分机状态
              //todo 重新登录
              //this.$Message.info(this.$t('exten_change'))
              //this.serverTime = jsonData.emp_timestamp
              break
            case 'subscribe':
              this.serverTime = jsonData.currentTime
              break
            case 'UserBroadcastSetVol':
              //this.$store.commit('setBroadVolume',true)
              break
            case 'UserBroadcastStart':
              let that = this
              setTimeout(function () {
                that.$store.commit('setBroadFresh', true)
              }, 1000)
              break
            case 'UserBroadcastStop':
              setTimeout(() => {
                this.$store.commit('setBroadFresh', true)
              }, 1000)
              break
            case 'UserBroadcastPause':
              setTimeout(() => {
                this.$store.commit('setBroadFresh', true)
              }, 1000)
              break
            case 'UserThreeway_Conferce':
              //重新获取会议
              method = 'getconferencelist'
              this.sendMsg({method})
              break
            case 'broadcast_stop':
              break
            case 'UserKickConference':
              /*let closeRoomName = this.$store.state.conferencejs.currRoom
            setTimeout(()=>{
              if (closeRoomName == this.$store.state.conferencejs.currRoom) {
                this.$store.dispatch('getRoom', closeRoomName).then(res => {
                  console.log('reload conference', res)
                  if (res) {
                    this.$root.bus.$emit('reloadConference', res.name)
                  }
                })
              }
            },5000)*/
              break
            case 'UserMuteConference':
              break
            case 'UserCancelMuteConferce':
              break
            case 'UserDeafConference':
              break
            case 'UserCancelDeafConferce':
              break
            case 'UserJoinConference':
              break
            case 'UserCreateStaticConference':
              //开始静态会议返回
              break
            case 'UserAlarmRecover':
              if (jsonData.retCode === '0') {
                if (this.alarmId) {
                  this.updateAlarm(this.alarmId)
                }
              }
              break
            case 'kick':
              this.$Message.info(this.$t('otherLogin'))
              setTimeout(() => {
                this.handleLogOut().then(() => {
                  this.closeWS()
                  window.sessionStorage.clear()
                  //window.localStorage.clear()
                  this.$router.push({
                    name: 'login'
                  })
                })
              }, 1500)
              break
            case 'notice':
              this.layerInfo(jsonData)
              break
            case 'invite':
              //会议室邀请
              let datas = jsonData.data
              let confName = jsonData.name
              this.$store.dispatch('getRoom', confName).then(room => {
                if (room) {
                  forEach(datas, d => {
                    if (d.name) {
                      room.addInviteParticipant(d)
                    }
                  })
                }
              })
              break
            case 'userOffline':
              let userId = jsonData.userId
              this.$store.dispatch('getRoom', this.$store.state.conferencejs.currRoom).then(room => {
                if (room) {
                  let participant = room.getParticipant(userId)
                  if (participant) {
                    participant.setStatus(this.$status.Offline)
                  }
                }
              })
              this.changeChatMemberState(userId, '0')
              break
            case 'userOnline':
              userId = jsonData.userId
              this.changeChatMemberState(userId, '1')
              break
            case 'unread':
              this.$store.commit('setChannelTotalUnread', jsonData.unreadCount ? jsonData.unreadCount : 0)
              break
            default:
              break
          }
        }
      },
      /**
       * 清理资源
       */
      cleanupOptimization() {
        this.debounceTimers.forEach(timer=>clearTimeout(timer))
        this.debounceTimers.clear()
        if (this.batchUpdateTimer) {
          clearTimeout(this.batchUpdateTimer)
        }
        if (this.uiDebounceTimer) {
          clearTimeout(this.uiDebounceTimer)
        }
        this.messageQueue = []
        this.deviceStatusBuffer.clear()
      },
      async addOutLine(number, status) {
        let showExten = this.$store.state.cacheData.devices ? this.$store.state.cacheData.devices[number] : null;

        if (!showExten) {
          let outExt = queryShowExtenInfo(this.$store.state.cacheData.extractDevices, number)
          if (outExt) {
            showExten = ''
          }
        }
        //存在
        if (!showExten && number != this.$store.state.user.displayNum) {
          //生成外线数据
          let name = this.$t('outLine')
          let callInfo = {
            exten: number,
            status: status,
            out: '2',
            deptid: '-1',
            deptname: name,
            cameraflag: '0',
            employeename: number,
            employeeid: '',
            position: '',
            order: '-5'
          }
          //同步等待数据返回
          let ass = await this.outLineInfo(number)
          let addFlag = true
          if (ass) {
            if (ass.hasOwnProperty('statuscode') && ass.statuscode === '000000') {
              let dataA = ass.data
              if (Array.isArray(dataA) && dataA.length > 0) {
                callInfo.deptname = ass.data[0].groupName
                callInfo.employeename = ass.data[0].name
              }
              let noData = ass.noAccess
              if (Array.isArray(noData) && noData.length > 0) {
                addFlag = noData.indexOf(number) < 0
              }
            }
          }
          if (addFlag) {
            let arr = this.$store.state.cacheData.extractDevices
            let pushFlag = true
            if (Array.isArray(arr) && arr.length > 0) {
              forEach(arr, item => {
                if (item.exten === callInfo.exten) {
                  pushFlag = false
                }
              })
            }
            if (pushFlag) {
              arr.push(callInfo)
              this.$store.commit('setExtractDevices', arr)
              let devices = this.$store.state.cacheData.devices
              devices[callInfo.exten] = callInfo
              this.$store.commit('setDevices', devices)
            }
          }
        }
      },
      callAnswerWeb(type) {
        this.showSoftWebrtc = false
        if (type === 'auto') {
          type = this.callType
        }
        if ('audio' === type && this.myWebRtc) {
          this.myWebRtc.JsSip_VoiceCall(this.callNumber, false)
        } else if ('video' === type && this.myWebRtc) {
          this.myWebRtc.JsSip_VoiceCall(this.callNumber, true)
        }
        let controlPhone;
        let control = this.$store.state.user.control
        if ("1" === control+'') {
          controlPhone = this.$store.state.user.left
        } else {
          controlPhone = this.$store.state.user.right
        }
        log_.log.sendCall(controlPhone, this.callNumber)
      },
      callRejectWeb() {
        this.showSoftWebrtc = false
        this.$store.commit('setIsOtherCall', '0')
        if (this.isFromMonitor) {
          this.$root.bus.$emit('refreshCamera', this.isFromMonitor)
        }
      },
      showAlarmVideo: function () {
        let showType = false
        let contentHeight = document.documentElement.clientHeight

        contentHeight = contentHeight / 3

        let contentWidth = document.documentElement.clientWidth / 3
        let strWindowFeatures = 'location=no,menubar=no,' +
          'status=no,resizable=no,titalebar=yes,width=' + contentWidth + ',height=' + contentHeight + ',top= ' + contentHeight * 1.7 + ',left=' + contentWidth * 1.9
        if (this.alarmOpenW !== '' && this.alarmOpenW !== undefined && this.alarmOpenW !== null) {
          if (this.alarmOpenW.name !== '') {
            this.alarmOpenW.close()
          }
        }
        if (!showType) {
          const routeData = this.$router.resolve({
            path: '/alarm_split_screen',
            query: {type: true}
          })
          let that = this
          setTimeout(function () {
            that.alarmOpenW = window.open(routeData.href, 'alarm_split_screen', strWindowFeatures)
          }, 1000)
          setTimeout(function () {
            if (that.alarmOpenW === '' || !that.alarmOpenW) {
              that.alarmOpenW = window.open(routeData.href, 'alarm_split_screen', strWindowFeatures)

            } else {
              if (that.alarmOpenW.name === '') {
                that.alarmOpenW = window.open(routeData.href, 'alarm_split_screen', strWindowFeatures)

              }
            }
          }, 1500)
        }
      },

      getMapDefaultSet() {
        getMapDefaultSet().then(res => {
          let response = res.data
          if (response.code === 200) {
            let json = {}
            json.center = 'shanghai'
            json.zoom = Number(response.data.level)
            json.maxZoom = Number(response.data.max)
            json.minZoom = Number(response.data.min)
            json.mapType = response.data.viewMode

            json.isOnline = response.data.mapMode
            json.ak = response.data.password
            json.point = {lng: response.data.lng, lat: response.data.lat}
            window.localStorage.removeItem('mapSet')
            localSave('mapSet', JSON.stringify(json))
          }
        }).catch(err => console.log('err', err))
      },
      getScreenInfo: function () {
        //存储屏幕尺寸
        let sysHeight = document.documentElement.clientHeight
        let sysWidth = document.documentElement.clientWidth
        this.setSysHeight(sysHeight)
        this.setSysWidth(sysWidth)
        this.noticeBottom = sysHeight - 300
      },
      visibleChange(val) {
        this.play = val
        if (!val) {
          this.videoExten = null
        }
      },
      alarmModal(exten) {
        this.avwidth = 900
        let sysWidth = document.documentElement.clientWidth || document.body.clientWidth
        if (sysWidth && sysWidth > 900) {
          this.openStation.left = sysWidth - 900
        }
        this.ph = 500
        let sysHeight = document.documentElement.clientHeight || document.body.clientHeight
        if (sysHeight) {
          this.ph = sysHeight / 3
        }
        if (this.ph < 508) {
          this.ph = 508
        }
        this.openStation.top = sysHeight - this.ph
        $('#video .ivu-modal-body').removeClass('display')
        $('#video .ivu-modal-content').removeClass('full')
        $('#video .ivu-modal-content').removeClass('min')
        $('#video .ivu-modal-content').removeClass('reset')
        $('#video .ivu-modal-content').removeClass('open')
        if (this.firstOpen) {
          $('#video .ivu-modal-content').addClass('open')
          this.firstOpen = false
        } else {
          if (!this.move) {
            $('#video .ivu-modal-content').addClass('open-tow')
            //this.firstOpen = true;
          } else {
            $('#video .ivu-modal-content').addClass('reset')
          }
        }

        //$('#video .ivu-modal').addClass('open')

        $('#video .ivu-modal-header').onclick = null
        this.vfull = false
        this.fullModal = 'md-expand'
        this.mid = true
        this.playFlash = new Date().getTime()
        if (this.showAlarm) {
          //this.showAlarm = false
          this.showAlarmVideo()
        } else {
          this.showAlarm = true
        }
        if (exten) {
          this.alarmOpen = true
        } else {
          this.alarmOpen = false
        }
      },
      moveStart() {
        this.move = true
      },
      minModal(event) {
        //最小化
        if (this.vfull) {

          this.vfull = false
          this.fullModal = 'md-expand'
          this.$nextTick(() => {
            $('#video .ivu-modal-content').removeClass('full')
            $('#video .ivu-modal-content').addClass('reset')
          })
        }
        this.avwidth = 200
        this.mid = false
        this.$nextTick(() => {
          $('#video .ivu-modal-content').removeClass('reset')
          $('#video .ivu-modal-body').addClass('display')
          $('#video .ivu-modal-content').addClass('min')
        })
        event.stopPropagation()
      },
      v_minModal(event) {
        this.vModalWidth = 200
        this.vmid = false
        this.$nextTick(() => {
          $('#videoModal .ivu-modal-content').removeClass('reset')
          $('#videoModal .ivu-modal-body').addClass('display')
          $('#videoModal .ivu-modal-content').addClass('min_left')
          // 手动触发Modal的handleClickModal方法，确保z-index是最新的
        })
        event.stopPropagation()
      },
      v_midModal(event) {
        $('#videoModal .ivu-modal-content').removeClass('min')
        $('#videoModal .ivu-modal-content').removeClass('min_left')
        $('#videoModal .ivu-modal-content').addClass('reset_left')
        $('#videoModal .ivu-modal-body').removeClass('display')
        //let left = window.innerWidth - 732
        //left = left / 2
        //$('#videoModal .ivu-modal-content').attr('style', 'left:' + left + 'px')
        this.vModalWidth = 732
        this.vmid = true
        event.stopPropagation()
      },
      maxModal(event) {
        //最大化
        $('#video .ivu-modal-content').removeClass('min')
        $('#video .ivu-modal-body').removeClass('display')
        if (this.vfull) {
          this.avwidth = 900
          this.ph = 500
          let sysHeight = document.documentElement.clientHeight || document.body.clientHeight
          if (sysHeight) {
            this.ph = sysHeight / 3
          }
          if (this.ph < 508) {
            this.ph = 508
          }
          $('#video .ivu-modal-content').removeClass('full')
          $('#video .ivu-modal-content').addClass('reset')
          this.vfull = false
          this.fullModal = 'md-expand'
        } else {
          $('#video .ivu-modal-content').addClass('full')
          this.avwidth = document.documentElement.clientWidth || document.body.clientWidth
          this.ph = (document.documentElement.clientHeight || document.body.clientHeight) - 100
          this.vfull = true
          this.fullModal = 'md-contract'
        }
        event.stopPropagation()
      },
      midModal(event) {
        //复原
        $('#video .ivu-modal-content').removeClass('min')
        $('#video .ivu-modal-content').addClass('reset')
        $('#video .ivu-modal-body').removeClass('display')
        this.avwidth = 900
        this.ph = 500
        let sysHeight = document.documentElement.clientHeight || document.body.clientHeight
        if (sysHeight) {
          this.ph = sysHeight / 3
        }
        if (this.ph < 508) {
          this.ph = 508
        }
        this.mid = true
        this.vfull = false
        this.fullModal = 'md-expand'
        event.stopPropagation()
      },
      resetAlarm(data, noticeName) {
        let port = ''
        if (data.alarm_data.indexOf('port=') !== -1) {
          let index = data.alarm_data.indexOf('port=')
          port = data.alarm_data.substring(index + 5)
          if (port.indexOf(';')) {
            port = port.split(';')[0]
          }
        }
        let method = 'alarm_recover'
        let ext = data.device_no
        let msg = '\'id\':\'' + data.id + '\',\'profile\':\'' + data.profile + '\',\'port\':\'' + port + '\',\'ext\':\'' + data.device_no + '\''
        this.sendMsg({method, ext, msg})
        this.$Notice.close(noticeName)
        this.alarmId = data.id

        //去除报警设备
        let alarms = this.$store.state.cacheData.alarmDevs
        alarms.remove(ext)
        this.$store.commit('setAlarmDevs', alarms)
      },
      resetIcon(data) {
        let ext = data.device_no
        let alarms = this.$store.state.cacheData.alarmDevs
        alarms.remove(ext)
        this.$store.commit('setAlarmDevs', alarms)
      },
      createWebSocket: function () {
        let ws = this.$store.state.websocket.WS
        if (ws === undefined) {
          let method = 'heartbeat'
          this.ws({method})
          //let that = this
          //重置计数器
          this.$store.commit('addHeart', 0)
        }
        //todo 先不使用新方法
        //this.$store.state.websocket.WS.onmessage(this.onHandle)
        this.$store.state.websocket.WS.onmessage(this.originalOnHandle)
      },
      initConfig(config) {
        let data = config ? config : {}
        let autoAccept = data.autoAccept
        let display_num = data.displayNum
        let theme = data.theme
        let acceptType = !data.acceptType ? 'auto' : data.acceptType;

        this.$store.commit('setTheme', theme);
        this.$root.bus.$emit('theme', theme)
        this.$store.commit('setAcceptType', acceptType);
        this.$root.bus.$emit('callType', acceptType)
        this.$root.bus.$emit('autoAnswer', autoAccept)
        this.$store.commit('setAutoAccept', autoAccept);
        this.$store.commit('setShowVideoBtn', data.showVideoBtn)

        if (display_num) {//没有主控台/会议室权限
          let row_col = display_num.split(',')//分隔为数组
          this.row = Number(row_col[0])
          this.col = Number(row_col[1])
          this.$store.commit('setRow_column_display_num', display_num)
        }
      },
      getSys() {
        getGeneral().then(res => {
          let response = res.data
          if (response.code === 200) {
            this.$store.commit('setSysGeneral', response.data)
            if (response.data) {
              forEach(response.data, item => {
                if (item.key === 'auto_close') {
                  this.autoCloseDialog = item.value === '1'
                }
                if (item.key === 'trigger_release_flag') {
                  this.autoRecover = item.value === '1'
                }
              })
            }
          }
        })
        findUserConfig().then(res => {
          let response = res.data

          if (response.code == 200) {
            //库中已有记录
            let data = response.data
            this.initConfig(data)
          }
        }).catch(err => {
          //设置默认的主题
          this.$root.bus.$emit('theme', 'black')
          console.log('err', err)
        })
      },
      answer(val) {
        this.showModal = !val
      },
      answerType(val) {
        this.callType = val
      },
      callAnswer(type) {
        if (this.myWebRtc !== undefined) {
          try {
            if (!this.callType) {
              return
            }
            if (this.callType === 'auto') {
              if (type === 'audio') {
                this.myWebRtc.VoiceAnswer(false)
              } else if (type === 'video') {
                this.myWebRtc.VoiceAnswer(true)
              }
            }
            if (type === 'auto') {
              if (this.callType === 'audio') {
                this.myWebRtc.VoiceAnswer(false)
              } else if (this.callType === 'video') {
                this.myWebRtc.VoiceAnswer(true)
              }
            }
          } catch (e) {
            //补偿挂断
            let method = 'handup'
            let ext = ''
            let control = this.$store.state.user.control
            if (control === '1') {
              ext = this.$store.state.user.left
            } else if (control === '2') {
              ext = this.$store.state.user.right
            }
            if (ext) {
              this.sendMsg({method, ext})
            }
            this.registerSIP()
          }
        }
        this.showSoft = false
      },
      callReject() {
        let ext = this.rejectExten
        if (this.myWebRtc !== undefined) {
          this.myWebRtc.JsSip_hangUpPhone()
        } else {
          //发送挂断指令
          let method = 'handup'
          if (ext) {
            this.sendMsg({method, ext})
          }
        }

        this.showSoft = false
        if (this.videoExten === ext && this.autoCloseDialog) {
          this.showAlarm = false
        }
      },
      hangup() {
        let method = 'handup'
        let ext = this.rejectExten
        if (ext) {
          this.sendMsg({method, ext})
        } else {
          this.$Message.info(this.$t('unSelectExt'))
          return
        }

        //挂断电话
        this.stopMyVideo()
        this.closeLayer()
      },
      doRealRegisterSIP(){
        //注册话机
        let control = this.$store.state.user.SIPControl
        let proto = window.location.protocol
        let _ws = 'ws://'
        //let port = this.$config.wsPort
        let port = this.$store.state.user.sipPort
        if (proto === 'https:') {
          _ws = 'wss://'
          //port = this.$config.wssPort
          port = this.$store.state.user.sipsPort
        }
        let _exten = ''
        let password = ''
        if (control === '1') {
          _exten = this.$store.state.user.left
          password = this.$store.state.user.lpd
        } else if (control === '2') {
          _exten = this.$store.state.user.right
          password = this.$store.state.user.rpd
        }
        if (!_exten || !password) {
          return
        }
        this.SIPControl = _exten
        //获取webrtc注册的地址信息
        let ip = this.$config.server_ip
        ip = ip.indexOf(':') > -1 ? ip.split(':')[0] : ip

        let WEBSocket = _ws + ip + ':' + port
        //注册话机
        try {
          let that = this

          this.myWebRtc.jssipAgent(WEBSocket, _exten, ip, password, (stream) => {
            this.openLayer(stream)
          }, (closed) => {
            this.stopMyVideo()
            this.closeLayer()
          }, (stream) => {
            this.sipVideoAnswer(stream)
          }, null, null, (val) => {
            that.register = val
            if (val) {
              that.$store.commit('setMyWebRtc', that.myWebRtc)
            }
          })

        } catch (e) {
          console.log('err', e)
        }
      },
      registerSIP() {
        let that = this;
        setTimeout(function (){
          that.doRealRegisterSIP();
        },1000)
      },
      openLayer(remoteStream) {
        let that = this
        if (!remoteStream) {
          //return null
          console.log('remote stream is null')
        }
        //this.closeLayer()
        //let dom = $('#'+this.webRtcVideoId)
        this.showWebVideo = true
        navigator.mediaDevices.getUserMedia({
          audio: false,
          video: true
        }).then(stream => {
          document.getElementById(that.myVideoId).srcObject = stream
          that.mediaTracks = document.getElementById(that.myVideoId).srcObject.getTracks()
        }).catch(error => {
          console.error('获取流失败:', error)
        })
        if (remoteStream) {
          document.getElementById(that.remoteVideo).srcObject = remoteStream
        }
      },
      sipVideoAnswer(stream) {
        document.getElementById(this.remoteVideo).srcObject = stream
      },
      closeLayer() {
        this.showWebVideo = false
      },
      stopMyVideo() {
        if (!this.myVideoId) {
          return
        }
        document.getElementById(this.myVideoId).pause()
        if (this.mediaTracks && this.mediaTracks.length > 0) {
          for (let i = 0; i < this.mediaTracks.length; i++) {
            this.mediaTracks[i].stop()
          }
          delete this.mediaTracks
          this.mediaTracks = null
        }
      },
      updateAlarm(aid) {
        let data = {
          id: aid,
          status: '1',
          remarks: '',
          alarm_level: '1',
          confirm_date: '0000-00-00 00:00:00',
          alarm_clear_date: '0000-00-00 00:00:00'
        }
        //封装日志参数
        alarmAck(data).then(res => {
          let response = res.data
          if (response.code == 200) {
            //this.$Message.success(this.$t('success'))
          }
        }).catch(err => console.log('err', err))

      },
      changeChatMemberState(userId, type) {
        let list = this.$store.state.chatChannel.allChatList
        if (!list || list.length === 0) {
          return
        }
        for (let i = 0; i < list.length; i++) {
          if (list[i].memberList && list[i].memberList.length > 0) {
            for (let j = 0; j < list[i].memberList.length; j++) {
              if (list[i].memberList[j].account.toLowerCase() === userId.toLowerCase()) {
                list[i].memberList[j].status = type
              }
            }
          }
        }
        this.$store.commit('setAllChatList', list)
      },
      initMember: function (id, jsonData) {
        let that = this
        let param = {
          id: id,
          status: '1'
        }
        getDetailById(param).then(res => {
          let response = res.data
          if (response.code === 200) {
            let returnList = response.data.member
            let item = null
            let list = []
            for (let i = 0; i < returnList.length; i++) {
              if (response.data.createUserId === returnList[i].id) {
                item = returnList[i]
                continue
              }
              list.push(returnList[i])
            }
            if (item) {
              list.unshift(item)
            }
            jsonData.newMemberList = list
            jsonData.sessionName = response.data.groupName
            that.reloadOneSession(jsonData)
          }
        }).catch(err => console.log('err', err))
      },
      alarmOnline(type, object) {
        if (!object || !object.missionName) {
          return
        }
        let content = this.$t('online')
        if ('0' === type + '') {
          //通知下线
          content = this.$t('extOffline')
        }

        let lang = this.$store.state.app.local
        let fenceClass = 'fence-warn'
        if (lang == 'en-US') {
          fenceClass = 'fence-warn-en'
        }
        object.createTime = object.createTime ? object.createTime : this.getNowTime()
        this.$Notice.close('forAlarmTip' + object.missionName)

        let htmlContent = '<div class="' + fenceClass + '">' +
          '<p><span>' + this.$t('status_tip.status') + '：</span><span style="color: red">' + content + '</span></p>' +
          '<p><span>' + this.$t('status_tip.device') + '：</span><span>' + object.missionName + '</span></p>' +
          '<p><span>' + this.$t('status_tip.time') + '：</span><span>' + object.createTime + '</span></p>' +
          '</div>'
        this.$Notice.warning({
          title: this.$t('status'),
          desc: htmlContent,
          name: 'forAlarmTip' + object.missionName,
          duration: 0,
          onClose: () => {
            this.closeEvent('1', object.noticeContent)
          }
        })
      },
      closeEvent(type, content) {
        if (type === '1') {
          //只有为1时，才是客户确认关闭了弹窗，其余都是非关闭。
          deleteNoticeByUserAndType({
            noticeType: '12',
            noticeContent: content,
            userId: this.$store.state.user.sys_user_id
          }).then(res => {
          }).catch(err => {
            console.log(err)
          })
        }
      },
      async loginExten(data) {
        let jsonExtens = produceLoginExten(data)
        //存一下系统内的分机数量。
        this.$store.commit('setExtCount', jsonExtens.extCount)
        this.$root.bus.$emit('extCount', jsonExtens.extCount)
        let extens = jsonExtens.extens
        //正在报警的分区
        let deptAlarmList = jsonExtens.deptAlarmList
        if (deptAlarmList) {
          this.$store.commit('copyIsAlarmDept', deptAlarmList)
        }
        let access = jsonExtens.access
        //重新缓存带状态的分机数据
        let mapForAllExt = {};
        let mapForRoleExt = {};
        if(extens && extens.length > 0){
          forEach(extens,item=>{
            mapForAllExt[item.exten] = item;
          })
        }
        if(access && access.length >0){
          if(access.length === extens.length){
            mapForRoleExt = JSON.parse(JSON.stringify(mapForAllExt));
          }else{
            forEach(access,item=>{
              mapForRoleExt[item.exten] = item;
            })
          }
        }
        this.cacheExtens(mapForAllExt)
        this.$store.commit('setRoleExten', mapForRoleExt)
        // this.cacheExtens({extens})
        // this.$store.commit('setRoleExten', access)
        this.$store.commit('setDeptId', '')
        //处理数据，生成分区
        // let groups = generArea(extens, this.deptList)
        // this.setGroups(groups)
        this.deptList = []
        getSysDept().then(res => {
          let response = res.data
          if (response.statuscode === '000000') {
            this.deptList = response.data
            this.setGroups(this.deptList)
          } else {
            console.log('get dept data error', response.message)
          }
        })
        //左右分机状态
        let leftStatus = getStatusByExten(extens, this.$store.state.user.left)
        let rightStatus = getStatusByExten(extens, this.$store.state.user.right)

        //记录左右话机状态
        if (leftStatus) {
          this.$store.commit('setLeftStatus', leftStatus.status)
        }
        if (rightStatus) {
          this.$store.commit('setRightStatus', rightStatus.status)
        }

        let outLines = jsonExtens.outLine
        if (Array.isArray(outLines) && outLines.length > 0) {
          let phone = ''
          forEach(outLines, item => {
            phone += item.number + ','
          })
          let tempOut = [].concat(outLines)
          //同步等待数据返回
          let outLineArr = []
          let ass = await this.outLineInfo(phone)
          if (ass) {
            if (ass.hasOwnProperty('statuscode') && ass.statuscode === '000000') {
              let dataA = ass.data
              if (Array.isArray(dataA) && dataA.length > 0) {
                for (let i = 0; i < dataA.length; i++) {
                  let dp = dataA[i]
                  for (let j = 0; j < outLines.length; j++) {
                    let op = outLines[j]
                    if (dp.phone === op.number && op.status === 'Talking') {
                      let callInfo = {
                        exten: dp.phone,
                        status: op.status,
                        out: '2',
                        deptid: '-1',
                        deptname: dp.groupName,
                        cameraflag: '0',
                        employeename: dp.name,
                        employeeid: '',
                        position: '',
                        order: '-5'
                      }
                      outLineArr.push(callInfo)
                      tempOut.splice(j, 1)
                    }
                  }
                }
                for (let i = 0; i < tempOut.length; i++) {
                  let op = tempOut[i]
                  let callInfo = {
                    exten: op.number,
                    status: op.status,
                    out: '2',
                    deptid: '-1',
                    deptname: this.$t('outLine'),
                    cameraflag: '0',
                    employeename: op.number,
                    employeeid: '',
                    position: '',
                    order: '-5'
                  }
                  if (op.status === 'Talking') {
                    outLineArr.push(callInfo)
                  }
                }
              } else {
                for (let i = 0; i < tempOut.length; i++) {
                  let op = tempOut[i]
                  let callInfo = {
                    exten: op.number,
                    status: op.status,
                    out: '2',
                    deptid: '-1',
                    deptname: this.$t('outLine'),
                    cameraflag: '0',
                    employeename: op.number,
                    employeeid: '',
                    position: '',
                    order: '-5'
                  }
                  if (op.status === 'Talking') {
                    outLineArr.push(callInfo)
                  }
                }
              }

            }
          } else {
            for (let i = 0; i < tempOut.length; i++) {
              let op = tempOut[i]
              let callInfo = {
                exten: op.number,
                status: op.status,
                out: '2',
                deptid: '-1',
                deptname: this.$t('outLine'),
                cameraflag: '0',
                employeename: op.number,
                employeeid: '',
                position: '',
                order: '-5'
              }
              if (op.status === 'Talking') {
                outLineArr.push(callInfo)
              }
            }
          }
          if (outLineArr.length > 0) {
            extens = extens.concat(outLineArr)
            extens.sort(sortOrder)
            this.$store.commit('setExtractDevices', outLineArr)
            this.$store.commit('setDevices', extens)
          }
        }
        this.$store.commit('setDeviceStatus', extens)

        //处理数据，生成分区
        this.deptList.forEach(item => {
          item.deptname = item.deptName
          item.deptid = item.id
          item.order = item.orderNum
          item.inline = 0
          item.offline = 0
        })
        this.deptList.push({'deptid': '-1', 'deptname': '全部分区', 'inline': 0, 'offline': 0, 'all': 0, 'order': 0})
        let groups = generArea(extens, this.deptList)
        this.setGroups(groups)
      },
      beforeunloadHandler() {
        if (this.register) {
          this.myWebRtc.JsSip_clearRegested() //取消注册
        }
        this.beforeUnload_time = new Date().getTime()
        //解决浏览器cookie中的token为空
        // if (this.$store.state.user.token != '' && this.$store.state.user.token != null) {
        //   setToken(this.$store.state.user.token)
        // }
        if (this.$store.state.app.local != '' && this.$store.state.app.local != null) {
          this.$store.commit('setLocal', this.$store.state.app.local)
        }
        this.doRrefresh()
      },
      getVideoPop(exten, cameraIds, type, userName, displayOut) {
        return new Promise((resolve, reject) => {
          let that = this
          let flag = false
          if (displayOut) {
            queryRTMPByPhone({phone: exten}).then(res => {
              let response = res.data
              that.cameras = []
              if (response.code === 200) {
                flag = true
                let data = response.data
                if (data !== null && data.length > 0) {
                  that.cameras = data
                  that.closeForExt = exten
                  that.cameras.exten = exten
                  that.alarmModal()
                }
              }
              resolve(flag)
            }).catch(err => {
              console.log(err)
              reject(flag)
            })
            return
          }
          queryRTMPByExten({exten, cameraIds, type, userName}).then(res => {
            let response = res.data
            that.cameras = []
            if (response.code === 200) {
              flag = true
              let data = response.data
              if (data !== null && data.length > 0) {
                that.cameras = data
                that.closeForExt = exten
                that.cameras.exten = exten
                that.alarmModal()
              }
            }
            resolve(flag)
          }).catch(err => {
            console.log(err)
            reject(flag)
          })
        })
      },
      showCameraPop(id) {
        queryCameraAddress(id).then(res => {
          let response = res.data
          if (response.code === 200) {
            if (response.data && response.data.length > 0) {
              this.cameras = response.data
              this.alarmModal()
            } else {
              console.log('query camera play address is empty')
            }

          }
        })
      },
      outLineInfo(phone) {
        let auth = this.$store.state.user.userAuth
        let userId = this.$store.state.user.userName
        if (phone && phone.endsWith(',')) {
          phone = phone.substring(0, phone.length - 1)
        }
        return new Promise((resolve, reject) => {
          phoneInfo({auth, phone, userId}).then(res => {
            let response = res.data
            resolve(response)
          }).catch(error => {
            console.log(error)
            reject(error)
          })
        })
      },
      unloadHandler() {
        this.gap_time = new Date().getTime() - this.beforeUnload_time
        if (this.gap_time <= 5) {
          if (this.alarmOpenW !== '' && this.alarmOpenW !== undefined && this.alarmOpenW !== null) {
            if (this.alarmOpenW.name !== '') {
              this.alarmOpenW.close()
            }
          }
          this.$store.commit('setWindowClear', true)
          setToken('')
          //window.localStorage.clear()
        }
      },
      callNoAnswer() {
        let ext = this.callNoExten
        let isLeft = this.$store.state.user.SIPControl
        let control = this.$store.state.user.control
        if (!this.$store.state.clickData.autoAccept && (isLeft === '1' || isLeft === '2') && (control === "1" || control === "2")) {
          window.toCall(ext, '')
          this.callNo = false
          return
        }
        if (this.$store.state.clickData.autoAccept && (isLeft === '1' || isLeft === '2') && (control === "1" || control === "2")) {
          window.toCall(ext, 'auto')
          this.callNo = false
          return
        }
        let method = 'call'
        this.sendMsg({method, ext})
        this.callNo = false
      },
      callIgnoral() {
        this.callNo = false
      },
      changeCallNo(val) {
        if (!val) {
          this.changeReadStatus()
        }
      },
      changeReadStatus() {
        let that = this
        updateNoAnswerIsRead(this.callNoId).then(res => {
          let response = res.data
          if (response.statuscode !== '000000') {
            console.log('error', response.statusmessage)
          }
          that.$root.bus.$emit('reflashData', true)
        })
      },
      async testSupportVideo() {
        let supportVideoConf = this.$store.state.user.videoConf && this.$store.state.user.videoConf > 0;
        let supportSip = this.$store.state.user.SIPControl == 1 || this.$store.state.user.SIPControl == 2
        //只检测sip 注册或者有视频会议权限的情况下
        if (!supportSip && !supportVideoConf) {
          return
        }
        let that = this
        let supportAudio = false
        try {
          await navigator.mediaDevices.getUserMedia({
            video:false,
            audio:true
          }).then(stream=>{
            if (stream) {
              supportAudio = true
              let trancks = stream.getTracks()
              for (let i = 0; i < trancks.length; i++) {
                trancks[i].stop()
              }
            } else {
              supportAudio = false
            }
          }).catch(err=>{
            console.error('system not support audio',err)
            supportAudio = false
          })
          await navigator.mediaDevices.getUserMedia({
            video: true,
            audio: false
          }).then(stream => {
            if (stream) {
              that.supportVideo = true
              let trancks = stream.getTracks()
              for (let i = 0; i < trancks.length; i++) {
                trancks[i].stop()
              }
            } else {
              that.supportVideo = false
            }
          }).catch(error => {
            console.error('获取视频流失败', error)
            that.supportVideo = false
          })
        }catch (e) {
          console.error(e)
          supportAudio = false
          this.supportVideo = false
        }

        if (!supportAudio || !this.supportVideo) {
          let mes = this.$t('meeting.setting.check')
          if (!supportAudio) {
            mes+=this.$t('meeting.setting.mic')
          }
          if (!this.supportVideo) {
            mes += (supportAudio ? '' : '、') + this.$t('meeting.setting.camera')
          }
          mes+=this.$t('meeting.setting.permission')
          this.$Message.warning({
            content: mes,
            duration: 0,
            closable: true,
          })
        }

      },
      checkPwd() {
        let userId = this.$store.state.user.userName
        if (userId !== 'admin') {
          return
        }
        let that = this
        checkPwd().then(res => {
          let response = res.data
          if (response.code !== 200) {
            that.showPwd = true
          }else {
            if (response.data.isDefault) {
              that.showPwd = true
            }
          }
        })
      },
      //修改密码
      changePwd() {
        this.showPwd = false
        this.showChangePwd = true
      },
      submitPwd() {
        if (this.isLoading) {
          return
        }
        if (!this.pwdForm.newPwd) {
          this.$Message.warning(this.$t('new_pass_placeHolder'))
          return
        }
        if (!this.pwdForm.newPwdTwice) {
          this.$Message.warning(this.$t('again_pass_placeHolder'))
          return
        }
        if (this.pwdForm.newPwdTwice !== this.pwdForm.newPwd) {
          this.$Message.warning(this.$t('password_error2'))
          return
        }
        this.isLoading = true
        let that = this
        let confirmPassword = this.pwdForm.newPwdTwice
        let username = this.$store.state.user.userName
        let oldPassword = this.$store.state.user.password
        let newPassword = this.pwdForm.newPwdTwice;
        updatePassword({confirmPassword, username, oldPassword, newPassword}).then(res => {
          let response = res.data
          if (response.code === 200) {
            that.$Message.success(that.$t('success'))
            that.showChangePwd = false
            that.isLoading = false
          } else {
            that.isLoading = false
            that.$Message.error(response.msg)
          }
        })
      },
      //关闭弹窗
      rejectVcs() {
        this.showVcsInvite = false
        this.sendRejectVcs(this.inviteInfo.roomName, this.inviteInfo.roomNum)
      },
      acceptVcs() {
        let params = {confName: this.inviteInfo.roomName, confNum: this.inviteInfo.roomNum}
        this.showVcsInvite = false
        //路由跳转到会议室界面
        if (this.currRouteName == 'conference') {
          this.$root.bus.$emit('joinVcs', params)
        } else {
          this.$router.push({name: 'conference', params: params})//传入参数
        }
      },
      sendRejectVcs(roomName, roomNum) {
        let method = 'reject_vcs'
        let msg = '\'confName\':\'' + roomName + '\',\'confnum\':\'' + roomNum + '\''
        this.sendMsg({method, msg})
      },
      getDept() {
        this.deptList = []
        getSysDept().then(res => {
          let response = res.data
          if (response.statuscode === '000000') {
            this.deptList = response.data
          } else {
            console.log('get dept data error', response.message)
          }
        })
      },
      getQueueExten(queueNum, callback) {
        getQueueExtens(queueNum).then(res => {
          let response = res.data
          if (response.statuscode === '000000') {
            this.queueExtens = []
            let re = response.data
            for (let i = 0; i < re.length; i++) {
              this.queueExtens.push(re[i].exten)
            }
            callback(this.queueExtens)
          }
        })
      },
      replaceClassName(className) {
        localStorage.setItem('className', className)
        localStorage.setItem('theme', className)
        document.documentElement.setAttribute('theme', className)
        this.$nextTick(() => {
          $('body ').removeClass('black')
          $('body ').removeClass('blue')
          $('body ').removeClass('white')
          $('body ').addClass(className)
        })
      },
      //分屏监控store数据
      splitScreenMonitor(val, nval, store) {
        val = JSON.stringify(val)
        nval = JSON.stringify(nval)
        let monitorOpen = localStorage.getItem('monitorOpen')
        if (val !== nval && monitorOpen !== '' && monitorOpen !== undefined && monitorOpen) {
          store.type = 1
          if (this.yuneasyStore === '' || this.yuneasyStore === undefined) {
            this.yuneasyStore = new BroadcastChannel('yuneasyStore')
          }
          this.yuneasyStore.postMessage(store)
        }
      },

      yuneasyStoreShow: function () {
        //将父页面的store数据传递到子页面
        let bc = new BroadcastChannel('yuneasyStore')
        let store = {
          type: 1,
          sys_user_id: this.$store.state.user.sys_user_id,
          groups: this.$store.state.cacheData.groups,
          userId: this.$store.state.user.userId,
          userName: this.$store.state.user.userName,
          devices: this.$store.state.cacheData.devices,
          sysHeight: this.$store.state.app.sysHeight,
          sysWidth: this.$store.state.app.sysWidth,
          cameraGroupName: this.$store.state.clickData.cameraGroupName,
          mapType: this.$store.state.clickData.mapType,
          editMap: this.$store.state.clickData.editMap,
          noBroad: this.$store.state.cacheData.noBroad,
          control: this.$store.state.user.control,
          left: this.$store.state.user.left,
          right: this.$store.state.user.right,
          sysGeneral: this.$store.state.cacheData.sysGeneral,
          confno: this.$store.state.conferencejs.confno,
          invateOutLines: this.$store.state.cacheData.invateOutLines,
          mapGroupName: this.$store.state.clickData.mapGroupName,
          ext: this.$store.state.clickData.ext,
          status: this.$store.state.clickData.status,
          //  myWebRtc:this.$store.state.cacheData.myWebRtc,
          SIPControl: this.$store.state.user.SIPControl,
          mapDevice: this.$store.state.clickData.mapDevice,
          autoAccept: this.$store.state.clickData.autoAccept,
          leftStatus: this.$store.state.cacheData.leftStatus,
          rightStatus: this.$store.state.cacheData.rightStatus,
          ports: this.$store.state.cacheData.ports,
          httpsPorts: this.$store.state.cacheData.httpsPorts,
          token: this.$store.state.token,
          hangExten: this.$store.state.clickData.hangExten,
          alarmDevs: this.$store.state.cacheData.alarmDevs,
          hangup: this.$store.state.clickData.hangup,
          mapGroupId: this.$store.state.clickData.mapGroupId,
          clickMapLeft: this.$store.state.clickData.clickMapLeft,
          local: this.$store.state.app.local,
          documentTitle: this.$t('document_title'),
          cameras: this.cameras,
          play: this.play,
          playFlash: this.playFlash,
          ph: this.ph
        }
        bc.postMessage(store)
      },
      layerInfo(message) {
        let json = this.generatorJSON(message.data)
        if (json) {
          let type = json.type
          if (type === 0 || type === 1 || type === 2 || type === 10 || type === 13) {
            this.$Notice.warning({
              title: json.title,
              desc: json.content,
              duration: 0,
            })
          } else if (type === 4 || type === 8 || type === 6 || (type === 11 && !json.sysUserId)) {
            this.showSystem = false
          } else if (type === 3 || type === 5 || type === 7 || type === 11) {
            this.showSystem = true
            if (type === 3) {
              this.backMsg = this.$t('system_notice.operator.backing')
            } else if (type === 5) {
              this.backMsg = this.$t('system_notice.operator.reset')
            } else if (type === 7) {
              this.backMsg = this.$t('system_notice.operator.reboot')
            } else if (type === 11) {
              this.backMsg = this.$t('system_notice.operator.upgrade')
            }
          } else if (type === 12) {
            json.missionName = json.noticeContent.split('@')[0]
            this.alarmOnline(json.linkType, json)
          }
        }
      },
      //获取当前时间
      getNowTime: function () {
        let date = new Date()
        let month = date.getMonth() + 1
        let strDate = date.getDate()
        let hour = date.getHours()
        let second = date.getSeconds()
        let minute = date.getMinutes()
        if (hour >= 0 && hour <= 9) {
          hour = '0' + hour
        }
        if (second >= 0 && second <= 9) {
          second = '0' + second
        }
        if (minute >= 0 && minute <= 9) {
          minute = '0' + minute
        }
        if (month >= 1 && month <= 9) {
          month = '0' + month
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = '0' + strDate
        }
        let currentDate = date.getFullYear() + '-' + month + '-' + strDate
          + ' ' + hour + ':' + minute + ':' + second
        return currentDate
      },
      generatorJSON(data) {
        if (data === null || data === 'null') {
          return null
        }
        let json = {}
        let noticeType = data.noticeType
        //构建内容
        let html = ''
        let ahtml = ''
        let lang = this.$store.state.app.local
        let fenceClass = 'fence-warn'
        if (lang == 'en-US') {
          fenceClass = 'fence-warn-en'
        }
        if (noticeType === 0) {
          json.title = this.$t('system_notice.title.warn')
          ahtml = '<p style="width: inherit;text-indent: 2em;"><a href="javascript:void(0);" onclick="toControlData()" style="text-decoration:underline;">' + this.$t('system_notice.turnToClean') + '</a></p><br/>'
          if (data.linkType !== 1) {
            ahtml = ''
          }
          html = '<div style="margin:10px 5px;"><p style="text-indent: 2em">' + data.noticeContent + '</p><br/>' +
            ahtml +
            '<p style="width: inherit;float: right">' + data.updateTime + '</p></div>'
        } else if (noticeType === 1) {
          json.title = this.$t('system_notice.title.delete')
          html = '<div style="margin:10px 5px;"><p style="text-indent: 2em">' + data.noticeContent + '</p><br/>' +
            ahtml +
            '<p style="width: inherit;float: right">' + data.updateTime + '</p></div>'
        } else if (noticeType === 2) {
          let dn = data.noticeContent
          if (dn && dn.endsWith(',')) {
            dn = dn.substring(0, dn.length - 1)
          }
          json.title = this.$t('system_notice.title.selfCheck')
          ahtml = '<p style="width: inherit;text-indent: 2em;"><a href="javascript:void(null);" onclick="openSelfResult()">' + this.$t('system_notice.turnToDetail') + '</a></p><br/>'
          html = '<div style="margin:10px 5px;"><p style="text-indent: 2em">' + this.$t('system_notice.self.abnormal')+" " + this.$t('system_notice.self.device') + '：</p><p style="text-indent: 2em;word-break: break-all;">' + dn + '</p><br/>' +
            ahtml
          this.extens = dn
        } else if (noticeType === 3) {

        } else if (noticeType === 10) {
          json.title = this.$t('system_notice.title.change')
          ahtml = '<p style="width: inherit;text-indent: 2em;"><a href="javascript:void(0);" onclick="toControlHAStatus()" style="text-decoration:underline;">' + this.$t('system_notice.turnToHA') + '</a></p><br/>'
          if (data.linkType !== 1) {
            ahtml = ''
          }
          html = '<div style="margin:10px 5px;"><p style="text-indent: 2em">' + data.noticeContent + '</p><br/>' +
            ahtml +
            '<p style="width: inherit;float: right">' + data.updateTime + '</p></div>'
        } else if (noticeType === 12) {
          json.noticeContent = data.noticeContent
          json.createTime = data.createTime
          json.linkType = data.linkType
        } else if (noticeType === 13) {
          json.title = this.$t('system_notice.title.alarm')
          html = '<div class="' + fenceClass + '">' +
            '<p><span style="white-space: nowrap;">' + this.$t('status_tip.content') +
            '：</span><span style="width: 75%;display: inline-block;word-break: break-all;overflow-wrap: break-word;">' + data.noticeContent + '</span></p>' +
            '<p><span>' + this.$t('status_tip.time') + '：</span><span>' + data.createTime + '</span></p>' +
            '</div>'
        }
        json.content = html
        json.type = noticeType
        return json
      },
      closeResult(value) {
        this.showSelfResult = value
      },
      doRrefresh() {
        localStorage.setItem('monitorOpen', false)
        //let destroy = this.$store.state.cacheData.destroy
        if (this.$store.state.websocket.WS) {
          let method = 'logout'
          this.sendMsg({method})
          this.closeWS()
        }
        if (this.register) {
          this.myWebRtc.JsSip_clearRegested() //取消注册
        }
        /*if (this.interval) {
        clearInterval(this.interval)
        this.interval = undefined
      }*/
        if (this.reConnect) {
          clearInterval(this.reConnect)
          this.reConnect = undefined
        }
      },
      //链接视频会议系统
      connectVCS() {
        let protols = this.$config.wsProto
        let vip = this.$store.state.user.videoSystemIp
        let vport = this.$store.state.user.videoSystemPort
        let vp = this.$store.state.user.videoConf
        if (vp && parseInt(vp) > 0 && vip) {
          let url = protols + '://' + vip + ':' + vport + '/vcs/call'
          connectVCS(url, () => {
            window.cws.onmessage(this.handleMessage, true)
          })
        }
      },
      handleMessage(message) {
        let parsedMessage = JSON.parse(message.data)
        let that = this
        this.$options.filters['handle'](that, parsedMessage.method, parsedMessage)
      },
      changeColor(flag) {

        let fff = document.getElementById('main_page')
        if (flag) {
          fff.style.boxShadow = 'inset 0 0 102px rgb(233 4 4)'
        } else {
          fff.style.boxShadow = 'unset'
        }
        flag = !flag
        let that = this
        if(that.colorTimer){
          clearTimeout(that.colorTimer)
          that.colorTimer = null;
        }
        that.colorTimer = setTimeout(function () {
          that.changeColor(flag)
        }, 1000)
      },
      toUploadLicense() {
        let url = this.$config.sysUrl
        let lang = this.$i18n.locale
        let login_name = encodeURIComponent(this.$store.state.user.userName)
        let login_pass = encodeURIComponent(this.$store.state.user.password)
        let uri = 'transferLogin?lang=' + lang + '&token=' + getToken() + '&userAccount=' + login_name+ '&timeStamp=' + login_pass;
        if (url === undefined || url === '') {
          url = window.location.protocol + '//' + window.location.host + '/epx/#' + uri
        } else {
          url = url.replace("control","epx/#")
          url = url.replace("YunEasy/upload","epx/#")
          url = url + uri
        }

        localStorage.removeItem("user");
        window.sessionStorage.clear()
        window.location.href=url;
      },
    },
    created() {
      //永远放第一位
      let serverTime = this.$store.state.app.serverTime
      if (serverTime) {
        sessionStorage.setItem('sysTime', serverTime)
        window.time = serverTime
      }
      //
      this.initDebouncedMethods()

      let params = {
        success: (config) => {
          if (!config.roles || config.roles.length <= 0) {
            this.$Message.warning(this.$t('no_broad_menu'))
            let that = this
            setTimeout(function (){
              setToken('')
              setBase64Token('')
              that.$store.commit('setToken', '')
              that.$router.push({
                name: 'login'
              })
            },1000)
            return
          }
          //是否支持级联，获取级联系统。
          let role = localRead('role')
          if (role && role.indexOf('all_permissions.cascade') != -1) {
            getGradeSystemInfo().then((res) => {
              let data = res.data
              if (data.code === 200) {
                that.$store.commit('setGradeSystemInfo', data.data)
              }
            })
          }
          this.registerSIP()
          this.createWebSocket()
          if (this.turnPage) {
            let homeName = this.$store.state.user.homeName
            if (homeName && homeName != this.$config.homeName && homeName != 'stand_page') {
              this.$router.push({
                name: homeName,
                params:{show:true}
              })
            }else {
              this.isLoad = true
            }
          }else {
            this.isLoad = true
          }
          //判断是非在无人值守
          if (this.$store.state.user.isUnattended) {
            this.$store.commit('setDestroy', false)
            this.$router.push({
              name: 'stand_page',
              params: {number: this.$store.state.user.isUnattended}
            })
            return
          }
          //测试是否支持视频流
          this.testSupportVideo()
          this.connectVCS()
          //判断是否需要提醒license要过期
          let warnDay = config.licenseWarnDay || 0
          if (warnDay > 0) {
            this.$Message.warning({content:this.$t('license_warn',{day:warnDay}), duration: 5})
          }
        },
        fail: (code) => {
          if (code == -100) {
            this.$Message.warning({content:this.$t('noLicense'), duration: 5})
          }
          if (code == -101) {
            this.$Message.warning({content:this.$t('expire'), duration: 5})
          }
          setTimeout(()=>{
            if (code == -100 || code == -101) {
              this.toUploadLicense()
              return
            }
            setToken('');
            setBase64Token('')
            this.$store.commit('setToken', '')
            this.$router.push({
              name: 'login'
            })
          },500)
        }
      }
      this.userConfig(params)
      this.yuneasyWS = new BroadcastChannel('yuneasyWS')
      let that = this
      //接收分屏页面的websocket消息
      this.yuneasyWS.onmessage = function (e) {
        var data = e.data
        let control = that.$store.state.user.control
        if (data.method === 'otherToCall' && control === '1') {
          window.toCall(data.ext, data.type, data.videoid)
          return
        }
        if (data.method === 'mulconference') {
          that.$router.push({name: 'conference'})//传入参数
        }
        that.sendMsg(data)
      }

      //接收分屏页面的store数据
      if (this.yuneasyStore === '' || this.yuneasyStore === undefined) {
        this.yuneasyStore = new BroadcastChannel('yuneasyStore')
      }

      let userName = that.$store.state.user.userName
      function close(keys) {
        if (keys) {
          keys.forEach(it => {
            stopRTMP({processId: it, userName: userName})
          })
        }
        return keys
      }
      const apply = debounce(close, 100, false)
      this.yuneasyStore.onmessage = function (e) {
        var data = e.data
        if (data.type === 2) {
          data.list.forEach(temp => {
            if (temp.name === 'setInvateOutLinesS') {
              let invateExtens = that.$store.state.cacheData.invateOutLines
              let add = true
              let extens = temp.sel.split(',')
              if (Array.isArray(extens)) {
                extens.push(temp._control)
              }
              if (invateExtens.length > 0) {
                for (let i = 0; i < invateExtens.length; i++) {
                  let hconfname = invateExtens[i].confname
                  let hextens = invateExtens[i].extens
                  if (hconfname === confname) {
                    invateExtens[i].extens = getUnion(hextens, extens)
                    add = false
                  }
                }
              }
              if (add) {
                let json = {confname: temp.confname, extens: extens}
                invateExtens.push(json)
              }
              that.$store.state.conferencejs.confno = temp.confname
            } else {
              that.$store.commit(temp.name, temp.value)
            }
          })
        }

        if (data.type === 3) {
          // that.$router.push({name: 'control'})//传入参数
          // that.$store.commit('setMenuId', '1')
          that.yuneasyStoreShow()
        }
        //视频联动页面关闭回调
        if (data.type === 4) {
          let keys = data.plays
          apply(keys)
          that.visibleChange(false)
          that.videoExten = null
          that.showAlarm = false
        }
        if (data.type === 'method') {
          if (e.data.data == null) {//空数据只调用方法
            that.$root.bus.$emit(e.data.name, 1)
          }
        }
        if (e.data.type === 'chatMessage') {
          if (e.data.isSelf) {
            that.sendSelfMsg(e.data.param)
            return
          }
          if (e.data.param && e.data.param.type === 'splitScreenClick') {
            that.$store.commit('setSplitScreenClick', e.data.param.value)
            return
          }
          that.sendMsg(e.data.param)
        }

        if (e.data.type == 'storeMapDataUpdate') {
          //更新主数据
          let data = e.data.param
          if (data && data.mapGroupId) {
            that.$store.commit('setMapGroupId', data.mapGroupId)
          }
          if (data && data.mapGroupName) {
            that.$store.commit('setMapGroupName', data.mapGroupName)
          }
        }

      }

      //新建一个webrtc
      let destroy = this.$store.state.cacheData.destroy
      if (destroy) {
        this.myWebRtc = new MyWebrtc()
      } else {
        this.$store.commit('setDestroy', true)
      }
      this.LogoPath().then(r=>{
        let txt = this.$store.state.app.txtLogo
        if (txt || !this.$store.state.app.isOpenLogo) {

        } else {
          txt = this.$t('document_title')
        }
        window.document.title = txt
      })
      //获取分区
      this.getDept()
      this.getMapDefaultSet()
      this.getScreenInfo()
      this.getSys()
      let uId = this.$store.state.user.userId


      //检测系统密码
      this.checkPwd()

    },
    filters: {
      handle(that, method, message) {
        const strategies = {
          'NoAuth': (event, message) => {
            //event.$Message.info('No Auth!')
            console.log('video conference Auth error!')
          },
          'ok': (event, message) => {

          },
          'joinRoom': (event, message) => {

          },
          'leaveRoom': (event, message) => {

          },
          'noLimits': (event, message) => {
            event.$Message.warning(event.$t('video_conference_no_limit'))
          },
          'kmsConnected': (event, message) => {
            let isConnected = message.connected
            event.$store.commit('setKmsConnected', isConnected)
          },
          'kickRoom': (event, message) => {

          },
          'startRecord': (event, message) => {
            //设置会议室为录像状态
            event.$store.dispatch('getRoom', message.roomName).then(room => {
              if (room) {
                if (!room.record) {
                  room.aysncInfo('', 'startrecord')
                }
                room.record = true
              }
            })
            //event.$Message.info(event.$t('meeting.record.pre')+message.roomName+event.$t('meeting.record.start'))
          },
          'stopRecord': (event, message) => {
            event.$store.dispatch('getRoom', message.roomName).then(room => {
              if (room) {
                room.record = false
                room.aysncInfo('', 'stoprecord')
              }
            })
            //event.$Message.info(event.$t('meeting.record.pre')+message.roomName+event.$t('meeting.record.stop'))
          },
          'muteVideo': (event, message) => {
            event.$store.dispatch('getRoom', message.roomName).then(room => {
              if (room) {
                let participant = room.getParticipant(message.name)
                participant ? participant.muteVideo = true : null
              }
            })
          },
          'unMuteVideo': (event, message) => {
            event.$store.dispatch('getRoom', message.roomName).then(room => {
              if (room) {
                let participant = room.getParticipant(message.name)
                participant ? participant.muteVideo = false : null
              }
            })
          },
          'mute': (event, message) => {
            event.$store.dispatch('getRoom', message.roomName).then(room => {
              if (room) {
                let participant = room.getParticipant(message.name)
                participant ? participant.setMute(true) : null
                let currUser = event.$store.state.user.userName
                if (participant && participant.type == 6 && currUser == participant.name) {
                  participant.mutedAudio(false)
                }
                room.aysncInfo(message.name, 'mute')
              }
            })
          },
          'unMute': (event, message) => {
            event.$store.dispatch('getRoom', message.roomName).then(room => {
              if (room) {
                let participant = room.getParticipant(message.name)
                participant ? participant.setMute(false) : null
                let currUser = event.$store.state.user.userName
                if (participant && participant.type == 6 && currUser == participant.name) {
                  participant.mutedAudio(true)
                }
                room.aysncInfo(message.name, 'unMute')
              }
            })
          },
          'muteAll': (event, message) => {
            event.$store.dispatch('getRoom', message.roomName).then(room => {
              if (room) {
                room.muteAll()
                let participant = room.getParticipant(event.$store.state.user.userName)
                if (participant) {
                  participant.mutedAudio(false)
                }
              }
            })
          },
          'unMuteAll': (event, message) => {
            event.$store.dispatch('getRoom', message.roomName).then(room => {
              if (room) {
                room.unMuteAll()
                let participant = room.getParticipant(event.$store.state.user.userName)
                if (participant) {
                  participant.mutedAudio(true)
                }
              }
            })
          },
          'BadRequest': (event, message) => {

          },
          'exist': (event, message) => {
            let code = message.code
            if (code == 109) {
              event.$Message.warning(message.share+event.$t('meeting.share.sharing'))
            }
          },
          'notJoin': (event, message) => {
            //event.$Message.warning('未加入会议室')
          },
          'notMeeting': (event, message) => {

          },
          'pong': (event, message) => {
            console.log('server  pong!')
          },
          'existingParticipants': (event, message) => {
            //存在的成员，加入会议室收到消息，可以直接解析成需要渲染的成员
            let roomName = message.roomName
            event.$store.dispatch('getRoom', roomName).then(res => {
              if (res) {
                if (message.data && message.data.length > 0) {
                  forEach(message.data, d => {
                    res.changeVcsMember(d);
                  })
                }
              }
            })

          },
          'newParticipantArrived': (event, message) => {
            //新加入视频会议成员
            let roomName = message.roomName
            let memberName = message.name
            event.$store.dispatch('getRoom', roomName).then(res => {
              if (res) {
                if (res.forceRecord && res.forceRecord !== res.record) {
                  event.$root.bus.$emit('autoRecord', res.forceRecord)
                }
                res.changeVcsMember({
                  name: message.name,
                  type: message.pType,
                  mute: false,
                  muteVideo: message.muteVideo,
                  shareName: message.shareName
                })
                res.aysncInfo(message.pType != 'SCREEN'?message.name:message.shareName, message.pType != 'SCREEN'?'enter':'startShare');

              }
            });
            if(message.pType === 'CAMERA'){
              that.$root.bus.$emit('meetingChange')
            }
          },
          'participantLeft': (event, message) => {
            //视频会议成员离会
            let roomName = message.roomName
            event.$store.dispatch('getRoom', roomName).then(room => {
              if (room) {
                room.aysncInfo(message.pType != 'SCREEN'?message.name:message.shareName, message.pType != 'SCREEN'?'leave':'endShare')
                room.vcsMemberLeave({name: message.name, type: message.pType})
              }
            })

          },
          'receiveVideoAnswer': (event, message) => {
            let roomName = message.roomName
            event.$store.dispatch('getRoom', roomName).then(room => {
              if (room) {
                room.vcsAnswer(message)
              }
            })

          },
          'iceCandidate': (event, message) => {
            let roomName = message.roomName
            event.$store.dispatch('getRoom', roomName).then(room => {
              if (room) {
                room.vcsCandidate(message, 0)
              }
            })

          },
          'participants': (event, message) => {
            //点击会议室，收到该会议室中存在的视频成员
            let roomName = message.roomName
            event.$store.dispatch('getRoom', roomName).then(room => {
              if (room) {
                if (message.data && message.data.length > 0) {
                  forEach(message.data, d => {
                    room.changeVcsMember(d)
                  })
                }
              }
            })

          },
          'roomInfos': (event, message) => {
            let rooms = event.$store.state.conferencejs.rooms
            if (rooms) {
              if (!message.data || message.data.length <= 0) {
                return
              }
              let all = message.data.map(item => item.roomName)
              forEach(message.data, p => {
                let roomName = p.roomName
                forEach(rooms, r => {
                  if (r.name === roomName) {
                    r.addVcsMember(p)
                    let index = all.indexOf(roomName)
                    r.record = p.record
                    all.splice(index, 1)
                  }
                })
              })
              //剩余的会议属于临时会议
              if (all.length > 0) {
                forEach(message.data, p => {
                  forEach(all, l => {
                    if (p.roomName === l) {
                      let room = new Room(p.roomName, p.roomNo, p.roomNo, '', '', '', true, p.record, '', true)
                      event.$store.commit('addRoom', room)
                      //
                      room.addVcsMember(p)
                    }
                  })
                })

              }
            }
          },
          'closeRoom': (event, message) => {
            let roomName = message.roomName
            event.$store.dispatch('getRoom', roomName).then(room => {
              if (room) {
                room.dispose()
              }
            })
            event.$root.bus.$emit('closeVcs', roomName)
          },
          'startShareScreen': (event, message) => {
            //会议室是对的，进行创建屏幕共享内容
            event.$root.bus.$emit('startShareScreen', message)
          },
          'stopShareScreen': (event, message) => {
            event.$root.bus.$emit('stopShareScreen', message)
          },
          'broadcast':(event,message)=>{

          },
          'queryBroadcast':(event,message)=>{
            let names = message.name
            if (names) {
              event.$root.bus.$emit('broadcastNames', names)
            }
          }
        }
        let md = strategies[method]
        if (md) {
          return md(that, message)
        }
        return null
        //return strategies[method](that,message);
      }
    },
    destroyed() {
      this.cleanupOptimization()

      this.doRrefresh()
      window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e))
      window.removeEventListener('unload', e => this.unloadHandler(e))
    },
    computed: {
      active() {
        let menuId = this.$store.state.clickData.menuId
        if (menuId) {
          return menuId
        } else {
          return localRead('currentMenu')
        }
      },
      userId() {
        return this.$store.state.user.sys_user_id
      },
      userAccount() {
        return this.$store.state.user.userName
      }
    },
    watch: {
      cameras: {
        deep:true,
        handler(val, oldValue) {
          let store = {
            cameras: this.cameras,
          }
          this.splitScreenMonitor(1, 2, store)
        }
      },
      showAlarm: function () {
        if (this.showAlarm) {
          this.showAlarmVideo()
        } else {
          if (this.alarmOpenW !== '' && this.alarmOpenW !== null && this.alarmOpenW !== undefined) {
            if (this.alarmOpenW.name !== '') {
              this.alarmOpenW.close();
            } else {
              this.visibleChange(false);
            }
          } else {
            this.visibleChange(false);
          }
        }
      },
      refreshCount: {
        immediate: true,
        deep: true,
        handler(val) {
          if (val > 0) {
            setTimeout(() => {
              //let msg = '\'getStatus\':\'1\''
              //this.sendMsg({method: 'login', msg})
              this.sendMsg({method: 'getext'})
              this.refreshCount--
              if (this.refreshCount < 0) {
                this.refreshCount = 0
              }
            }, 1000)
          }
        }
      },

      '$store.state.clickData.videoModal': {
        deep: true,
        immediate: true,
        handler(val) {
          if (val) {
            this.cameras = this.$store.state.clickData.modalCameras
            //this.showAlarm = true
            if (this.alarmOpenW !== '' && this.alarmOpenW !== undefined && this.alarmOpenW !== null) {
              this.alarmOpenW.close()
            }
            this.alarmOpenW = null
            let that = this
            setTimeout(function () {
              that.alarmModal(val)
            })
            this.$store.commit('setVideoModal', false)
            this.$store.commit('setModalCameras', null)
          }
        }
      },
      '$store.state.websocket.heartCount': {
        deep: true,
        immediate: true,
        handler(val) {
          if (val >= 3) {
            if (this.$store.state.websocket.WS) {
              //let method = 'logout'
              //this.sendMsg({method})
              //this.closeWS()
            }
            //重新建立连接
            //this.createWebSocket()
          }
        }
      },
      '$store.state.app.local': {
        deep: true,
        immediate: true,
        handler(val, nval) {

          let that = this
          setTimeout(function () {
            let store = {
              local: that.$store.state.app.local,
              documentTitle: document.title,
            }
            that.splitScreenMonitor(val, nval, store)

            let txt = that.$store.state.app.txtLogo
            if (txt || !that.$store.state.app.isOpenLogo) {
            } else {
              txt = that.$t('document_title');
            }
            window.document.title = txt
          }, 100)

        }
      },

      '$store.state.cacheData.ports': {
        deep: true,
        immediate: true,
        handler(val, nval) {
          let store = {
            ports: this.$store.state.cacheData.ports,
          }
          this.splitScreenMonitor(val, nval, store)

        }
      },
      '$store.state.cacheData.httpsPorts': {
        deep: true,
        immediate: true,
        handler(val, nval) {
          let store = {
            httpsPorts: this.$store.state.cacheData.httpsPorts,
          }
          this.splitScreenMonitor(val, nval, store)

        }
      },
      '$store.state.token': {
        deep: true,
        immediate: true,
        handler(val, nval) {
          let store = {
            token: this.$store.state.token,
          }
          this.splitScreenMonitor(val, nval, store)

        }
      },
      '$store.state.clickData.hangExten': {
        deep: true,
        immediate: true,
        handler(val, nval) {
          let store = {
            hangExten: this.$store.state.clickData.hangExten,
          }
          this.splitScreenMonitor(val, nval, store)

        }
      },
      '$store.state.cacheData.alarmDevs': {
        deep: true,
        immediate: true,
        handler(val, nval) {
          let store = {
            alarmDevs: this.$store.state.cacheData.alarmDevs,
          }
          this.splitScreenMonitor(val, nval, store)

        }
      },
      '$store.state.clickData.hangup': {
        deep: true,
        immediate: true,
        handler(val, nval) {
          let store = {
            hangup: this.$store.state.clickData.hangup,
          }
          this.splitScreenMonitor(val, nval, store)

        }
      },
      '$store.state.clickData.mapGroupId': {
        deep: true,
        immediate: true,
        handler(val, nval) {
          let store = {
            mapGroupName: this.$store.state.clickData.mapGroupName,
            mapGroupId: this.$store.state.clickData.mapGroupId,
          }
          this.splitScreenMonitor(val, nval, store)

        }
      },
      '$store.state.clickData.clickMapLeft': {
        deep: true,
        immediate: true,
        handler(val, nval) {
          let store = {
            clickMapLeft: this.$store.state.clickData.clickMapLeft,
          }
          this.splitScreenMonitor(val, nval, store)

        }
      },

      '$store.state.cacheData.groups': {
        deep: true,
        immediate: true,
        handler(val, nval) {
          let store = {
            groups: this.$store.state.cacheData.groups,
          }
          this.splitScreenMonitor(val, nval, store)

        }
      },
      '$store.state.cacheData.rightStatus': {
        deep: true,
        immediate: true,
        handler(val, nval) {
          let store = {
            rightStatus: this.$store.state.cacheData.rightStatus,
          }
          this.splitScreenMonitor(val, nval, store)
        }
      },
      '$store.state.cacheData.leftStatus': {
        deep: true,
        immediate: true,
        handler(val, nval) {
          let store = {
            leftStatus: this.$store.state.cacheData.leftStatus,
          }
          this.splitScreenMonitor(val, nval, store)
        }
      },
      '$store.state.clickData.autoAccept': {
        deep: true,
        immediate: true,
        handler(val, nval) {
          let store = {
            autoAccept: this.$store.state.clickData.autoAccept,
          }
          this.splitScreenMonitor(val, nval, store)
        }
      },
      '$store.state.clickData.autoCall': {
        deep: true,
        immediate: true,
        handler(val, nval) {
          let store = {
            autoCall: this.$store.state.clickData.autoCall,
          }
          this.splitScreenMonitor(val, nval, store)
        }
      },
      '$store.state.clickData.mapDevice': {
        deep: true,
        immediate: true,
        handler(val, nval) {
          let store = {
            mapDevice: this.$store.state.clickData.mapDevice,
          }
          this.splitScreenMonitor(val, nval, store)
        }
      },
      '$store.state.user.SIPControl': {
        deep: true,
        immediate: true,
        handler(val, nval) {
          let store = {
            SIPControl: this.$store.state.user.SIPControl,
          }
          this.splitScreenMonitor(val, nval, store)
        }
      },
      '$store.state.clickData.status': {
        deep: true,
        immediate: true,
        handler(val, nval) {
          let store = {
            status: this.$store.state.clickData.status,
          }
          this.splitScreenMonitor(val, nval, store)
        }
      },
      '$store.state.clickData.ext': {
        deep: true,
        immediate: true,
        handler(val, nval) {
          let store = {
            ext: this.$store.state.clickData.ext,
          }
          this.splitScreenMonitor(val, nval, store)
        }
      },
      '$store.state.clickData.mapGroupName': {
        deep: true,
        immediate: true,
        handler(val, nval) {
          let store = {
            mapGroupName: this.$store.state.clickData.mapGroupName,
          }
          this.splitScreenMonitor(val, nval, store)
        }
      },
      '$store.state.cacheData.invateOutLines': {
        deep: true,
        immediate: true,
        handler(val, nval) {

          let store = {
            invateOutLines: this.$store.state.cacheData.invateOutLines,
          }
          this.splitScreenMonitor(val, nval, store)
        }
      },
      '$store.state.conferencejs.confno': {
        deep: true,
        immediate: true,
        handler(val, nval) {

          let store = {
            confno: this.$store.state.conferencejs.confno,
          }
          this.splitScreenMonitor(val, nval, store)
        }
      },
      '$store.state.cacheData.sysGeneral': {
        deep: true,
        immediate: true,
        handler(val, nval) {

          let store = {
            sysGeneral: this.$store.state.cacheData.sysGeneral,
          }
          this.splitScreenMonitor(val, nval, store)
        }
      },
      '$store.state.user.right': {
        deep: true,
        immediate: true,
        handler(val, nval) {

          let store = {
            right: this.$store.state.user.right,
          }
          this.splitScreenMonitor(val, nval, store)
        }
      },
      '$store.state.user.left': {
        deep: true,
        immediate: true,
        handler(val, nval) {

          let store = {
            left: this.$store.state.user.left,
          }
          this.splitScreenMonitor(val, nval, store)
        }
      },
      '$store.state.user.control': {
        deep: true,
        immediate: true,
        handler(val, nval) {

          let store = {
            control: this.$store.state.user.control,
          }
          this.splitScreenMonitor(val, nval, store)
        }
      },
      '$store.state.clickData.editMap': {
        deep: true,
        immediate: true,
        handler(val, nval) {

          let store = {
            editMap: this.$store.state.clickData.editMap,
          }
          this.splitScreenMonitor(val, nval, store)
        }
      },
      '$store.state.clickData.mapType': {
        deep: true,
        immediate: true,
        handler(val, nval) {

          let store = {
            mapType: this.$store.state.clickData.mapType,
          }
          this.splitScreenMonitor(val, nval, store)
        }
      },
      '$store.state.clickData.cameraGroupName': {
        deep: true,
        immediate: true,
        handler(val, nval) {

          let store = {
            cameraGroupName: this.$store.state.clickData.cameraGroupName,
          }
          this.splitScreenMonitor(val, nval, store)
        }
      },
      '$store.state.app.sysWidth': {
        deep: true,
        immediate: true,
        handler(val, nval) {

          let store = {
            sysWidth: this.$store.state.app.sysWidth,
          }
          this.splitScreenMonitor(val, nval, store)
        }
      },
      '$store.state.app.sysHeight': {
        deep: true,
        immediate: true,
        handler(val, nval) {

          let store = {
            sysHeight: this.$store.state.app.sysHeight,
          }
          this.splitScreenMonitor(val, nval, store)
        }
      },
      '$store.state.cacheData.noBroad': {
        deep: true,
        immediate: true,
        handler(val, nval) {

          let store = {
            noBroad: this.$store.state.cacheData.noBroad,
          }
          this.splitScreenMonitor(val, nval, store)
        }
      },
      '$store.state.cacheData.devices': {
        deep: true,
        immediate: true,
        handler(val, nval) {
          let store = {
            devices: this.$store.state.cacheData.devices,
          }
          this.splitScreenMonitor(val, '1', store)
        }
      },
      '$store.state.user.userId': {
        deep: true,
        immediate: true,
        handler(val, nval) {

          let store = {
            userId: this.$store.state.user.userId,
          }
          this.splitScreenMonitor(val, nval, store)
        }
      },
      '$store.state.user.sys_user_id': {
        deep: true,
        immediate: true,
        handler(val, nval) {

          let store = {
            sys_user_id: this.$store.state.user.sys_user_id,
          }
          this.splitScreenMonitor(val, nval, store)
        }
      },
      '$store.state.user.userName': {
        deep: true,
        immediate: true,
        handler(val, nval) {

          let store = {
            userName: this.$store.state.user.userName,
          }
          this.splitScreenMonitor(val, nval, store)
        }
      },
      '$store.state.app.theme': {
        deep: true,
        immediate: true,
        handler(val, nval) {
          let store = {
            theme: this.$store.state.app.theme,
          }
          this.splitScreenMonitor(val, nval, store)
        }
      },
      '$route': {
        immediate: true,
        deep: true,
        handler(to, fm) {
          if (to.params.fromLogin) {
            this.turnPage = true
          }
          if (to.params.show) {
            this.isLoad = true
          }
          this.currRouteName = to.name
          this.currRoutePath = to.path
          window.dispatchEvent(new Event('resize'))
        }
      },
      '$store.state.chatChannel': {
        deep: true,
        handler(val) {
          let store = {
            chatChannel: val,
          }
          val.storeType = 1
          if (this.yuneasyStore === '' || this.yuneasyStore === undefined) {
            this.yuneasyStore = new BroadcastChannel('yuneasyStore')
          }
          this.yuneasyStore.postMessage(store)
        }
      }
    },
    mounted() {
      window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
      window.addEventListener('unload', e => this.unloadHandler(e))
      window.addEventListener('resize', () => {
        this.resize = true
      })
      //创建视频会议系统websocket
      //this.connectVCS()
      //创建多媒体消息websocket
      log_.log.sendFn(this.sendMsg)
      let that = this
      window.openSelfResult = function () {
        that.showSelfResult = true
      }
      window.onresize = () => {//记录页面变化
        return (() => {
          that.$store.commit('setSysHeight', document.body.clientHeight)
          that.$store.commit('setSysWidth', document.body.clientWidth)
        })()
      }
      window.toControlData = function () {
        if (!that.$store.state.user.systemRole) {
          that.$Message.warning(that.$t('system_role'))
          return
        }
        that.toControl('/system-Tools/data-cleaning')
      }
      window.toControlHAStatus = function () {
        if (!that.$store.state.user.systemRole) {
          that.$Message.warning(that.$t('system_role'))
          return
        }
        that.toControl('/system-manage/ha-manage')
      }
      window.toCall = function (callPhone, type, monitorType) {
        that.$store.commit('setIsOtherCall', '1')
        that.isFromMonitor = ''
        let control = that.$store.state.user.control
        let controlStatus
        let controlPhone;
        if ("1" === control+'') {
          controlStatus = that.$store.state.cacheData.leftStatus
          controlPhone = that.$store.state.user.left
        } else {
          controlPhone = that.$store.state.user.right
          controlStatus = that.$store.state.cacheData.rightStatus
        }
        if (controlStatus !== 'Idle') {
          return
        }
        if (type === 'auto') {
          type = that.callType
          if ('audio' === type && that.myWebRtc) {
            that.myWebRtc.JsSip_VoiceCall(callPhone, false)
            log_.log.sendCall(controlPhone, callPhone)
          } else if ('video' === type && that.myWebRtc) {
            that.myWebRtc.JsSip_VoiceCall(callPhone, true)
            log_.log.sendCall(controlPhone, callPhone)
          }
          return
        }
        if (type === 'voice') {
          if (that.myWebRtc) {
            that.myWebRtc.JsSip_VoiceCall(callPhone, false, 'voice')
            log_.log.sendCall(controlPhone, callPhone)
          }
          return
        }
        if (type === 'noVoice') {
          if (that.myWebRtc) {
            that.myWebRtc.JsSip_VoiceCall(callPhone, true, 'noVoice')
            log_.log.sendCall(controlPhone, callPhone)
            that.rejectExten = callPhone
          }
          return
        }
        if (monitorType) {
          that.isFromMonitor = monitorType
        }
        that.callNumber = callPhone
        let showExt = that.$store.state.cacheData.devices ? that.$store.state.cacheData.devices[callPhone] : null;
        if (!showExt) {
          that.softInfoTwo = that.$t('device_station') + ' : ' + that.$t('UnKnow') + ' , ' + that.$t('device_name') + ' : ' + callPhone
        } else {
          that.softInfoTwo = that.$t('device_station') + ' : ' + showExt.deptname + ' , ' + that.$t('device_name') + ' : ' + showExt.employeename
        }
        that.showSoftWebrtc = true
      }
      window.showCamera = function (exten) {
        let userName = that.$store.state.user.userName
        let cameraIds = ''
        let type = '1'
        that.videoExten = exten
        that.showVideoList.push(exten)
        if (!that.timeOutLife) {
          that.timeOutLife = setTimeout(async function () {
            //定时器结束后，将数据拷贝过来，然后将数据和定时器初始化。
            let newList = JSON.parse(JSON.stringify(that.showVideoList))
            that.showVideoList = []
            that.timeOutLife = null
            //从尾到头去遍历，直到找到支持联动的摄像头。
            /*for (let i = newList.length-1; i >= 0; i--) {
            let flag = await that.getVideoPop(newList[i], cameraIds, type, userName,"");
            //跳出for循环。
            if(flag){
              break;
            }
          }*/
            if (newList.length > 0) {
              that.getVideoPop(newList[0], cameraIds, type, userName, '')
            }
          }, 1000)
        }
      }
      window.showCameraById = (id) => {
        that.showCameraPop(id)
      }
      this.$root.bus.$on('closeVcs', roomName => {
        if (this.inviteInfo.roomName && this.inviteInfo.roomName === roomName) {
          this.showVcsInvite = false
        }
      })
      //绑定接听队列电话的方法
      this.$root.bus.$on('answerqueue', info => {
        //获取当前webrtc 话机的状态，如果是通话中，不允许接听

        if (!this.register) {
          return this.$Message.warning(this.$t('queue_answer_error'));
        }
        /*let leftStatus = that.$store.state.cacheData.leftStatus
      if (leftStatus !== 'Idle' && leftStatus !== 'Ringing') {
        return
      }*/
        let control = this.$store.state.user.control
        if (info.called && (info.called == this.$store.state.user.left || info.called == this.$store.state.user.right)) {
          let controlStatus = null
          if (1 == control) {
            controlStatus = this.$store.state.cacheData.leftStatus
          } else {
            controlStatus = that.$store.state.cacheData.rightStatus
          }
          if (controlStatus == 'Idle') {
            this.$Message.warning(this.$t('queue_answer_error'));
            return
          }
          if (controlStatus == 'Ring') {
            if (1 == control) {
              if (this.register) {
                this.$Message.warning(this.$t('queue_answer_error'))
                //this.myWebRtc.VoiceAnswer(false);
                return;
              }
              console.log('Left Control Ring,need Handle Accept!')
            }
            if (2 == control) {
              console.log('Right Control Ring,need Handle Accept!')
              return;
            }
          }
        }
        let queueid = info.queueId
        let queuename = info.queueName
        let method = 'queueanswer'
        let ext = info.exten
        let msg = '\'queuename\':\'' + queuename + '\',\'queueid\':\'' + queueid + '\''
        that.sendMsg({method, ext, msg})
        //移除队列中的号码
        /*info.ExtenInfo = ext
        let deviceArr2 = deviceQueueArrNoExtens(this.$store.state.cacheData.queueList, info)
        this.$store.commit('setQueueList', deviceArr2)*/
      })

      this.$root.bus.$on('lookNoAnswer', (info) => {
        that.callNo = true
        that.callNoExten = info.caller
        that.callNoId = info.id
        let exInfo = that.$store.state.cacheData.devices ? that.$store.state.cacheData.devices[info.caller] : null;
        let str = ''
        if (exInfo) {
          str = that.$t('device_station') + '：' + exInfo.deptname
        }
        that.callInfo = that.$t('unanswer_time') + '：' + info.time + ' ' + that.$t('exten') + '：' + info.caller + ' ' + str
      })
      this.$root.bus.$on('callType', res => {
        that.answerType(res)
      })
      this.$root.bus.$on('autoAnswer', res => {
        that.answer(res)
      })
      this.$root.bus.$on('theme', res => {
        const root = document.documentElement
        //TODO 后期有主题需求时，进行解除
        res = 'blue';
        switch (res) {
          case 'black':
            root.style.setProperty('--scroll-color', 'whitesmoke')
            root.style.setProperty('--thumb-color', 'dimgrey')
            root.style.setProperty('--primary-color', 'white')
            root.style.setProperty('--backgroud-img', 'none')
            root.style.setProperty('--search-font', 'white')

            root.style.setProperty('--backgroud-color', 'dimgrey')
            this.replaceClassName('black')
            break
          case 'blue':
            root.style.setProperty('--backgroud-color', 'unset')
            root.style.setProperty('--backgroud-img', 'url("../../assets/images/new-back.png") !important')
            root.style.setProperty('--scroll-color', 'rgb(16,36,47)')
            root.style.setProperty('--thumb-color', '#00d5ff')
            root.style.setProperty('--primary-color', '#00d5ff')
            root.style.setProperty('--button-little-color', '#00d4ff')
            root.style.setProperty('--search-font', '#03B3D6')
            this.replaceClassName('blue')
            break
          case 'white':
            root.style.setProperty('--scroll-color', 'whitesmoke')
            root.style.setProperty('--thumb-color', '#2d8cf0')
            root.style.setProperty('--primary-color', 'black')
            root.style.setProperty('--button-little-color', '#2d8cf0')
            root.style.setProperty('--backgroud-color', 'white')
            root.style.setProperty('--search-font', 'black')
            this.replaceClassName('white')
            break
          default:
            root.style.setProperty('--scroll-color', 'whitesmoke')
            root.style.setProperty('--thumb-color', 'dimgrey')
            root.style.setProperty('--primary-color', '#353535')
            this.replaceClassName('black')
        }
      })

      this.$root.bus.$on('webRtcStatus', res => {
        if (that.myWebRtc) {
          that.myWebRtc.setStatus(res)
        }
      })
      this.$root.bus.$on('logout', res => {
        if (that.register) {
          that.myWebRtc.JsSip_clearRegested() //取消注册
        }
      })
      this.$once('hook:beforeDestroy', () => {
        this.$root.bus.$off(['closeVcs', 'answerqueue', 'lookNoAnswer', 'callType', 'autoAnswer', 'theme', 'webRtcStatus', 'logout'])
        window.openSelfResult = null
        window.onresize = null
        window.toControlData = null
        window.toControlHAStatus = null
        window.toCall = null
        window.showCamera = null
        window.showCameraById = null
      })

    },
  }
</script>
<style scoped>
  #showCall /deep/ .ivu-modal-body{
    position: relative !important;
  }
</style>




// WEBPACK FOOTER //
// src/components/main/main.vue